var Kn = Object.defineProperty;
var Ln = (e, t, r) => t in e ? Kn(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var y = (e, t, r) => (Ln(e, typeof t != "symbol" ? t + "" : t, r), r);
const Bn = "https://mainnet.radixdlt.com".replace(/\/+$/, "");
class _e {
  constructor(t = {}) {
    this.configuration = t;
  }
  set config(t) {
    this.configuration = t;
  }
  get basePath() {
    return this.configuration.basePath != null ? this.configuration.basePath : Bn;
  }
  get fetchApi() {
    return this.configuration.fetchApi;
  }
  get middleware() {
    return this.configuration.middleware || [];
  }
  get queryParamsStringify() {
    return this.configuration.queryParamsStringify || me;
  }
  get username() {
    return this.configuration.username;
  }
  get password() {
    return this.configuration.password;
  }
  get apiKey() {
    const t = this.configuration.apiKey;
    if (t)
      return typeof t == "function" ? t : () => t;
  }
  get accessToken() {
    const t = this.configuration.accessToken;
    if (t)
      return typeof t == "function" ? t : async () => t;
  }
  get headers() {
    return this.configuration.headers;
  }
  get credentials() {
    return this.configuration.credentials;
  }
}
const Gn = new _e();
class w {
  constructor(t = Gn) {
    y(this, "middleware");
    y(this, "fetchApi", async (t, r) => {
      let i = { url: t, init: r };
      for (const o of this.middleware)
        o.pre && (i = await o.pre({
          fetch: this.fetchApi,
          ...i
        }) || i);
      let a;
      try {
        a = await (this.configuration.fetchApi || fetch)(i.url, i.init);
      } catch (o) {
        for (const u of this.middleware)
          u.onError && (a = await u.onError({
            fetch: this.fetchApi,
            url: i.url,
            init: i.init,
            error: o,
            response: a ? a.clone() : void 0
          }) || a);
        if (a === void 0)
          throw o;
      }
      for (const o of this.middleware)
        o.post && (a = await o.post({
          fetch: this.fetchApi,
          url: i.url,
          init: i.init,
          response: a.clone()
        }) || a);
      return a;
    });
    this.configuration = t, this.middleware = t.middleware;
  }
  withMiddleware(...t) {
    const r = this.clone();
    return r.middleware = r.middleware.concat(...t), r;
  }
  withPreMiddleware(...t) {
    const r = t.map((i) => ({ pre: i }));
    return this.withMiddleware(...r);
  }
  withPostMiddleware(...t) {
    const r = t.map((i) => ({ post: i }));
    return this.withMiddleware(...r);
  }
  async request(t, r) {
    const { url: i, init: a } = await this.createFetchParams(t, r), o = await this.fetchApi(i, a);
    if (o && o.status >= 200 && o.status < 300)
      return o;
    throw await G.from(o);
  }
  async createFetchParams(t, r) {
    let i = this.configuration.basePath + t.path;
    t.query !== void 0 && Object.keys(t.query).length !== 0 && (i += "?" + this.configuration.queryParamsStringify(t.query));
    const a = Object.assign({}, this.configuration.headers, t.headers);
    Object.keys(a).forEach((h) => a[h] === void 0 ? delete a[h] : {});
    const o = typeof r == "function" ? r : async () => r, u = {
      method: t.method,
      headers: a,
      body: t.body,
      credentials: this.configuration.credentials
    }, l = {
      ...u,
      ...await o({
        init: u,
        context: t
      })
    }, O = {
      ...l,
      body: $n(l.body) || l.body instanceof URLSearchParams || Hn(l.body) ? l.body : JSON.stringify(l.body)
    };
    return { url: i, init: O };
  }
  clone() {
    const t = this.constructor, r = new t(this.configuration);
    return r.middleware = this.middleware.slice(), r;
  }
}
function Hn(e) {
  return typeof Blob < "u" && e instanceof Blob;
}
function $n(e) {
  return typeof FormData < "u" && e instanceof FormData;
}
class G extends Error {
  constructor(r, i, a) {
    super(a ? JSON.stringify(a) : "Unknown error occurred");
    y(this, "name", "ResponseError");
    this.fetchResponse = r, this.status = i, this.errorResponse = a;
  }
  static async from(r) {
    const i = r.status;
    try {
      const a = await r.json();
      return new G(r, i, a);
    } catch {
      return new G(r, i, void 0);
    }
  }
}
class m extends Error {
  constructor(r, i) {
    super(i);
    y(this, "name", "RequiredError");
    this.field = r;
  }
}
const Yc = {
  csv: ",",
  ssv: " ",
  tsv: "	",
  pipes: "|"
};
function n(e, t) {
  const r = e[t];
  return r != null;
}
function me(e, t = "") {
  return Object.keys(e).map((r) => ye(r, e[r], t)).filter((r) => r.length > 0).join("&");
}
function ye(e, t, r = "") {
  const i = r + (r.length ? `[${e}]` : e);
  if (t instanceof Array) {
    const a = t.map((o) => encodeURIComponent(String(o))).join(`&${encodeURIComponent(i)}=`);
    return `${encodeURIComponent(i)}=${a}`;
  }
  if (t instanceof Set) {
    const a = Array.from(t);
    return ye(e, a, r);
  }
  return t instanceof Date ? `${encodeURIComponent(i)}=${encodeURIComponent(t.toISOString())}` : t instanceof Object ? me(t, i) : `${encodeURIComponent(i)}=${encodeURIComponent(String(t))}`;
}
function jc(e, t) {
  return Object.keys(e).reduce(
    (r, i) => ({ ...r, [i]: t(e[i]) }),
    {}
  );
}
function ed(e) {
  for (const t of e)
    if (t.contentType === "multipart/form-data")
      return !0;
  return !1;
}
class s {
  constructor(t, r = (i) => i) {
    this.raw = t, this.transformer = r;
  }
  async value() {
    return this.transformer(await this.raw.json());
  }
}
class td {
  constructor(t) {
    this.raw = t;
  }
  async value() {
  }
}
class nd {
  constructor(t) {
    this.raw = t;
  }
  async value() {
    return await this.raw.blob();
  }
}
class rd {
  constructor(t) {
    this.raw = t;
  }
  async value() {
    return await this.raw.text();
  }
}
function id(e) {
  return !0;
}
function c(e) {
  return Wn(e);
}
function Wn(e, t) {
  return e == null ? e : {
    state_version: n(e, "state_version") ? e.state_version : void 0,
    timestamp: n(e, "timestamp") ? e.timestamp === null ? null : new Date(e.timestamp) : void 0,
    epoch: n(e, "epoch") ? e.epoch : void 0,
    round: n(e, "round") ? e.round : void 0
  };
}
function d(e) {
  if (e !== void 0)
    return e === null ? null : {
      state_version: e.state_version,
      timestamp: e.timestamp === void 0 ? void 0 : e.timestamp === null ? null : e.timestamp.toISOString(),
      epoch: e.epoch,
      round: e.round
    };
}
function ad(e) {
  return !0;
}
function od(e) {
  return zn(e);
}
function zn(e, t) {
  return e == null ? e : {
    at_ledger_state: n(e, "at_ledger_state") ? c(e.at_ledger_state) : void 0
  };
}
function ud(e) {
  if (e !== void 0)
    return e === null ? null : {
      at_ledger_state: d(e.at_ledger_state)
    };
}
function ld(e) {
  let t = !0;
  return t = t && "entity_address" in e, t = t && "resource_address" in e, t = t && "balance_change" in e, t;
}
function Xn(e) {
  return Zn(e);
}
function Zn(e, t) {
  return e == null ? e : {
    entity_address: e.entity_address,
    resource_address: e.resource_address,
    balance_change: e.balance_change
  };
}
function Qn(e) {
  if (e !== void 0)
    return e === null ? null : {
      entity_address: e.entity_address,
      resource_address: e.resource_address,
      balance_change: e.balance_change
    };
}
const sd = {
  FeePayment: "FeePayment",
  FeeDistributed: "FeeDistributed",
  TipDistributed: "TipDistributed",
  RoyaltyDistributed: "RoyaltyDistributed"
};
function Yn(e) {
  return jn(e);
}
function jn(e, t) {
  return e;
}
function cd(e) {
  return e;
}
function dd(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "entity_address" in e, t = t && "resource_address" in e, t = t && "balance_change" in e, t;
}
function er(e) {
  return tr(e);
}
function tr(e, t) {
  return e == null ? e : {
    type: Yn(e.type),
    entity_address: e.entity_address,
    resource_address: e.resource_address,
    balance_change: e.balance_change
  };
}
function nr(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      entity_address: e.entity_address,
      resource_address: e.resource_address,
      balance_change: e.balance_change
    };
}
function fd(e) {
  let t = !0;
  return t = t && "entity_address" in e, t = t && "resource_address" in e, t = t && "added" in e, t = t && "removed" in e, t;
}
function rr(e) {
  return ir(e);
}
function ir(e, t) {
  return e == null ? e : {
    entity_address: e.entity_address,
    resource_address: e.resource_address,
    added: e.added,
    removed: e.removed
  };
}
function ar(e) {
  if (e !== void 0)
    return e === null ? null : {
      entity_address: e.entity_address,
      resource_address: e.resource_address,
      added: e.added,
      removed: e.removed
    };
}
function _d(e) {
  let t = !0;
  return t = t && "fungible_fee_balance_changes" in e, t = t && "fungible_balance_changes" in e, t = t && "non_fungible_balance_changes" in e, t;
}
function or(e) {
  return ur(e);
}
function ur(e, t) {
  return e == null ? e : {
    fungible_fee_balance_changes: e.fungible_fee_balance_changes.map(er),
    fungible_balance_changes: e.fungible_balance_changes.map(Xn),
    non_fungible_balance_changes: e.non_fungible_balance_changes.map(rr)
  };
}
function lr(e) {
  if (e !== void 0)
    return e === null ? null : {
      fungible_fee_balance_changes: e.fungible_fee_balance_changes.map(nr),
      fungible_balance_changes: e.fungible_balance_changes.map(Qn),
      non_fungible_balance_changes: e.non_fungible_balance_changes.map(ar)
    };
}
const md = {
  Bool: "Bool",
  I8: "I8",
  I16: "I16",
  I32: "I32",
  I64: "I64",
  I128: "I128",
  U8: "U8",
  U16: "U16",
  U32: "U32",
  U64: "U64",
  U128: "U128",
  String: "String",
  Enum: "Enum",
  Array: "Array",
  Bytes: "Bytes",
  Map: "Map",
  Tuple: "Tuple",
  Reference: "Reference",
  Own: "Own",
  Decimal: "Decimal",
  PreciseDecimal: "PreciseDecimal",
  NonFungibleLocalId: "NonFungibleLocalId"
};
function b(e) {
  return sr(e);
}
function sr(e, t) {
  return e;
}
function yd(e) {
  return e;
}
const pd = {
  Array: "Array"
};
function gd(e) {
  let t = !0;
  return t = t && "kind" in e, t = t && "element_kind" in e, t = t && "elements" in e, t;
}
function Sd(e) {
  return pe(e);
}
function pe(e, t) {
  return e == null ? e : {
    kind: e.kind,
    type_name: n(e, "type_name") ? e.type_name : void 0,
    field_name: n(e, "field_name") ? e.field_name : void 0,
    element_kind: b(e.element_kind),
    element_type_name: n(e, "element_type_name") ? e.element_type_name : void 0,
    elements: e.elements.map(p)
  };
}
function cr(e) {
  if (e !== void 0)
    return e === null ? null : {
      kind: e.kind,
      type_name: e.type_name,
      field_name: e.field_name,
      element_kind: e.element_kind,
      element_type_name: e.element_type_name,
      elements: e.elements.map(g)
    };
}
const Od = {
  Bool: "Bool"
};
function bd(e) {
  let t = !0;
  return t = t && "kind" in e, t = t && "value" in e, t;
}
function Nd(e) {
  return ge(e);
}
function ge(e, t) {
  return e == null ? e : {
    kind: e.kind,
    type_name: n(e, "type_name") ? e.type_name : void 0,
    field_name: n(e, "field_name") ? e.field_name : void 0,
    value: e.value
  };
}
function dr(e) {
  if (e !== void 0)
    return e === null ? null : {
      kind: e.kind,
      type_name: e.type_name,
      field_name: e.field_name,
      value: e.value
    };
}
const Fd = {
  Bytes: "Bytes"
};
function hd(e) {
  let t = !0;
  return t = t && "kind" in e, t = t && "element_kind" in e, t = t && "hex" in e, t;
}
function Ad(e) {
  return Se(e);
}
function Se(e, t) {
  return e == null ? e : {
    kind: e.kind,
    type_name: n(e, "type_name") ? e.type_name : void 0,
    field_name: n(e, "field_name") ? e.field_name : void 0,
    element_kind: b(e.element_kind),
    element_type_name: n(e, "element_type_name") ? e.element_type_name : void 0,
    hex: e.hex
  };
}
function fr(e) {
  if (e !== void 0)
    return e === null ? null : {
      kind: e.kind,
      type_name: e.type_name,
      field_name: e.field_name,
      element_kind: e.element_kind,
      element_type_name: e.element_type_name,
      hex: e.hex
    };
}
const Id = {
  Decimal: "Decimal"
};
function Td(e) {
  let t = !0;
  return t = t && "kind" in e, t = t && "value" in e, t;
}
function Jd(e) {
  return Oe(e);
}
function Oe(e, t) {
  return e == null ? e : {
    kind: e.kind,
    type_name: n(e, "type_name") ? e.type_name : void 0,
    field_name: n(e, "field_name") ? e.field_name : void 0,
    value: e.value
  };
}
function _r(e) {
  if (e !== void 0)
    return e === null ? null : {
      kind: e.kind,
      type_name: e.type_name,
      field_name: e.field_name,
      value: e.value
    };
}
const vd = {
  Enum: "Enum"
};
function Vd(e) {
  let t = !0;
  return t = t && "kind" in e, t = t && "variant_id" in e, t = t && "fields" in e, t;
}
function Rd(e) {
  return be(e);
}
function be(e, t) {
  return e == null ? e : {
    kind: e.kind,
    type_name: n(e, "type_name") ? e.type_name : void 0,
    field_name: n(e, "field_name") ? e.field_name : void 0,
    variant_id: e.variant_id,
    variant_name: n(e, "variant_name") ? e.variant_name : void 0,
    fields: e.fields.map(p)
  };
}
function mr(e) {
  if (e !== void 0)
    return e === null ? null : {
      kind: e.kind,
      type_name: e.type_name,
      field_name: e.field_name,
      variant_id: e.variant_id,
      variant_name: e.variant_name,
      fields: e.fields.map(g)
    };
}
const kd = {
  I128: "I128"
};
function Ed(e) {
  let t = !0;
  return t = t && "kind" in e, t = t && "value" in e, t;
}
function Dd(e) {
  return Ne(e);
}
function Ne(e, t) {
  return e == null ? e : {
    kind: e.kind,
    type_name: n(e, "type_name") ? e.type_name : void 0,
    field_name: n(e, "field_name") ? e.field_name : void 0,
    value: e.value
  };
}
function yr(e) {
  if (e !== void 0)
    return e === null ? null : {
      kind: e.kind,
      type_name: e.type_name,
      field_name: e.field_name,
      value: e.value
    };
}
const Pd = {
  I16: "I16"
};
function wd(e) {
  let t = !0;
  return t = t && "kind" in e, t = t && "value" in e, t;
}
function Md(e) {
  return Fe(e);
}
function Fe(e, t) {
  return e == null ? e : {
    kind: e.kind,
    type_name: n(e, "type_name") ? e.type_name : void 0,
    field_name: n(e, "field_name") ? e.field_name : void 0,
    value: e.value
  };
}
function pr(e) {
  if (e !== void 0)
    return e === null ? null : {
      kind: e.kind,
      type_name: e.type_name,
      field_name: e.field_name,
      value: e.value
    };
}
const xd = {
  I32: "I32"
};
function Cd(e) {
  let t = !0;
  return t = t && "kind" in e, t = t && "value" in e, t;
}
function qd(e) {
  return he(e);
}
function he(e, t) {
  return e == null ? e : {
    kind: e.kind,
    type_name: n(e, "type_name") ? e.type_name : void 0,
    field_name: n(e, "field_name") ? e.field_name : void 0,
    value: e.value
  };
}
function gr(e) {
  if (e !== void 0)
    return e === null ? null : {
      kind: e.kind,
      type_name: e.type_name,
      field_name: e.field_name,
      value: e.value
    };
}
const Ud = {
  I64: "I64"
};
function Kd(e) {
  let t = !0;
  return t = t && "kind" in e, t = t && "value" in e, t;
}
function Ld(e) {
  return Ae(e);
}
function Ae(e, t) {
  return e == null ? e : {
    kind: e.kind,
    type_name: n(e, "type_name") ? e.type_name : void 0,
    field_name: n(e, "field_name") ? e.field_name : void 0,
    value: e.value
  };
}
function Sr(e) {
  if (e !== void 0)
    return e === null ? null : {
      kind: e.kind,
      type_name: e.type_name,
      field_name: e.field_name,
      value: e.value
    };
}
const Bd = {
  I8: "I8"
};
function Gd(e) {
  let t = !0;
  return t = t && "kind" in e, t = t && "value" in e, t;
}
function Hd(e) {
  return Ie(e);
}
function Ie(e, t) {
  return e == null ? e : {
    kind: e.kind,
    type_name: n(e, "type_name") ? e.type_name : void 0,
    field_name: n(e, "field_name") ? e.field_name : void 0,
    value: e.value
  };
}
function Or(e) {
  if (e !== void 0)
    return e === null ? null : {
      kind: e.kind,
      type_name: e.type_name,
      field_name: e.field_name,
      value: e.value
    };
}
function $d(e) {
  let t = !0;
  return t = t && "key" in e, t = t && "value" in e, t;
}
function Te(e) {
  return br(e);
}
function br(e, t) {
  return e == null ? e : {
    key: p(e.key),
    value: p(e.value)
  };
}
function Je(e) {
  if (e !== void 0)
    return e === null ? null : {
      key: g(e.key),
      value: g(e.value)
    };
}
const Wd = {
  Map: "Map"
};
function zd(e) {
  let t = !0;
  return t = t && "kind" in e, t = t && "key_kind" in e, t = t && "value_kind" in e, t = t && "entries" in e, t;
}
function Xd(e) {
  return ve(e);
}
function ve(e, t) {
  return e == null ? e : {
    kind: e.kind,
    type_name: n(e, "type_name") ? e.type_name : void 0,
    field_name: n(e, "field_name") ? e.field_name : void 0,
    key_kind: b(e.key_kind),
    key_type_name: n(e, "key_type_name") ? e.key_type_name : void 0,
    value_kind: b(e.value_kind),
    value_type_name: n(e, "value_type_name") ? e.value_type_name : void 0,
    entries: e.entries.map(Te)
  };
}
function Nr(e) {
  if (e !== void 0)
    return e === null ? null : {
      kind: e.kind,
      type_name: e.type_name,
      field_name: e.field_name,
      key_kind: e.key_kind,
      key_type_name: e.key_type_name,
      value_kind: e.value_kind,
      value_type_name: e.value_type_name,
      entries: e.entries.map(Je)
    };
}
const Zd = {
  NonFungibleLocalId: "NonFungibleLocalId"
};
function Qd(e) {
  let t = !0;
  return t = t && "kind" in e, t = t && "value" in e, t;
}
function Yd(e) {
  return Ve(e);
}
function Ve(e, t) {
  return e == null ? e : {
    kind: e.kind,
    type_name: n(e, "type_name") ? e.type_name : void 0,
    field_name: n(e, "field_name") ? e.field_name : void 0,
    value: e.value
  };
}
function Fr(e) {
  if (e !== void 0)
    return e === null ? null : {
      kind: e.kind,
      type_name: e.type_name,
      field_name: e.field_name,
      value: e.value
    };
}
const jd = {
  Own: "Own"
};
function ef(e) {
  let t = !0;
  return t = t && "kind" in e, t = t && "value" in e, t;
}
function tf(e) {
  return Re(e);
}
function Re(e, t) {
  return e == null ? e : {
    kind: e.kind,
    type_name: n(e, "type_name") ? e.type_name : void 0,
    field_name: n(e, "field_name") ? e.field_name : void 0,
    value: e.value
  };
}
function hr(e) {
  if (e !== void 0)
    return e === null ? null : {
      kind: e.kind,
      type_name: e.type_name,
      field_name: e.field_name,
      value: e.value
    };
}
const nf = {
  PreciseDecimal: "PreciseDecimal"
};
function rf(e) {
  let t = !0;
  return t = t && "kind" in e, t = t && "value" in e, t;
}
function af(e) {
  return ke(e);
}
function ke(e, t) {
  return e == null ? e : {
    kind: e.kind,
    type_name: n(e, "type_name") ? e.type_name : void 0,
    field_name: n(e, "field_name") ? e.field_name : void 0,
    value: e.value
  };
}
function Ar(e) {
  if (e !== void 0)
    return e === null ? null : {
      kind: e.kind,
      type_name: e.type_name,
      field_name: e.field_name,
      value: e.value
    };
}
const of = {
  Reference: "Reference"
};
function uf(e) {
  let t = !0;
  return t = t && "kind" in e, t = t && "value" in e, t;
}
function lf(e) {
  return Ee(e);
}
function Ee(e, t) {
  return e == null ? e : {
    kind: e.kind,
    type_name: n(e, "type_name") ? e.type_name : void 0,
    field_name: n(e, "field_name") ? e.field_name : void 0,
    value: e.value
  };
}
function Ir(e) {
  if (e !== void 0)
    return e === null ? null : {
      kind: e.kind,
      type_name: e.type_name,
      field_name: e.field_name,
      value: e.value
    };
}
const sf = {
  String: "String"
};
function cf(e) {
  let t = !0;
  return t = t && "kind" in e, t = t && "value" in e, t;
}
function df(e) {
  return De(e);
}
function De(e, t) {
  return e == null ? e : {
    kind: e.kind,
    type_name: n(e, "type_name") ? e.type_name : void 0,
    field_name: n(e, "field_name") ? e.field_name : void 0,
    value: e.value
  };
}
function Tr(e) {
  if (e !== void 0)
    return e === null ? null : {
      kind: e.kind,
      type_name: e.type_name,
      field_name: e.field_name,
      value: e.value
    };
}
const ff = {
  Tuple: "Tuple"
};
function _f(e) {
  let t = !0;
  return t = t && "kind" in e, t = t && "fields" in e, t;
}
function mf(e) {
  return Pe(e);
}
function Pe(e, t) {
  return e == null ? e : {
    kind: e.kind,
    type_name: n(e, "type_name") ? e.type_name : void 0,
    field_name: n(e, "field_name") ? e.field_name : void 0,
    fields: e.fields.map(p)
  };
}
function Jr(e) {
  if (e !== void 0)
    return e === null ? null : {
      kind: e.kind,
      type_name: e.type_name,
      field_name: e.field_name,
      fields: e.fields.map(g)
    };
}
const yf = {
  U128: "U128"
};
function pf(e) {
  let t = !0;
  return t = t && "kind" in e, t = t && "value" in e, t;
}
function gf(e) {
  return we(e);
}
function we(e, t) {
  return e == null ? e : {
    kind: e.kind,
    type_name: n(e, "type_name") ? e.type_name : void 0,
    field_name: n(e, "field_name") ? e.field_name : void 0,
    value: e.value
  };
}
function vr(e) {
  if (e !== void 0)
    return e === null ? null : {
      kind: e.kind,
      type_name: e.type_name,
      field_name: e.field_name,
      value: e.value
    };
}
const Sf = {
  U16: "U16"
};
function Of(e) {
  let t = !0;
  return t = t && "kind" in e, t = t && "value" in e, t;
}
function bf(e) {
  return Me(e);
}
function Me(e, t) {
  return e == null ? e : {
    kind: e.kind,
    type_name: n(e, "type_name") ? e.type_name : void 0,
    field_name: n(e, "field_name") ? e.field_name : void 0,
    value: e.value
  };
}
function Vr(e) {
  if (e !== void 0)
    return e === null ? null : {
      kind: e.kind,
      type_name: e.type_name,
      field_name: e.field_name,
      value: e.value
    };
}
const Nf = {
  U32: "U32"
};
function Ff(e) {
  let t = !0;
  return t = t && "kind" in e, t = t && "value" in e, t;
}
function hf(e) {
  return xe(e);
}
function xe(e, t) {
  return e == null ? e : {
    kind: e.kind,
    type_name: n(e, "type_name") ? e.type_name : void 0,
    field_name: n(e, "field_name") ? e.field_name : void 0,
    value: e.value
  };
}
function Rr(e) {
  if (e !== void 0)
    return e === null ? null : {
      kind: e.kind,
      type_name: e.type_name,
      field_name: e.field_name,
      value: e.value
    };
}
const Af = {
  U64: "U64"
};
function If(e) {
  let t = !0;
  return t = t && "kind" in e, t = t && "value" in e, t;
}
function Tf(e) {
  return Ce(e);
}
function Ce(e, t) {
  return e == null ? e : {
    kind: e.kind,
    type_name: n(e, "type_name") ? e.type_name : void 0,
    field_name: n(e, "field_name") ? e.field_name : void 0,
    value: e.value
  };
}
function kr(e) {
  if (e !== void 0)
    return e === null ? null : {
      kind: e.kind,
      type_name: e.type_name,
      field_name: e.field_name,
      value: e.value
    };
}
const Jf = {
  U8: "U8"
};
function vf(e) {
  let t = !0;
  return t = t && "kind" in e, t = t && "value" in e, t;
}
function Vf(e) {
  return qe(e);
}
function qe(e, t) {
  return e == null ? e : {
    kind: e.kind,
    type_name: n(e, "type_name") ? e.type_name : void 0,
    field_name: n(e, "field_name") ? e.field_name : void 0,
    value: e.value
  };
}
function Er(e) {
  if (e !== void 0)
    return e === null ? null : {
      kind: e.kind,
      type_name: e.type_name,
      field_name: e.field_name,
      value: e.value
    };
}
function p(e) {
  return Dr(e);
}
function Dr(e, t) {
  if (e == null)
    return e;
  switch (e.kind) {
    case "Array":
      return { ...pe(e), kind: "Array" };
    case "Bool":
      return { ...ge(e), kind: "Bool" };
    case "Bytes":
      return { ...Se(e), kind: "Bytes" };
    case "Decimal":
      return { ...Oe(e), kind: "Decimal" };
    case "Enum":
      return { ...be(e), kind: "Enum" };
    case "I128":
      return { ...Ne(e), kind: "I128" };
    case "I16":
      return { ...Fe(e), kind: "I16" };
    case "I32":
      return { ...he(e), kind: "I32" };
    case "I64":
      return { ...Ae(e), kind: "I64" };
    case "I8":
      return { ...Ie(e), kind: "I8" };
    case "Map":
      return { ...ve(e), kind: "Map" };
    case "NonFungibleLocalId":
      return { ...Ve(e), kind: "NonFungibleLocalId" };
    case "Own":
      return { ...Re(e), kind: "Own" };
    case "PreciseDecimal":
      return { ...ke(e), kind: "PreciseDecimal" };
    case "Reference":
      return { ...Ee(e), kind: "Reference" };
    case "String":
      return { ...De(e), kind: "String" };
    case "Tuple":
      return { ...Pe(e), kind: "Tuple" };
    case "U128":
      return { ...we(e), kind: "U128" };
    case "U16":
      return { ...Me(e), kind: "U16" };
    case "U32":
      return { ...xe(e), kind: "U32" };
    case "U64":
      return { ...Ce(e), kind: "U64" };
    case "U8":
      return { ...qe(e), kind: "U8" };
    default:
      throw new Error(`No variant of ProgrammaticScryptoSborValue exists with 'kind=${e.kind}'`);
  }
}
function g(e) {
  if (e !== void 0) {
    if (e === null)
      return null;
    switch (e.kind) {
      case "Array":
        return cr(e);
      case "Bool":
        return dr(e);
      case "Bytes":
        return fr(e);
      case "Decimal":
        return _r(e);
      case "Enum":
        return mr(e);
      case "I128":
        return yr(e);
      case "I16":
        return pr(e);
      case "I32":
        return gr(e);
      case "I64":
        return Sr(e);
      case "I8":
        return Or(e);
      case "Map":
        return Nr(e);
      case "NonFungibleLocalId":
        return Fr(e);
      case "Own":
        return hr(e);
      case "PreciseDecimal":
        return Ar(e);
      case "Reference":
        return Ir(e);
      case "String":
        return Tr(e);
      case "Tuple":
        return Jr(e);
      case "U128":
        return vr(e);
      case "U16":
        return Vr(e);
      case "U32":
        return Rr(e);
      case "U64":
        return kr(e);
      case "U8":
        return Er(e);
      default:
        throw new Error(`No variant of ProgrammaticScryptoSborValue exists with 'kind=${e.kind}'`);
    }
  }
}
function Rf(e) {
  let t = !0;
  return t = t && "name" in e, t = t && "emitter" in e, t = t && "data" in e, t;
}
function Pr(e) {
  return wr(e);
}
function wr(e, t) {
  return e == null ? e : {
    name: e.name,
    emitter: e.emitter,
    data: p(e.data)
  };
}
function Mr(e) {
  if (e !== void 0)
    return e === null ? null : {
      name: e.name,
      emitter: e.emitter,
      data: g(e.data)
    };
}
const kf = {
  Unknown: "Unknown",
  CommittedSuccess: "CommittedSuccess",
  CommittedFailure: "CommittedFailure",
  Pending: "Pending",
  Rejected: "Rejected"
};
function M(e) {
  return xr(e);
}
function xr(e, t) {
  return e;
}
function Ef(e) {
  return e;
}
function Df(e) {
  return !0;
}
function Cr(e) {
  return qr(e);
}
function qr(e, t) {
  return e == null ? e : {
    status: n(e, "status") ? M(e.status) : void 0,
    fee_summary: n(e, "fee_summary") ? e.fee_summary : void 0,
    costing_parameters: n(e, "costing_parameters") ? e.costing_parameters : void 0,
    fee_destination: n(e, "fee_destination") ? e.fee_destination : void 0,
    fee_source: n(e, "fee_source") ? e.fee_source : void 0,
    state_updates: n(e, "state_updates") ? e.state_updates : void 0,
    next_epoch: n(e, "next_epoch") ? e.next_epoch : void 0,
    output: n(e, "output") ? e.output : void 0,
    events: n(e, "events") ? e.events.map(Pr) : void 0,
    error_message: n(e, "error_message") ? e.error_message : void 0
  };
}
function Ur(e) {
  if (e !== void 0)
    return e === null ? null : {
      status: e.status,
      fee_summary: e.fee_summary,
      costing_parameters: e.costing_parameters,
      fee_destination: e.fee_destination,
      fee_source: e.fee_source,
      state_updates: e.state_updates,
      next_epoch: e.next_epoch,
      output: e.output,
      events: e.events === void 0 ? void 0 : e.events.map(Mr),
      error_message: e.error_message
    };
}
function Pf(e) {
  let t = !0;
  return t = t && "state_version" in e, t = t && "epoch" in e, t = t && "round" in e, t = t && "round_timestamp" in e, t = t && "transaction_status" in e, t;
}
function H(e) {
  return Kr(e);
}
function Kr(e, t) {
  return e == null ? e : {
    state_version: e.state_version,
    epoch: e.epoch,
    round: e.round,
    round_timestamp: e.round_timestamp,
    transaction_status: M(e.transaction_status),
    payload_hash: n(e, "payload_hash") ? e.payload_hash : void 0,
    intent_hash: n(e, "intent_hash") ? e.intent_hash : void 0,
    fee_paid: n(e, "fee_paid") ? e.fee_paid : void 0,
    affected_global_entities: n(e, "affected_global_entities") ? e.affected_global_entities : void 0,
    confirmed_at: n(e, "confirmed_at") ? e.confirmed_at === null ? null : new Date(e.confirmed_at) : void 0,
    error_message: n(e, "error_message") ? e.error_message : void 0,
    raw_hex: n(e, "raw_hex") ? e.raw_hex : void 0,
    receipt: n(e, "receipt") ? Cr(e.receipt) : void 0,
    message: n(e, "message") ? e.message : void 0,
    balance_changes: n(e, "balance_changes") ? or(e.balance_changes) : void 0
  };
}
function $(e) {
  if (e !== void 0)
    return e === null ? null : {
      state_version: e.state_version,
      epoch: e.epoch,
      round: e.round,
      round_timestamp: e.round_timestamp,
      transaction_status: e.transaction_status,
      payload_hash: e.payload_hash,
      intent_hash: e.intent_hash,
      fee_paid: e.fee_paid,
      affected_global_entities: e.affected_global_entities,
      confirmed_at: e.confirmed_at === void 0 ? void 0 : e.confirmed_at === null ? null : e.confirmed_at.toISOString(),
      error_message: e.error_message,
      raw_hex: e.raw_hex,
      receipt: Ur(e.receipt),
      message: e.message,
      balance_changes: lr(e.balance_changes)
    };
}
const wf = {
  Explicit: "Explicit",
  Owner: "Owner"
};
function Lr(e) {
  return Br(e);
}
function Br(e, t) {
  return e;
}
function Mf(e) {
  return e;
}
function xf(e) {
  let t = !0;
  return t = t && "resolution" in e, t;
}
function Gr(e) {
  return Hr(e);
}
function Hr(e, t) {
  return e == null ? e : {
    resolution: Lr(e.resolution),
    explicit_rule: n(e, "explicit_rule") ? e.explicit_rule : void 0
  };
}
function $r(e) {
  if (e !== void 0)
    return e === null ? null : {
      resolution: e.resolution,
      explicit_rule: e.explicit_rule
    };
}
const Cf = {
  Main: "Main",
  Metadata: "Metadata",
  Royalty: "Royalty",
  RoleAssignment: "RoleAssignment"
};
function Wr(e) {
  return zr(e);
}
function zr(e, t) {
  return e;
}
function qf(e) {
  return e;
}
function Uf(e) {
  let t = !0;
  return t = t && "name" in e, t = t && "module" in e, t;
}
function de(e) {
  return Xr(e);
}
function Xr(e, t) {
  return e == null ? e : {
    name: e.name,
    module: Wr(e.module)
  };
}
function fe(e) {
  if (e !== void 0)
    return e === null ? null : {
      name: e.name,
      module: e.module
    };
}
function Kf(e) {
  let t = !0;
  return t = t && "role_key" in e, t = t && "assignment" in e, t;
}
function Zr(e) {
  return Qr(e);
}
function Qr(e, t) {
  return e == null ? e : {
    role_key: de(e.role_key),
    assignment: Gr(e.assignment),
    updater_roles: n(e, "updater_roles") ? e.updater_roles.map(de) : void 0
  };
}
function Yr(e) {
  if (e !== void 0)
    return e === null ? null : {
      role_key: fe(e.role_key),
      assignment: $r(e.assignment),
      updater_roles: e.updater_roles === void 0 ? void 0 : e.updater_roles.map(fe)
    };
}
function Lf(e) {
  let t = !0;
  return t = t && "owner" in e, t = t && "entries" in e, t;
}
function v(e) {
  return jr(e);
}
function jr(e, t) {
  return e == null ? e : {
    owner: e.owner,
    entries: e.entries.map(Zr)
  };
}
function V(e) {
  if (e !== void 0)
    return e === null ? null : {
      owner: e.owner,
      entries: e.entries.map(Yr)
    };
}
function Bf(e) {
  return !0;
}
function Gf(e) {
  return ei(e);
}
function ei(e, t) {
  return e == null ? e : {
    cursor: n(e, "cursor") ? e.cursor : void 0,
    limit_per_page: n(e, "limit_per_page") ? e.limit_per_page : void 0
  };
}
function Hf(e) {
  if (e !== void 0)
    return e === null ? null : {
      cursor: e.cursor,
      limit_per_page: e.limit_per_page
    };
}
const $f = {
  BoolArray: "BoolArray"
};
function Wf(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "values" in e, t;
}
function zf(e) {
  return Ue(e);
}
function Ue(e, t) {
  return e == null ? e : {
    type: e.type,
    values: e.values
  };
}
function ti(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      values: e.values
    };
}
const Xf = {
  Bool: "Bool"
};
function Zf(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "value" in e, t;
}
function Qf(e) {
  return Ke(e);
}
function Ke(e, t) {
  return e == null ? e : {
    type: e.type,
    value: e.value
  };
}
function ni(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      value: e.value
    };
}
const Yf = {
  DecimalArray: "DecimalArray"
};
function jf(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "values" in e, t;
}
function e_(e) {
  return Le(e);
}
function Le(e, t) {
  return e == null ? e : {
    type: e.type,
    values: e.values
  };
}
function ri(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      values: e.values
    };
}
const t_ = {
  Decimal: "Decimal"
};
function n_(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "value" in e, t;
}
function r_(e) {
  return Be(e);
}
function Be(e, t) {
  return e == null ? e : {
    type: e.type,
    value: e.value
  };
}
function ii(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      value: e.value
    };
}
const i_ = {
  GlobalAddressArray: "GlobalAddressArray"
};
function a_(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "values" in e, t;
}
function o_(e) {
  return Ge(e);
}
function Ge(e, t) {
  return e == null ? e : {
    type: e.type,
    values: e.values
  };
}
function ai(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      values: e.values
    };
}
const u_ = {
  GlobalAddress: "GlobalAddress"
};
function l_(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "value" in e, t;
}
function s_(e) {
  return He(e);
}
function He(e, t) {
  return e == null ? e : {
    type: e.type,
    value: e.value
  };
}
function oi(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      value: e.value
    };
}
const c_ = {
  I32Array: "I32Array"
};
function d_(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "values" in e, t;
}
function f_(e) {
  return $e(e);
}
function $e(e, t) {
  return e == null ? e : {
    type: e.type,
    values: e.values
  };
}
function ui(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      values: e.values
    };
}
const __ = {
  I32: "I32"
};
function m_(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "value" in e, t;
}
function y_(e) {
  return We(e);
}
function We(e, t) {
  return e == null ? e : {
    type: e.type,
    value: e.value
  };
}
function li(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      value: e.value
    };
}
const p_ = {
  I64Array: "I64Array"
};
function g_(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "values" in e, t;
}
function S_(e) {
  return ze(e);
}
function ze(e, t) {
  return e == null ? e : {
    type: e.type,
    values: e.values
  };
}
function si(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      values: e.values
    };
}
const O_ = {
  I64: "I64"
};
function b_(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "value" in e, t;
}
function N_(e) {
  return Xe(e);
}
function Xe(e, t) {
  return e == null ? e : {
    type: e.type,
    value: e.value
  };
}
function ci(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      value: e.value
    };
}
const F_ = {
  InstantArray: "InstantArray"
};
function h_(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "values" in e, t;
}
function A_(e) {
  return Ze(e);
}
function Ze(e, t) {
  return e == null ? e : {
    type: e.type,
    values: e.values
  };
}
function di(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      values: e.values
    };
}
const I_ = {
  Instant: "Instant"
};
function T_(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "value" in e, t;
}
function J_(e) {
  return Qe(e);
}
function Qe(e, t) {
  return e == null ? e : {
    type: e.type,
    value: e.value
  };
}
function fi(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      value: e.value
    };
}
function v_(e) {
  let t = !0;
  return t = t && "resource_address" in e, t = t && "non_fungible_id" in e, t;
}
function Ye(e) {
  return _i(e);
}
function _i(e, t) {
  return e == null ? e : {
    resource_address: e.resource_address,
    non_fungible_id: e.non_fungible_id
  };
}
function je(e) {
  if (e !== void 0)
    return e === null ? null : {
      resource_address: e.resource_address,
      non_fungible_id: e.non_fungible_id
    };
}
const V_ = {
  NonFungibleGlobalIdArray: "NonFungibleGlobalIdArray"
};
function R_(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "values" in e, t;
}
function k_(e) {
  return et(e);
}
function et(e, t) {
  return e == null ? e : {
    type: e.type,
    values: e.values.map(Ye)
  };
}
function mi(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      values: e.values.map(je)
    };
}
const E_ = {
  NonFungibleGlobalId: "NonFungibleGlobalId"
};
function D_(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "resource_address" in e, t = t && "non_fungible_id" in e, t;
}
function P_(e) {
  return tt(e);
}
function tt(e, t) {
  return e == null ? e : {
    type: e.type,
    resource_address: e.resource_address,
    non_fungible_id: e.non_fungible_id
  };
}
function yi(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      resource_address: e.resource_address,
      non_fungible_id: e.non_fungible_id
    };
}
const w_ = {
  NonFungibleLocalIdArray: "NonFungibleLocalIdArray"
};
function M_(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "values" in e, t;
}
function x_(e) {
  return nt(e);
}
function nt(e, t) {
  return e == null ? e : {
    type: e.type,
    values: e.values
  };
}
function pi(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      values: e.values
    };
}
const C_ = {
  NonFungibleLocalId: "NonFungibleLocalId"
};
function q_(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "value" in e, t;
}
function U_(e) {
  return rt(e);
}
function rt(e, t) {
  return e == null ? e : {
    type: e.type,
    value: e.value
  };
}
function gi(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      value: e.value
    };
}
const K_ = {
  OriginArray: "OriginArray"
};
function L_(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "values" in e, t;
}
function B_(e) {
  return it(e);
}
function it(e, t) {
  return e == null ? e : {
    type: e.type,
    values: e.values
  };
}
function Si(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      values: e.values
    };
}
const G_ = {
  Origin: "Origin"
};
function H_(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "value" in e, t;
}
function $_(e) {
  return at(e);
}
function at(e, t) {
  return e == null ? e : {
    type: e.type,
    value: e.value
  };
}
function Oi(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      value: e.value
    };
}
const W_ = {
  EcdsaSecp256k1: "EcdsaSecp256k1"
};
function z_(e) {
  let t = !0;
  return t = t && "key_type" in e, t = t && "key_hex" in e, t;
}
function X_(e) {
  return ot(e);
}
function ot(e, t) {
  return e == null ? e : {
    key_type: e.key_type,
    key_hex: e.key_hex
  };
}
function bi(e) {
  if (e !== void 0)
    return e === null ? null : {
      key_type: e.key_type,
      key_hex: e.key_hex
    };
}
const Z_ = {
  EddsaEd25519: "EddsaEd25519"
};
function Q_(e) {
  let t = !0;
  return t = t && "key_type" in e, t = t && "key_hex" in e, t;
}
function Y_(e) {
  return ut(e);
}
function ut(e, t) {
  return e == null ? e : {
    key_type: e.key_type,
    key_hex: e.key_hex
  };
}
function Ni(e) {
  if (e !== void 0)
    return e === null ? null : {
      key_type: e.key_type,
      key_hex: e.key_hex
    };
}
function I(e) {
  return Fi(e);
}
function Fi(e, t) {
  if (e == null)
    return e;
  switch (e.key_type) {
    case "EcdsaSecp256k1":
      return { ...ot(e), key_type: "EcdsaSecp256k1" };
    case "EddsaEd25519":
      return { ...ut(e), key_type: "EddsaEd25519" };
    default:
      throw new Error(`No variant of PublicKey exists with 'key_type=${e.key_type}'`);
  }
}
function T(e) {
  if (e !== void 0) {
    if (e === null)
      return null;
    switch (e.key_type) {
      case "EcdsaSecp256k1":
        return bi(e);
      case "EddsaEd25519":
        return Ni(e);
      default:
        throw new Error(`No variant of PublicKey exists with 'key_type=${e.key_type}'`);
    }
  }
}
const j_ = {
  PublicKeyArray: "PublicKeyArray"
};
function em(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "values" in e, t;
}
function tm(e) {
  return lt(e);
}
function lt(e, t) {
  return e == null ? e : {
    type: e.type,
    values: e.values.map(I)
  };
}
function hi(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      values: e.values.map(T)
    };
}
const nm = {
  EcdsaSecp256k1: "EcdsaSecp256k1"
};
function rm(e) {
  let t = !0;
  return t = t && "key_hash_type" in e, t = t && "hash_hex" in e, t;
}
function im(e) {
  return st(e);
}
function st(e, t) {
  return e == null ? e : {
    key_hash_type: e.key_hash_type,
    hash_hex: e.hash_hex
  };
}
function Ai(e) {
  if (e !== void 0)
    return e === null ? null : {
      key_hash_type: e.key_hash_type,
      hash_hex: e.hash_hex
    };
}
const am = {
  EddsaEd25519: "EddsaEd25519"
};
function om(e) {
  let t = !0;
  return t = t && "key_hash_type" in e, t = t && "hash_hex" in e, t;
}
function um(e) {
  return ct(e);
}
function ct(e, t) {
  return e == null ? e : {
    key_hash_type: e.key_hash_type,
    hash_hex: e.hash_hex
  };
}
function Ii(e) {
  if (e !== void 0)
    return e === null ? null : {
      key_hash_type: e.key_hash_type,
      hash_hex: e.hash_hex
    };
}
function W(e) {
  return Ti(e);
}
function Ti(e, t) {
  if (e == null)
    return e;
  switch (e.key_hash_type) {
    case "EcdsaSecp256k1":
      return { ...st(e), key_hash_type: "EcdsaSecp256k1" };
    case "EddsaEd25519":
      return { ...ct(e), key_hash_type: "EddsaEd25519" };
    default:
      throw new Error(`No variant of PublicKeyHash exists with 'key_hash_type=${e.key_hash_type}'`);
  }
}
function z(e) {
  if (e !== void 0) {
    if (e === null)
      return null;
    switch (e.key_hash_type) {
      case "EcdsaSecp256k1":
        return Ai(e);
      case "EddsaEd25519":
        return Ii(e);
      default:
        throw new Error(`No variant of PublicKeyHash exists with 'key_hash_type=${e.key_hash_type}'`);
    }
  }
}
const lm = {
  PublicKeyHashArray: "PublicKeyHashArray"
};
function sm(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "values" in e, t;
}
function cm(e) {
  return dt(e);
}
function dt(e, t) {
  return e == null ? e : {
    type: e.type,
    values: e.values.map(W)
  };
}
function Ji(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      values: e.values.map(z)
    };
}
const dm = {
  PublicKeyHash: "PublicKeyHash"
};
function fm(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "value" in e, t;
}
function _m(e) {
  return ft(e);
}
function ft(e, t) {
  return e == null ? e : {
    type: e.type,
    value: W(e.value)
  };
}
function vi(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      value: z(e.value)
    };
}
const mm = {
  PublicKey: "PublicKey"
};
function ym(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "value" in e, t;
}
function pm(e) {
  return _t(e);
}
function _t(e, t) {
  return e == null ? e : {
    type: e.type,
    value: I(e.value)
  };
}
function Vi(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      value: T(e.value)
    };
}
const gm = {
  StringArray: "StringArray"
};
function Sm(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "values" in e, t;
}
function Om(e) {
  return mt(e);
}
function mt(e, t) {
  return e == null ? e : {
    type: e.type,
    values: e.values
  };
}
function Ri(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      values: e.values
    };
}
const bm = {
  String: "String"
};
function Nm(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "value" in e, t;
}
function Fm(e) {
  return yt(e);
}
function yt(e, t) {
  return e == null ? e : {
    type: e.type,
    value: e.value
  };
}
function ki(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      value: e.value
    };
}
const hm = {
  U32Array: "U32Array"
};
function Am(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "values" in e, t;
}
function Im(e) {
  return pt(e);
}
function pt(e, t) {
  return e == null ? e : {
    type: e.type,
    values: e.values
  };
}
function Ei(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      values: e.values
    };
}
const Tm = {
  U32: "U32"
};
function Jm(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "value" in e, t;
}
function vm(e) {
  return gt(e);
}
function gt(e, t) {
  return e == null ? e : {
    type: e.type,
    value: e.value
  };
}
function Di(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      value: e.value
    };
}
const Vm = {
  U64Array: "U64Array"
};
function Rm(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "values" in e, t;
}
function km(e) {
  return St(e);
}
function St(e, t) {
  return e == null ? e : {
    type: e.type,
    values: e.values
  };
}
function Pi(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      values: e.values
    };
}
const Em = {
  U64: "U64"
};
function Dm(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "value" in e, t;
}
function Pm(e) {
  return Ot(e);
}
function Ot(e, t) {
  return e == null ? e : {
    type: e.type,
    value: e.value
  };
}
function wi(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      value: e.value
    };
}
const wm = {
  U8Array: "U8Array"
};
function Mm(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "value_hex" in e, t;
}
function xm(e) {
  return bt(e);
}
function bt(e, t) {
  return e == null ? e : {
    type: e.type,
    value_hex: e.value_hex
  };
}
function Mi(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      value_hex: e.value_hex
    };
}
const Cm = {
  U8: "U8"
};
function qm(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "value" in e, t;
}
function Um(e) {
  return Nt(e);
}
function Nt(e, t) {
  return e == null ? e : {
    type: e.type,
    value: e.value
  };
}
function xi(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      value: e.value
    };
}
const Km = {
  UrlArray: "UrlArray"
};
function Lm(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "values" in e, t;
}
function Bm(e) {
  return Ft(e);
}
function Ft(e, t) {
  return e == null ? e : {
    type: e.type,
    values: e.values
  };
}
function Ci(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      values: e.values
    };
}
const Gm = {
  Url: "Url"
};
function Hm(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "value" in e, t;
}
function $m(e) {
  return ht(e);
}
function ht(e, t) {
  return e == null ? e : {
    type: e.type,
    value: e.value
  };
}
function qi(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      value: e.value
    };
}
function At(e) {
  return Ui(e);
}
function Ui(e, t) {
  if (e == null)
    return e;
  switch (e.type) {
    case "Bool":
      return { ...Ke(e), type: "Bool" };
    case "BoolArray":
      return { ...Ue(e), type: "BoolArray" };
    case "Decimal":
      return { ...Be(e), type: "Decimal" };
    case "DecimalArray":
      return { ...Le(e), type: "DecimalArray" };
    case "GlobalAddress":
      return { ...He(e), type: "GlobalAddress" };
    case "GlobalAddressArray":
      return { ...Ge(e), type: "GlobalAddressArray" };
    case "I32":
      return { ...We(e), type: "I32" };
    case "I32Array":
      return { ...$e(e), type: "I32Array" };
    case "I64":
      return { ...Xe(e), type: "I64" };
    case "I64Array":
      return { ...ze(e), type: "I64Array" };
    case "Instant":
      return { ...Qe(e), type: "Instant" };
    case "InstantArray":
      return { ...Ze(e), type: "InstantArray" };
    case "NonFungibleGlobalId":
      return { ...tt(e), type: "NonFungibleGlobalId" };
    case "NonFungibleGlobalIdArray":
      return { ...et(e), type: "NonFungibleGlobalIdArray" };
    case "NonFungibleLocalId":
      return { ...rt(e), type: "NonFungibleLocalId" };
    case "NonFungibleLocalIdArray":
      return { ...nt(e), type: "NonFungibleLocalIdArray" };
    case "Origin":
      return { ...at(e), type: "Origin" };
    case "OriginArray":
      return { ...it(e), type: "OriginArray" };
    case "PublicKey":
      return { ..._t(e), type: "PublicKey" };
    case "PublicKeyArray":
      return { ...lt(e), type: "PublicKeyArray" };
    case "PublicKeyHash":
      return { ...ft(e), type: "PublicKeyHash" };
    case "PublicKeyHashArray":
      return { ...dt(e), type: "PublicKeyHashArray" };
    case "String":
      return { ...yt(e), type: "String" };
    case "StringArray":
      return { ...mt(e), type: "StringArray" };
    case "U32":
      return { ...gt(e), type: "U32" };
    case "U32Array":
      return { ...pt(e), type: "U32Array" };
    case "U64":
      return { ...Ot(e), type: "U64" };
    case "U64Array":
      return { ...St(e), type: "U64Array" };
    case "U8":
      return { ...Nt(e), type: "U8" };
    case "U8Array":
      return { ...bt(e), type: "U8Array" };
    case "Url":
      return { ...ht(e), type: "Url" };
    case "UrlArray":
      return { ...Ft(e), type: "UrlArray" };
    default:
      throw new Error(`No variant of MetadataTypedValue exists with 'type=${e.type}'`);
  }
}
function It(e) {
  if (e !== void 0) {
    if (e === null)
      return null;
    switch (e.type) {
      case "Bool":
        return ni(e);
      case "BoolArray":
        return ti(e);
      case "Decimal":
        return ii(e);
      case "DecimalArray":
        return ri(e);
      case "GlobalAddress":
        return oi(e);
      case "GlobalAddressArray":
        return ai(e);
      case "I32":
        return li(e);
      case "I32Array":
        return ui(e);
      case "I64":
        return ci(e);
      case "I64Array":
        return si(e);
      case "Instant":
        return fi(e);
      case "InstantArray":
        return di(e);
      case "NonFungibleGlobalId":
        return yi(e);
      case "NonFungibleGlobalIdArray":
        return mi(e);
      case "NonFungibleLocalId":
        return gi(e);
      case "NonFungibleLocalIdArray":
        return pi(e);
      case "Origin":
        return Oi(e);
      case "OriginArray":
        return Si(e);
      case "PublicKey":
        return Vi(e);
      case "PublicKeyArray":
        return hi(e);
      case "PublicKeyHash":
        return vi(e);
      case "PublicKeyHashArray":
        return Ji(e);
      case "String":
        return ki(e);
      case "StringArray":
        return Ri(e);
      case "U32":
        return Di(e);
      case "U32Array":
        return Ei(e);
      case "U64":
        return wi(e);
      case "U64Array":
        return Pi(e);
      case "U8":
        return xi(e);
      case "U8Array":
        return Mi(e);
      case "Url":
        return qi(e);
      case "UrlArray":
        return Ci(e);
      default:
        throw new Error(`No variant of MetadataTypedValue exists with 'type=${e.type}'`);
    }
  }
}
function Wm(e) {
  let t = !0;
  return t = t && "raw_hex" in e, t = t && "programmatic_json" in e, t = t && "typed" in e, t;
}
function Ki(e) {
  return Li(e);
}
function Li(e, t) {
  return e == null ? e : {
    raw_hex: e.raw_hex,
    programmatic_json: p(e.programmatic_json),
    typed: At(e.typed)
  };
}
function Bi(e) {
  if (e !== void 0)
    return e === null ? null : {
      raw_hex: e.raw_hex,
      programmatic_json: g(e.programmatic_json),
      typed: It(e.typed)
    };
}
function zm(e) {
  let t = !0;
  return t = t && "key" in e, t = t && "value" in e, t = t && "is_locked" in e, t = t && "last_updated_at_state_version" in e, t;
}
function ne(e) {
  return Gi(e);
}
function Gi(e, t) {
  return e == null ? e : {
    key: e.key,
    value: Ki(e.value),
    is_locked: e.is_locked,
    last_updated_at_state_version: e.last_updated_at_state_version
  };
}
function re(e) {
  if (e !== void 0)
    return e === null ? null : {
      key: e.key,
      value: Bi(e.value),
      is_locked: e.is_locked,
      last_updated_at_state_version: e.last_updated_at_state_version
    };
}
function Xm(e) {
  let t = !0;
  return t = t && "items" in e, t;
}
function N(e) {
  return Hi(e);
}
function Hi(e, t) {
  return e == null ? e : {
    total_count: n(e, "total_count") ? e.total_count : void 0,
    next_cursor: n(e, "next_cursor") ? e.next_cursor : void 0,
    items: e.items.map(ne)
  };
}
function F(e) {
  if (e !== void 0)
    return e === null ? null : {
      total_count: e.total_count,
      next_cursor: e.next_cursor,
      items: e.items.map(re)
    };
}
function Zm(e) {
  let t = !0;
  return t = t && "items" in e, t;
}
function Qm(e) {
  return $i(e);
}
function $i(e, t) {
  return e == null ? e : {
    items: e.items.map(ne)
  };
}
function Ym(e) {
  if (e !== void 0)
    return e === null ? null : {
      items: e.items.map(re)
    };
}
function jm(e) {
  let t = !0;
  return t = t && "typed" in e, t;
}
function ey(e) {
  return Wi(e);
}
function Wi(e, t) {
  return e == null ? e : {
    typed: At(e.typed)
  };
}
function ty(e) {
  if (e !== void 0)
    return e === null ? null : {
      typed: It(e.typed)
    };
}
const ny = {
  EntityNotFoundError: "EntityNotFoundError"
};
function ry(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "address" in e, t;
}
function iy(e) {
  return Tt(e);
}
function Tt(e, t) {
  return e == null ? e : {
    type: e.type,
    address: e.address
  };
}
function zi(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      address: e.address
    };
}
const ay = {
  EntityNotFoundError: "EntityNotFoundError"
};
function oy(e) {
  let t = !0;
  return t = t && "address" in e, t;
}
function uy(e) {
  return Xi(e);
}
function Xi(e, t) {
  return e == null ? e : {
    address: e.address,
    type: n(e, "type") ? e.type : void 0
  };
}
function ly(e) {
  if (e !== void 0)
    return e === null ? null : {
      address: e.address,
      type: e.type
    };
}
const sy = {
  InternalServerError: "InternalServerError"
};
function cy(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "exception" in e, t = t && "cause" in e, t;
}
function dy(e) {
  return Jt(e);
}
function Jt(e, t) {
  return e == null ? e : {
    type: e.type,
    exception: e.exception,
    cause: e.cause
  };
}
function Zi(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      exception: e.exception,
      cause: e.cause
    };
}
const fy = {
  InvalidEntityError: "InvalidEntityError"
};
function _y(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "address" in e, t;
}
function my(e) {
  return vt(e);
}
function vt(e, t) {
  return e == null ? e : {
    type: e.type,
    address: e.address
  };
}
function Qi(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      address: e.address
    };
}
function yy(e) {
  let t = !0;
  return t = t && "path" in e, t = t && "errors" in e, t;
}
function Vt(e) {
  return Yi(e);
}
function Yi(e, t) {
  return e == null ? e : {
    path: e.path,
    errors: e.errors
  };
}
function Rt(e) {
  if (e !== void 0)
    return e === null ? null : {
      path: e.path,
      errors: e.errors
    };
}
const py = {
  InvalidRequestError: "InvalidRequestError"
};
function gy(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "validation_errors" in e, t;
}
function Sy(e) {
  return kt(e);
}
function kt(e, t) {
  return e == null ? e : {
    type: e.type,
    validation_errors: e.validation_errors.map(Vt)
  };
}
function ji(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      validation_errors: e.validation_errors.map(Rt)
    };
}
const Oy = {
  InvalidTransactionError: "InvalidTransactionError"
};
function by(e) {
  let t = !0;
  return t = t && "type" in e, t;
}
function Ny(e) {
  return Et(e);
}
function Et(e, t) {
  return e == null ? e : {
    type: e.type
  };
}
function ea(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type
    };
}
const Fy = {
  NotSyncedUpError: "NotSyncedUpError"
};
function hy(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "request_type" in e, t = t && "current_sync_delay_seconds" in e, t = t && "max_allowed_sync_delay_seconds" in e, t;
}
function Ay(e) {
  return Dt(e);
}
function Dt(e, t) {
  return e == null ? e : {
    type: e.type,
    request_type: e.request_type,
    current_sync_delay_seconds: e.current_sync_delay_seconds,
    max_allowed_sync_delay_seconds: e.max_allowed_sync_delay_seconds
  };
}
function ta(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      request_type: e.request_type,
      current_sync_delay_seconds: e.current_sync_delay_seconds,
      max_allowed_sync_delay_seconds: e.max_allowed_sync_delay_seconds
    };
}
const Iy = {
  TransactionNotFoundError: "TransactionNotFoundError"
};
function Ty(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "intent_hash" in e, t;
}
function Jy(e) {
  return Pt(e);
}
function Pt(e, t) {
  return e == null ? e : {
    type: e.type,
    intent_hash: e.intent_hash
  };
}
function na(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      intent_hash: e.intent_hash
    };
}
function ra(e) {
  return ia(e);
}
function ia(e, t) {
  if (e == null)
    return e;
  switch (e.type) {
    case "EntityNotFoundError":
      return { ...Tt(e), type: "EntityNotFoundError" };
    case "InternalServerError":
      return { ...Jt(e), type: "InternalServerError" };
    case "InvalidEntityError":
      return { ...vt(e), type: "InvalidEntityError" };
    case "InvalidRequestError":
      return { ...kt(e), type: "InvalidRequestError" };
    case "InvalidTransactionError":
      return { ...Et(e), type: "InvalidTransactionError" };
    case "NotSyncedUpError":
      return { ...Dt(e), type: "NotSyncedUpError" };
    case "TransactionNotFoundError":
      return { ...Pt(e), type: "TransactionNotFoundError" };
    default:
      throw new Error(`No variant of GatewayError exists with 'type=${e.type}'`);
  }
}
function aa(e) {
  if (e !== void 0) {
    if (e === null)
      return null;
    switch (e.type) {
      case "EntityNotFoundError":
        return zi(e);
      case "InternalServerError":
        return Zi(e);
      case "InvalidEntityError":
        return Qi(e);
      case "InvalidRequestError":
        return ji(e);
      case "InvalidTransactionError":
        return ea(e);
      case "NotSyncedUpError":
        return ta(e);
      case "TransactionNotFoundError":
        return na(e);
      default:
        throw new Error(`No variant of GatewayError exists with 'type=${e.type}'`);
    }
  }
}
function vy(e) {
  let t = !0;
  return t = t && "message" in e, t;
}
function Vy(e) {
  return oa(e);
}
function oa(e, t) {
  return e == null ? e : {
    message: e.message,
    code: n(e, "code") ? e.code : void 0,
    details: n(e, "details") ? ra(e.details) : void 0,
    trace_id: n(e, "trace_id") ? e.trace_id : void 0
  };
}
function Ry(e) {
  if (e !== void 0)
    return e === null ? null : {
      message: e.message,
      code: e.code,
      details: aa(e.details),
      trace_id: e.trace_id
    };
}
function ky(e) {
  return !0;
}
function Ey(e) {
  return ua(e);
}
function ua(e, t) {
  return e == null ? e : {
    from_ledger_state: n(e, "from_ledger_state") ? c(e.from_ledger_state) : void 0
  };
}
function Dy(e) {
  if (e !== void 0)
    return e === null ? null : {
      from_ledger_state: d(e.from_ledger_state)
    };
}
const Py = {
  Global: "Global"
};
function wy(e) {
  let t = !0;
  return t = t && "aggregation_level" in e, t = t && "resource_address" in e, t = t && "amount" in e, t = t && "last_updated_at_state_version" in e, t;
}
function My(e) {
  return wt(e);
}
function wt(e, t) {
  return e == null ? e : {
    aggregation_level: e.aggregation_level,
    resource_address: e.resource_address,
    explicit_metadata: n(e, "explicit_metadata") ? N(e.explicit_metadata) : void 0,
    amount: e.amount,
    last_updated_at_state_version: e.last_updated_at_state_version
  };
}
function la(e) {
  if (e !== void 0)
    return e === null ? null : {
      aggregation_level: e.aggregation_level,
      resource_address: e.resource_address,
      explicit_metadata: F(e.explicit_metadata),
      amount: e.amount,
      last_updated_at_state_version: e.last_updated_at_state_version
    };
}
function xy(e) {
  let t = !0;
  return t = t && "vault_address" in e, t = t && "amount" in e, t = t && "last_updated_at_state_version" in e, t;
}
function x(e) {
  return sa(e);
}
function sa(e, t) {
  return e == null ? e : {
    vault_address: e.vault_address,
    amount: e.amount,
    last_updated_at_state_version: e.last_updated_at_state_version
  };
}
function C(e) {
  if (e !== void 0)
    return e === null ? null : {
      vault_address: e.vault_address,
      amount: e.amount,
      last_updated_at_state_version: e.last_updated_at_state_version
    };
}
function Cy(e) {
  let t = !0;
  return t = t && "items" in e, t;
}
function Mt(e) {
  return ca(e);
}
function ca(e, t) {
  return e == null ? e : {
    total_count: n(e, "total_count") ? e.total_count : void 0,
    next_cursor: n(e, "next_cursor") ? e.next_cursor : void 0,
    items: e.items.map(x)
  };
}
function xt(e) {
  if (e !== void 0)
    return e === null ? null : {
      total_count: e.total_count,
      next_cursor: e.next_cursor,
      items: e.items.map(C)
    };
}
const qy = {
  Vault: "Vault"
};
function Uy(e) {
  let t = !0;
  return t = t && "aggregation_level" in e, t = t && "resource_address" in e, t = t && "vaults" in e, t;
}
function Ky(e) {
  return Ct(e);
}
function Ct(e, t) {
  return e == null ? e : {
    aggregation_level: e.aggregation_level,
    resource_address: e.resource_address,
    explicit_metadata: n(e, "explicit_metadata") ? N(e.explicit_metadata) : void 0,
    vaults: Mt(e.vaults)
  };
}
function da(e) {
  if (e !== void 0)
    return e === null ? null : {
      aggregation_level: e.aggregation_level,
      resource_address: e.resource_address,
      explicit_metadata: F(e.explicit_metadata),
      vaults: xt(e.vaults)
    };
}
function ie(e) {
  return fa(e);
}
function fa(e, t) {
  if (e == null)
    return e;
  switch (e.aggregation_level) {
    case "Global":
      return { ...wt(e), aggregation_level: "Global" };
    case "Vault":
      return { ...Ct(e), aggregation_level: "Vault" };
    default:
      throw new Error(`No variant of FungibleResourcesCollectionItem exists with 'aggregation_level=${e.aggregation_level}'`);
  }
}
function ae(e) {
  if (e !== void 0) {
    if (e === null)
      return null;
    switch (e.aggregation_level) {
      case "Global":
        return la(e);
      case "Vault":
        return da(e);
      default:
        throw new Error(`No variant of FungibleResourcesCollectionItem exists with 'aggregation_level=${e.aggregation_level}'`);
    }
  }
}
function Ly(e) {
  let t = !0;
  return t = t && "items" in e, t;
}
function _a(e) {
  return ma(e);
}
function ma(e, t) {
  return e == null ? e : {
    total_count: n(e, "total_count") ? e.total_count : void 0,
    next_cursor: n(e, "next_cursor") ? e.next_cursor : void 0,
    items: e.items.map(ie)
  };
}
function ya(e) {
  if (e !== void 0)
    return e === null ? null : {
      total_count: e.total_count,
      next_cursor: e.next_cursor,
      items: e.items.map(ae)
    };
}
function By(e) {
  let t = !0;
  return t = t && "items" in e, t;
}
function Gy(e) {
  return pa(e);
}
function pa(e, t) {
  return e == null ? e : {
    items: e.items.map(ie)
  };
}
function Hy(e) {
  if (e !== void 0)
    return e === null ? null : {
      items: e.items.map(ae)
    };
}
const ga = {
  Global: "Global",
  Vault: "Vault"
};
function A(e) {
  return Sa(e);
}
function Sa(e, t) {
  return e;
}
function $y(e) {
  return e;
}
function Wy(e) {
  let t = !0;
  return t = t && "aggregation_level" in e, t = t && "resource_address" in e, t;
}
function zy(e) {
  return Oa(e);
}
function Oa(e, t) {
  return e == null ? e : {
    aggregation_level: A(e.aggregation_level),
    resource_address: e.resource_address,
    explicit_metadata: n(e, "explicit_metadata") ? N(e.explicit_metadata) : void 0
  };
}
function Xy(e) {
  if (e !== void 0)
    return e === null ? null : {
      aggregation_level: e.aggregation_level,
      resource_address: e.resource_address,
      explicit_metadata: F(e.explicit_metadata)
    };
}
const Zy = {
  Global: "Global"
};
function Qy(e) {
  let t = !0;
  return t = t && "amount" in e, t = t && "last_updated_at_state_version" in e, t;
}
function Yy(e) {
  return ba(e);
}
function ba(e, t) {
  return e == null ? e : {
    amount: e.amount,
    last_updated_at_state_version: e.last_updated_at_state_version,
    aggregation_level: n(e, "aggregation_level") ? e.aggregation_level : void 0
  };
}
function jy(e) {
  if (e !== void 0)
    return e === null ? null : {
      amount: e.amount,
      last_updated_at_state_version: e.last_updated_at_state_version,
      aggregation_level: e.aggregation_level
    };
}
const ep = {
  Vault: "Vault"
};
function tp(e) {
  let t = !0;
  return t = t && "vaults" in e, t;
}
function np(e) {
  return Na(e);
}
function Na(e, t) {
  return e == null ? e : {
    vaults: Mt(e.vaults),
    aggregation_level: n(e, "aggregation_level") ? e.aggregation_level : void 0
  };
}
function rp(e) {
  if (e !== void 0)
    return e === null ? null : {
      vaults: xt(e.vaults),
      aggregation_level: e.aggregation_level
    };
}
function ip(e) {
  let t = !0;
  return t = t && "items" in e, t;
}
function ap(e) {
  return Fa(e);
}
function Fa(e, t) {
  return e == null ? e : {
    items: e.items.map(x)
  };
}
function op(e) {
  if (e !== void 0)
    return e === null ? null : {
      items: e.items.map(C)
    };
}
function up(e) {
  let t = !0;
  return t = t && "type" in e, t;
}
function lp(e) {
  return ha(e);
}
function ha(e, t) {
  return e == null ? e : {
    type: e.type
  };
}
function sp(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type
    };
}
function cp(e) {
  let t = !0;
  return t = t && "state_version" in e, t;
}
function dp(e) {
  return Aa(e);
}
function Aa(e, t) {
  return e == null ? e : {
    state_version: e.state_version
  };
}
function fp(e) {
  if (e !== void 0)
    return e === null ? null : {
      state_version: e.state_version
    };
}
function _p(e) {
  let t = !0;
  return t = t && "release_version" in e, t = t && "open_api_schema_version" in e, t = t && "image_tag" in e, t;
}
function qt(e) {
  return Ia(e);
}
function Ia(e, t) {
  return e == null ? e : {
    release_version: e.release_version,
    open_api_schema_version: e.open_api_schema_version,
    image_tag: e.image_tag
  };
}
function Ut(e) {
  if (e !== void 0)
    return e === null ? null : {
      release_version: e.release_version,
      open_api_schema_version: e.open_api_schema_version,
      image_tag: e.image_tag
    };
}
function mp(e) {
  let t = !0;
  return t = t && "network" in e, t = t && "state_version" in e, t = t && "proposer_round_timestamp" in e, t = t && "epoch" in e, t = t && "round" in e, t;
}
function f(e) {
  return Ta(e);
}
function Ta(e, t) {
  return e == null ? e : {
    network: e.network,
    state_version: e.state_version,
    proposer_round_timestamp: e.proposer_round_timestamp,
    epoch: e.epoch,
    round: e.round
  };
}
function _(e) {
  if (e !== void 0)
    return e === null ? null : {
      network: e.network,
      state_version: e.state_version,
      proposer_round_timestamp: e.proposer_round_timestamp,
      epoch: e.epoch,
      round: e.round
    };
}
function yp(e) {
  let t = !0;
  return t = t && "ledger_state" in e, t = t && "release_info" in e, t;
}
function Ja(e) {
  return va(e);
}
function va(e, t) {
  return e == null ? e : {
    ledger_state: f(e.ledger_state),
    release_info: qt(e.release_info)
  };
}
function pp(e) {
  if (e !== void 0)
    return e === null ? null : {
      ledger_state: _(e.ledger_state),
      release_info: Ut(e.release_info)
    };
}
function gp(e) {
  let t = !0;
  return t = t && "release_info" in e, t;
}
function Sp(e) {
  return Va(e);
}
function Va(e, t) {
  return e == null ? e : {
    release_info: qt(e.release_info)
  };
}
function Op(e) {
  if (e !== void 0)
    return e === null ? null : {
      release_info: Ut(e.release_info)
    };
}
const bp = {
  InternalServerError: "InternalServerError"
};
function Np(e) {
  let t = !0;
  return t = t && "exception" in e, t = t && "cause" in e, t;
}
function Fp(e) {
  return Ra(e);
}
function Ra(e, t) {
  return e == null ? e : {
    exception: e.exception,
    cause: e.cause,
    type: n(e, "type") ? e.type : void 0
  };
}
function hp(e) {
  if (e !== void 0)
    return e === null ? null : {
      exception: e.exception,
      cause: e.cause,
      type: e.type
    };
}
const Ap = {
  InvalidEntityError: "InvalidEntityError"
};
function Ip(e) {
  let t = !0;
  return t = t && "address" in e, t;
}
function Tp(e) {
  return ka(e);
}
function ka(e, t) {
  return e == null ? e : {
    address: e.address,
    type: n(e, "type") ? e.type : void 0
  };
}
function Jp(e) {
  if (e !== void 0)
    return e === null ? null : {
      address: e.address,
      type: e.type
    };
}
const vp = {
  InvalidRequestError: "InvalidRequestError"
};
function Vp(e) {
  let t = !0;
  return t = t && "validation_errors" in e, t;
}
function Rp(e) {
  return Ea(e);
}
function Ea(e, t) {
  return e == null ? e : {
    validation_errors: e.validation_errors.map(Vt),
    type: n(e, "type") ? e.type : void 0
  };
}
function kp(e) {
  if (e !== void 0)
    return e === null ? null : {
      validation_errors: e.validation_errors.map(Rt),
      type: e.type
    };
}
const Ep = {
  InvalidTransactionError: "InvalidTransactionError"
};
function Dp(e) {
  return !0;
}
function Pp(e) {
  return Da(e);
}
function Da(e, t) {
  return e == null ? e : {
    type: n(e, "type") ? e.type : void 0
  };
}
function wp(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type
    };
}
function Mp(e) {
  let t = !0;
  return t = t && "ledger_state" in e, t;
}
function xp(e) {
  return Pa(e);
}
function Pa(e, t) {
  return e == null ? e : {
    ledger_state: f(e.ledger_state)
  };
}
function Cp(e) {
  if (e !== void 0)
    return e === null ? null : {
      ledger_state: _(e.ledger_state)
    };
}
const qp = {
  BoolArray: "BoolArray"
};
function Up(e) {
  let t = !0;
  return t = t && "values" in e, t;
}
function Kp(e) {
  return wa(e);
}
function wa(e, t) {
  return e == null ? e : {
    values: e.values,
    type: n(e, "type") ? e.type : void 0
  };
}
function Lp(e) {
  if (e !== void 0)
    return e === null ? null : {
      values: e.values,
      type: e.type
    };
}
const Bp = {
  Bool: "Bool"
};
function Gp(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function Hp(e) {
  return Ma(e);
}
function Ma(e, t) {
  return e == null ? e : {
    value: e.value,
    type: n(e, "type") ? e.type : void 0
  };
}
function $p(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      type: e.type
    };
}
const Wp = {
  DecimalArray: "DecimalArray"
};
function zp(e) {
  let t = !0;
  return t = t && "values" in e, t;
}
function Xp(e) {
  return xa(e);
}
function xa(e, t) {
  return e == null ? e : {
    values: e.values,
    type: n(e, "type") ? e.type : void 0
  };
}
function Zp(e) {
  if (e !== void 0)
    return e === null ? null : {
      values: e.values,
      type: e.type
    };
}
const Qp = {
  Decimal: "Decimal"
};
function Yp(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function jp(e) {
  return Ca(e);
}
function Ca(e, t) {
  return e == null ? e : {
    value: e.value,
    type: n(e, "type") ? e.type : void 0
  };
}
function eg(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      type: e.type
    };
}
const tg = {
  GlobalAddressArray: "GlobalAddressArray"
};
function ng(e) {
  let t = !0;
  return t = t && "values" in e, t;
}
function rg(e) {
  return qa(e);
}
function qa(e, t) {
  return e == null ? e : {
    values: e.values,
    type: n(e, "type") ? e.type : void 0
  };
}
function ig(e) {
  if (e !== void 0)
    return e === null ? null : {
      values: e.values,
      type: e.type
    };
}
const ag = {
  GlobalAddress: "GlobalAddress"
};
function og(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function ug(e) {
  return Ua(e);
}
function Ua(e, t) {
  return e == null ? e : {
    value: e.value,
    type: n(e, "type") ? e.type : void 0
  };
}
function lg(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      type: e.type
    };
}
const sg = {
  I32Array: "I32Array"
};
function cg(e) {
  let t = !0;
  return t = t && "values" in e, t;
}
function dg(e) {
  return Ka(e);
}
function Ka(e, t) {
  return e == null ? e : {
    values: e.values,
    type: n(e, "type") ? e.type : void 0
  };
}
function fg(e) {
  if (e !== void 0)
    return e === null ? null : {
      values: e.values,
      type: e.type
    };
}
const _g = {
  I32: "I32"
};
function mg(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function yg(e) {
  return La(e);
}
function La(e, t) {
  return e == null ? e : {
    value: e.value,
    type: n(e, "type") ? e.type : void 0
  };
}
function pg(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      type: e.type
    };
}
const gg = {
  I64Array: "I64Array"
};
function Sg(e) {
  let t = !0;
  return t = t && "values" in e, t;
}
function Og(e) {
  return Ba(e);
}
function Ba(e, t) {
  return e == null ? e : {
    values: e.values,
    type: n(e, "type") ? e.type : void 0
  };
}
function bg(e) {
  if (e !== void 0)
    return e === null ? null : {
      values: e.values,
      type: e.type
    };
}
const Ng = {
  I64: "I64"
};
function Fg(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function hg(e) {
  return Ga(e);
}
function Ga(e, t) {
  return e == null ? e : {
    value: e.value,
    type: n(e, "type") ? e.type : void 0
  };
}
function Ag(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      type: e.type
    };
}
const Ig = {
  InstantArray: "InstantArray"
};
function Tg(e) {
  let t = !0;
  return t = t && "values" in e, t;
}
function Jg(e) {
  return Ha(e);
}
function Ha(e, t) {
  return e == null ? e : {
    values: e.values,
    type: n(e, "type") ? e.type : void 0
  };
}
function vg(e) {
  if (e !== void 0)
    return e === null ? null : {
      values: e.values,
      type: e.type
    };
}
const Vg = {
  Instant: "Instant"
};
function Rg(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function kg(e) {
  return $a(e);
}
function $a(e, t) {
  return e == null ? e : {
    value: e.value,
    type: n(e, "type") ? e.type : void 0
  };
}
function Eg(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      type: e.type
    };
}
const Dg = {
  NonFungibleGlobalIdArray: "NonFungibleGlobalIdArray"
};
function Pg(e) {
  let t = !0;
  return t = t && "values" in e, t;
}
function wg(e) {
  return Wa(e);
}
function Wa(e, t) {
  return e == null ? e : {
    values: e.values.map(Ye),
    type: n(e, "type") ? e.type : void 0
  };
}
function Mg(e) {
  if (e !== void 0)
    return e === null ? null : {
      values: e.values.map(je),
      type: e.type
    };
}
const xg = {
  NonFungibleGlobalId: "NonFungibleGlobalId"
};
function Cg(e) {
  let t = !0;
  return t = t && "resource_address" in e, t = t && "non_fungible_id" in e, t;
}
function qg(e) {
  return za(e);
}
function za(e, t) {
  return e == null ? e : {
    resource_address: e.resource_address,
    non_fungible_id: e.non_fungible_id,
    type: n(e, "type") ? e.type : void 0
  };
}
function Ug(e) {
  if (e !== void 0)
    return e === null ? null : {
      resource_address: e.resource_address,
      non_fungible_id: e.non_fungible_id,
      type: e.type
    };
}
const Kg = {
  NonFungibleLocalIdArray: "NonFungibleLocalIdArray"
};
function Lg(e) {
  let t = !0;
  return t = t && "values" in e, t;
}
function Bg(e) {
  return Xa(e);
}
function Xa(e, t) {
  return e == null ? e : {
    values: e.values,
    type: n(e, "type") ? e.type : void 0
  };
}
function Gg(e) {
  if (e !== void 0)
    return e === null ? null : {
      values: e.values,
      type: e.type
    };
}
const Hg = {
  NonFungibleLocalId: "NonFungibleLocalId"
};
function $g(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function Wg(e) {
  return Za(e);
}
function Za(e, t) {
  return e == null ? e : {
    value: e.value,
    type: n(e, "type") ? e.type : void 0
  };
}
function zg(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      type: e.type
    };
}
const Xg = {
  OriginArray: "OriginArray"
};
function Zg(e) {
  let t = !0;
  return t = t && "values" in e, t;
}
function Qg(e) {
  return Qa(e);
}
function Qa(e, t) {
  return e == null ? e : {
    values: e.values,
    type: n(e, "type") ? e.type : void 0
  };
}
function Yg(e) {
  if (e !== void 0)
    return e === null ? null : {
      values: e.values,
      type: e.type
    };
}
const jg = {
  Origin: "Origin"
};
function eS(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function tS(e) {
  return Ya(e);
}
function Ya(e, t) {
  return e == null ? e : {
    value: e.value,
    type: n(e, "type") ? e.type : void 0
  };
}
function nS(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      type: e.type
    };
}
const rS = {
  PublicKeyArray: "PublicKeyArray"
};
function iS(e) {
  let t = !0;
  return t = t && "values" in e, t;
}
function aS(e) {
  return ja(e);
}
function ja(e, t) {
  return e == null ? e : {
    values: e.values.map(I),
    type: n(e, "type") ? e.type : void 0
  };
}
function oS(e) {
  if (e !== void 0)
    return e === null ? null : {
      values: e.values.map(T),
      type: e.type
    };
}
const uS = {
  PublicKeyHashArray: "PublicKeyHashArray"
};
function lS(e) {
  let t = !0;
  return t = t && "values" in e, t;
}
function sS(e) {
  return eo(e);
}
function eo(e, t) {
  return e == null ? e : {
    values: e.values.map(W),
    type: n(e, "type") ? e.type : void 0
  };
}
function cS(e) {
  if (e !== void 0)
    return e === null ? null : {
      values: e.values.map(z),
      type: e.type
    };
}
const dS = {
  PublicKeyHash: "PublicKeyHash"
};
function fS(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function _S(e) {
  return to(e);
}
function to(e, t) {
  return e == null ? e : {
    value: W(e.value),
    type: n(e, "type") ? e.type : void 0
  };
}
function mS(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: z(e.value),
      type: e.type
    };
}
const yS = {
  PublicKey: "PublicKey"
};
function pS(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function gS(e) {
  return no(e);
}
function no(e, t) {
  return e == null ? e : {
    value: I(e.value),
    type: n(e, "type") ? e.type : void 0
  };
}
function SS(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: T(e.value),
      type: e.type
    };
}
const OS = {
  StringArray: "StringArray"
};
function bS(e) {
  let t = !0;
  return t = t && "values" in e, t;
}
function NS(e) {
  return ro(e);
}
function ro(e, t) {
  return e == null ? e : {
    values: e.values,
    type: n(e, "type") ? e.type : void 0
  };
}
function FS(e) {
  if (e !== void 0)
    return e === null ? null : {
      values: e.values,
      type: e.type
    };
}
const hS = {
  String: "String"
};
function AS(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function IS(e) {
  return io(e);
}
function io(e, t) {
  return e == null ? e : {
    value: e.value,
    type: n(e, "type") ? e.type : void 0
  };
}
function TS(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      type: e.type
    };
}
const JS = {
  String: "String",
  Bool: "Bool",
  U8: "U8",
  U32: "U32",
  U64: "U64",
  I32: "I32",
  I64: "I64",
  Decimal: "Decimal",
  GlobalAddress: "GlobalAddress",
  PublicKey: "PublicKey",
  NonFungibleGlobalId: "NonFungibleGlobalId",
  NonFungibleLocalId: "NonFungibleLocalId",
  Instant: "Instant",
  Url: "Url",
  Origin: "Origin",
  PublicKeyHash: "PublicKeyHash",
  StringArray: "StringArray",
  BoolArray: "BoolArray",
  U8Array: "U8Array",
  U32Array: "U32Array",
  U64Array: "U64Array",
  I32Array: "I32Array",
  I64Array: "I64Array",
  DecimalArray: "DecimalArray",
  GlobalAddressArray: "GlobalAddressArray",
  PublicKeyArray: "PublicKeyArray",
  NonFungibleGlobalIdArray: "NonFungibleGlobalIdArray",
  NonFungibleLocalIdArray: "NonFungibleLocalIdArray",
  InstantArray: "InstantArray",
  UrlArray: "UrlArray",
  OriginArray: "OriginArray",
  PublicKeyHashArray: "PublicKeyHashArray"
};
function ao(e) {
  return oo(e);
}
function oo(e, t) {
  return e;
}
function vS(e) {
  return e;
}
function VS(e) {
  let t = !0;
  return t = t && "type" in e, t;
}
function RS(e) {
  return uo(e);
}
function uo(e, t) {
  return e == null ? e : {
    type: ao(e.type)
  };
}
function kS(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type
    };
}
const ES = {
  U32Array: "U32Array"
};
function DS(e) {
  let t = !0;
  return t = t && "values" in e, t;
}
function PS(e) {
  return lo(e);
}
function lo(e, t) {
  return e == null ? e : {
    values: e.values,
    type: n(e, "type") ? e.type : void 0
  };
}
function wS(e) {
  if (e !== void 0)
    return e === null ? null : {
      values: e.values,
      type: e.type
    };
}
const MS = {
  U32: "U32"
};
function xS(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function CS(e) {
  return so(e);
}
function so(e, t) {
  return e == null ? e : {
    value: e.value,
    type: n(e, "type") ? e.type : void 0
  };
}
function qS(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      type: e.type
    };
}
const US = {
  U64Array: "U64Array"
};
function KS(e) {
  let t = !0;
  return t = t && "values" in e, t;
}
function LS(e) {
  return co(e);
}
function co(e, t) {
  return e == null ? e : {
    values: e.values,
    type: n(e, "type") ? e.type : void 0
  };
}
function BS(e) {
  if (e !== void 0)
    return e === null ? null : {
      values: e.values,
      type: e.type
    };
}
const GS = {
  U64: "U64"
};
function HS(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function $S(e) {
  return fo(e);
}
function fo(e, t) {
  return e == null ? e : {
    value: e.value,
    type: n(e, "type") ? e.type : void 0
  };
}
function WS(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      type: e.type
    };
}
const zS = {
  U8Array: "U8Array"
};
function XS(e) {
  let t = !0;
  return t = t && "value_hex" in e, t;
}
function ZS(e) {
  return _o(e);
}
function _o(e, t) {
  return e == null ? e : {
    value_hex: e.value_hex,
    type: n(e, "type") ? e.type : void 0
  };
}
function QS(e) {
  if (e !== void 0)
    return e === null ? null : {
      value_hex: e.value_hex,
      type: e.type
    };
}
const YS = {
  U8: "U8"
};
function jS(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function eO(e) {
  return mo(e);
}
function mo(e, t) {
  return e == null ? e : {
    value: e.value,
    type: n(e, "type") ? e.type : void 0
  };
}
function tO(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      type: e.type
    };
}
const nO = {
  UrlArray: "UrlArray"
};
function rO(e) {
  let t = !0;
  return t = t && "values" in e, t;
}
function iO(e) {
  return yo(e);
}
function yo(e, t) {
  return e == null ? e : {
    values: e.values,
    type: n(e, "type") ? e.type : void 0
  };
}
function aO(e) {
  if (e !== void 0)
    return e === null ? null : {
      values: e.values,
      type: e.type
    };
}
const oO = {
  Url: "Url"
};
function uO(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function lO(e) {
  return po(e);
}
function po(e, t) {
  return e == null ? e : {
    value: e.value,
    type: n(e, "type") ? e.type : void 0
  };
}
function sO(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      type: e.type
    };
}
function cO(e) {
  let t = !0;
  return t = t && "xrd" in e, t = t && "secp256k1_signature_virtual_badge" in e, t = t && "ed25519_signature_virtual_badge" in e, t = t && "package_of_direct_caller_virtual_badge" in e, t = t && "global_caller_virtual_badge" in e, t = t && "system_transaction_badge" in e, t = t && "package_owner_badge" in e, t = t && "validator_owner_badge" in e, t = t && "account_owner_badge" in e, t = t && "identity_owner_badge" in e, t = t && "package_package" in e, t = t && "resource_package" in e, t = t && "account_package" in e, t = t && "identity_package" in e, t = t && "consensus_manager_package" in e, t = t && "access_controller_package" in e, t = t && "transaction_processor_package" in e, t = t && "metadata_module_package" in e, t = t && "royalty_module_package" in e, t = t && "access_rules_package" in e, t = t && "genesis_helper_package" in e, t = t && "faucet_package" in e, t = t && "consensus_manager" in e, t = t && "genesis_helper" in e, t = t && "faucet" in e, t = t && "pool_package" in e, t = t && "transaction_tracker" in e, t;
}
function go(e) {
  return So(e);
}
function So(e, t) {
  return e == null ? e : {
    xrd: e.xrd,
    secp256k1_signature_virtual_badge: e.secp256k1_signature_virtual_badge,
    ed25519_signature_virtual_badge: e.ed25519_signature_virtual_badge,
    package_of_direct_caller_virtual_badge: e.package_of_direct_caller_virtual_badge,
    global_caller_virtual_badge: e.global_caller_virtual_badge,
    system_transaction_badge: e.system_transaction_badge,
    package_owner_badge: e.package_owner_badge,
    validator_owner_badge: e.validator_owner_badge,
    account_owner_badge: e.account_owner_badge,
    identity_owner_badge: e.identity_owner_badge,
    package_package: e.package_package,
    resource_package: e.resource_package,
    account_package: e.account_package,
    identity_package: e.identity_package,
    consensus_manager_package: e.consensus_manager_package,
    access_controller_package: e.access_controller_package,
    transaction_processor_package: e.transaction_processor_package,
    metadata_module_package: e.metadata_module_package,
    royalty_module_package: e.royalty_module_package,
    access_rules_package: e.access_rules_package,
    genesis_helper_package: e.genesis_helper_package,
    faucet_package: e.faucet_package,
    consensus_manager: e.consensus_manager,
    genesis_helper: e.genesis_helper,
    faucet: e.faucet,
    pool_package: e.pool_package,
    transaction_tracker: e.transaction_tracker
  };
}
function Oo(e) {
  if (e !== void 0)
    return e === null ? null : {
      xrd: e.xrd,
      secp256k1_signature_virtual_badge: e.secp256k1_signature_virtual_badge,
      ed25519_signature_virtual_badge: e.ed25519_signature_virtual_badge,
      package_of_direct_caller_virtual_badge: e.package_of_direct_caller_virtual_badge,
      global_caller_virtual_badge: e.global_caller_virtual_badge,
      system_transaction_badge: e.system_transaction_badge,
      package_owner_badge: e.package_owner_badge,
      validator_owner_badge: e.validator_owner_badge,
      account_owner_badge: e.account_owner_badge,
      identity_owner_badge: e.identity_owner_badge,
      package_package: e.package_package,
      resource_package: e.resource_package,
      account_package: e.account_package,
      identity_package: e.identity_package,
      consensus_manager_package: e.consensus_manager_package,
      access_controller_package: e.access_controller_package,
      transaction_processor_package: e.transaction_processor_package,
      metadata_module_package: e.metadata_module_package,
      royalty_module_package: e.royalty_module_package,
      access_rules_package: e.access_rules_package,
      genesis_helper_package: e.genesis_helper_package,
      faucet_package: e.faucet_package,
      consensus_manager: e.consensus_manager,
      genesis_helper: e.genesis_helper,
      faucet: e.faucet,
      pool_package: e.pool_package,
      transaction_tracker: e.transaction_tracker
    };
}
function dO(e) {
  let t = !0;
  return t = t && "network_id" in e, t = t && "network_name" in e, t = t && "well_known_addresses" in e, t;
}
function bo(e) {
  return No(e);
}
function No(e, t) {
  return e == null ? e : {
    network_id: e.network_id,
    network_name: e.network_name,
    well_known_addresses: go(e.well_known_addresses)
  };
}
function fO(e) {
  if (e !== void 0)
    return e === null ? null : {
      network_id: e.network_id,
      network_name: e.network_name,
      well_known_addresses: Oo(e.well_known_addresses)
    };
}
const _O = {
  String: "String",
  Integer: "Integer",
  Bytes: "Bytes",
  Ruid: "Ruid"
};
function X(e) {
  return Fo(e);
}
function Fo(e, t) {
  return e;
}
function mO(e) {
  return e;
}
function yO(e) {
  let t = !0;
  return t = t && "items" in e, t;
}
function Kt(e) {
  return ho(e);
}
function ho(e, t) {
  return e == null ? e : {
    total_count: n(e, "total_count") ? e.total_count : void 0,
    next_cursor: n(e, "next_cursor") ? e.next_cursor : void 0,
    items: e.items
  };
}
function Lt(e) {
  if (e !== void 0)
    return e === null ? null : {
      total_count: e.total_count,
      next_cursor: e.next_cursor,
      items: e.items
    };
}
function pO(e) {
  let t = !0;
  return t = t && "items" in e, t;
}
function gO(e) {
  return Ao(e);
}
function Ao(e, t) {
  return e == null ? e : {
    items: e.items
  };
}
function SO(e) {
  if (e !== void 0)
    return e === null ? null : {
      items: e.items
    };
}
const OO = {
  Global: "Global"
};
function bO(e) {
  let t = !0;
  return t = t && "aggregation_level" in e, t = t && "resource_address" in e, t = t && "amount" in e, t = t && "last_updated_at_state_version" in e, t;
}
function NO(e) {
  return Bt(e);
}
function Bt(e, t) {
  return e == null ? e : {
    aggregation_level: e.aggregation_level,
    resource_address: e.resource_address,
    explicit_metadata: n(e, "explicit_metadata") ? N(e.explicit_metadata) : void 0,
    amount: e.amount,
    last_updated_at_state_version: e.last_updated_at_state_version
  };
}
function Io(e) {
  if (e !== void 0)
    return e === null ? null : {
      aggregation_level: e.aggregation_level,
      resource_address: e.resource_address,
      explicit_metadata: F(e.explicit_metadata),
      amount: e.amount,
      last_updated_at_state_version: e.last_updated_at_state_version
    };
}
function FO(e) {
  let t = !0;
  return t = t && "total_count" in e, t = t && "vault_address" in e, t = t && "last_updated_at_state_version" in e, t;
}
function q(e) {
  return To(e);
}
function To(e, t) {
  return e == null ? e : {
    total_count: e.total_count,
    next_cursor: n(e, "next_cursor") ? e.next_cursor : void 0,
    items: n(e, "items") ? e.items : void 0,
    vault_address: e.vault_address,
    last_updated_at_state_version: e.last_updated_at_state_version
  };
}
function U(e) {
  if (e !== void 0)
    return e === null ? null : {
      total_count: e.total_count,
      next_cursor: e.next_cursor,
      items: e.items,
      vault_address: e.vault_address,
      last_updated_at_state_version: e.last_updated_at_state_version
    };
}
function hO(e) {
  let t = !0;
  return t = t && "items" in e, t;
}
function Gt(e) {
  return Jo(e);
}
function Jo(e, t) {
  return e == null ? e : {
    total_count: n(e, "total_count") ? e.total_count : void 0,
    next_cursor: n(e, "next_cursor") ? e.next_cursor : void 0,
    items: e.items.map(q)
  };
}
function Ht(e) {
  if (e !== void 0)
    return e === null ? null : {
      total_count: e.total_count,
      next_cursor: e.next_cursor,
      items: e.items.map(U)
    };
}
const AO = {
  Vault: "Vault"
};
function IO(e) {
  let t = !0;
  return t = t && "aggregation_level" in e, t = t && "resource_address" in e, t = t && "vaults" in e, t;
}
function TO(e) {
  return $t(e);
}
function $t(e, t) {
  return e == null ? e : {
    aggregation_level: e.aggregation_level,
    resource_address: e.resource_address,
    explicit_metadata: n(e, "explicit_metadata") ? N(e.explicit_metadata) : void 0,
    vaults: Gt(e.vaults)
  };
}
function vo(e) {
  if (e !== void 0)
    return e === null ? null : {
      aggregation_level: e.aggregation_level,
      resource_address: e.resource_address,
      explicit_metadata: F(e.explicit_metadata),
      vaults: Ht(e.vaults)
    };
}
function oe(e) {
  return Vo(e);
}
function Vo(e, t) {
  if (e == null)
    return e;
  switch (e.aggregation_level) {
    case "Global":
      return { ...Bt(e), aggregation_level: "Global" };
    case "Vault":
      return { ...$t(e), aggregation_level: "Vault" };
    default:
      throw new Error(`No variant of NonFungibleResourcesCollectionItem exists with 'aggregation_level=${e.aggregation_level}'`);
  }
}
function ue(e) {
  if (e !== void 0) {
    if (e === null)
      return null;
    switch (e.aggregation_level) {
      case "Global":
        return Io(e);
      case "Vault":
        return vo(e);
      default:
        throw new Error(`No variant of NonFungibleResourcesCollectionItem exists with 'aggregation_level=${e.aggregation_level}'`);
    }
  }
}
function JO(e) {
  let t = !0;
  return t = t && "items" in e, t;
}
function Ro(e) {
  return ko(e);
}
function ko(e, t) {
  return e == null ? e : {
    total_count: n(e, "total_count") ? e.total_count : void 0,
    next_cursor: n(e, "next_cursor") ? e.next_cursor : void 0,
    items: e.items.map(oe)
  };
}
function Eo(e) {
  if (e !== void 0)
    return e === null ? null : {
      total_count: e.total_count,
      next_cursor: e.next_cursor,
      items: e.items.map(ue)
    };
}
function vO(e) {
  let t = !0;
  return t = t && "items" in e, t;
}
function VO(e) {
  return Do(e);
}
function Do(e, t) {
  return e == null ? e : {
    items: e.items.map(oe)
  };
}
function RO(e) {
  if (e !== void 0)
    return e === null ? null : {
      items: e.items.map(ue)
    };
}
function kO(e) {
  let t = !0;
  return t = t && "aggregation_level" in e, t = t && "resource_address" in e, t;
}
function EO(e) {
  return Po(e);
}
function Po(e, t) {
  return e == null ? e : {
    aggregation_level: A(e.aggregation_level),
    resource_address: e.resource_address,
    explicit_metadata: n(e, "explicit_metadata") ? N(e.explicit_metadata) : void 0
  };
}
function DO(e) {
  if (e !== void 0)
    return e === null ? null : {
      aggregation_level: e.aggregation_level,
      resource_address: e.resource_address,
      explicit_metadata: F(e.explicit_metadata)
    };
}
const PO = {
  Global: "Global"
};
function wO(e) {
  let t = !0;
  return t = t && "amount" in e, t = t && "last_updated_at_state_version" in e, t;
}
function MO(e) {
  return wo(e);
}
function wo(e, t) {
  return e == null ? e : {
    amount: e.amount,
    last_updated_at_state_version: e.last_updated_at_state_version,
    aggregation_level: n(e, "aggregation_level") ? e.aggregation_level : void 0
  };
}
function xO(e) {
  if (e !== void 0)
    return e === null ? null : {
      amount: e.amount,
      last_updated_at_state_version: e.last_updated_at_state_version,
      aggregation_level: e.aggregation_level
    };
}
const CO = {
  Vault: "Vault"
};
function qO(e) {
  let t = !0;
  return t = t && "vaults" in e, t;
}
function UO(e) {
  return Mo(e);
}
function Mo(e, t) {
  return e == null ? e : {
    vaults: Gt(e.vaults),
    aggregation_level: n(e, "aggregation_level") ? e.aggregation_level : void 0
  };
}
function KO(e) {
  if (e !== void 0)
    return e === null ? null : {
      vaults: Ht(e.vaults),
      aggregation_level: e.aggregation_level
    };
}
function LO(e) {
  let t = !0;
  return t = t && "items" in e, t;
}
function BO(e) {
  return xo(e);
}
function xo(e, t) {
  return e == null ? e : {
    items: e.items.map(q)
  };
}
function GO(e) {
  if (e !== void 0)
    return e === null ? null : {
      items: e.items.map(U)
    };
}
function HO(e) {
  let t = !0;
  return t = t && "vault_address" in e, t = t && "total_count" in e, t = t && "last_updated_at_state_version" in e, t;
}
function $O(e) {
  return Co(e);
}
function Co(e, t) {
  return e == null ? e : {
    vault_address: e.vault_address,
    total_count: e.total_count,
    last_updated_at_state_version: e.last_updated_at_state_version
  };
}
function WO(e) {
  if (e !== void 0)
    return e === null ? null : {
      vault_address: e.vault_address,
      total_count: e.total_count,
      last_updated_at_state_version: e.last_updated_at_state_version
    };
}
const zO = {
  NotSyncedUpError: "NotSyncedUpError"
};
function XO(e) {
  let t = !0;
  return t = t && "request_type" in e, t = t && "current_sync_delay_seconds" in e, t = t && "max_allowed_sync_delay_seconds" in e, t;
}
function ZO(e) {
  return qo(e);
}
function qo(e, t) {
  return e == null ? e : {
    request_type: e.request_type,
    current_sync_delay_seconds: e.current_sync_delay_seconds,
    max_allowed_sync_delay_seconds: e.max_allowed_sync_delay_seconds,
    type: n(e, "type") ? e.type : void 0
  };
}
function QO(e) {
  if (e !== void 0)
    return e === null ? null : {
      request_type: e.request_type,
      current_sync_delay_seconds: e.current_sync_delay_seconds,
      max_allowed_sync_delay_seconds: e.max_allowed_sync_delay_seconds,
      type: e.type
    };
}
function YO(e) {
  return !0;
}
function jO(e) {
  return Uo(e);
}
function Uo(e, t) {
  return e == null ? e : {
    total_count: n(e, "total_count") ? e.total_count : void 0,
    next_cursor: n(e, "next_cursor") ? e.next_cursor : void 0,
    items: n(e, "items") ? e.items : void 0
  };
}
function eb(e) {
  if (e !== void 0)
    return e === null ? null : {
      total_count: e.total_count,
      next_cursor: e.next_cursor,
      items: e.items
    };
}
function tb(e) {
  return !0;
}
function nb(e) {
  return Ko(e);
}
function Ko(e, t) {
  return e == null ? e : {
    items: n(e, "items") ? e.items : void 0
  };
}
function rb(e) {
  if (e !== void 0)
    return e === null ? null : {
      items: e.items
    };
}
const ib = {
  Native: "Native",
  ScryptoV1: "ScryptoV1"
};
function le(e) {
  return Lo(e);
}
function Lo(e, t) {
  return e;
}
function ab(e) {
  return e;
}
function ob(e) {
  let t = !0;
  return t = t && "vm_type" in e, t = t && "code_hash_hex" in e, t = t && "code_hex" in e, t;
}
function Wt(e) {
  return Bo(e);
}
function Bo(e, t) {
  return e == null ? e : {
    vm_type: le(e.vm_type),
    code_hash_hex: e.code_hash_hex,
    code_hex: e.code_hex
  };
}
function zt(e) {
  if (e !== void 0)
    return e === null ? null : {
      vm_type: e.vm_type,
      code_hash_hex: e.code_hash_hex,
      code_hex: e.code_hex
    };
}
const ub = {
  Array: "Array"
};
function lb(e) {
  let t = !0;
  return t = t && "element_kind" in e, t = t && "elements" in e, t;
}
function sb(e) {
  return Go(e);
}
function Go(e, t) {
  return e == null ? e : {
    element_kind: b(e.element_kind),
    element_type_name: n(e, "element_type_name") ? e.element_type_name : void 0,
    elements: e.elements.map(p),
    kind: n(e, "kind") ? e.kind : void 0
  };
}
function cb(e) {
  if (e !== void 0)
    return e === null ? null : {
      element_kind: e.element_kind,
      element_type_name: e.element_type_name,
      elements: e.elements.map(g),
      kind: e.kind
    };
}
function db(e) {
  let t = !0;
  return t = t && "kind" in e, t;
}
function fb(e) {
  return Ho(e);
}
function Ho(e, t) {
  return e == null ? e : {
    kind: b(e.kind),
    type_name: n(e, "type_name") ? e.type_name : void 0,
    field_name: n(e, "field_name") ? e.field_name : void 0
  };
}
function _b(e) {
  if (e !== void 0)
    return e === null ? null : {
      kind: e.kind,
      type_name: e.type_name,
      field_name: e.field_name
    };
}
const mb = {
  Bool: "Bool"
};
function yb(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function pb(e) {
  return $o(e);
}
function $o(e, t) {
  return e == null ? e : {
    value: e.value,
    kind: n(e, "kind") ? e.kind : void 0
  };
}
function gb(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      kind: e.kind
    };
}
const Sb = {
  Bytes: "Bytes"
};
function Ob(e) {
  let t = !0;
  return t = t && "element_kind" in e, t = t && "hex" in e, t;
}
function bb(e) {
  return Wo(e);
}
function Wo(e, t) {
  return e == null ? e : {
    element_kind: b(e.element_kind),
    element_type_name: n(e, "element_type_name") ? e.element_type_name : void 0,
    hex: e.hex,
    kind: n(e, "kind") ? e.kind : void 0
  };
}
function Nb(e) {
  if (e !== void 0)
    return e === null ? null : {
      element_kind: e.element_kind,
      element_type_name: e.element_type_name,
      hex: e.hex,
      kind: e.kind
    };
}
const Fb = {
  Decimal: "Decimal"
};
function hb(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function Ab(e) {
  return zo(e);
}
function zo(e, t) {
  return e == null ? e : {
    value: e.value,
    kind: n(e, "kind") ? e.kind : void 0
  };
}
function Ib(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      kind: e.kind
    };
}
const Tb = {
  Enum: "Enum"
};
function Jb(e) {
  let t = !0;
  return t = t && "variant_id" in e, t = t && "fields" in e, t;
}
function vb(e) {
  return Xo(e);
}
function Xo(e, t) {
  return e == null ? e : {
    variant_id: e.variant_id,
    variant_name: n(e, "variant_name") ? e.variant_name : void 0,
    fields: e.fields.map(p),
    kind: n(e, "kind") ? e.kind : void 0
  };
}
function Vb(e) {
  if (e !== void 0)
    return e === null ? null : {
      variant_id: e.variant_id,
      variant_name: e.variant_name,
      fields: e.fields.map(g),
      kind: e.kind
    };
}
const Rb = {
  I128: "I128"
};
function kb(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function Eb(e) {
  return Zo(e);
}
function Zo(e, t) {
  return e == null ? e : {
    value: e.value,
    kind: n(e, "kind") ? e.kind : void 0
  };
}
function Db(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      kind: e.kind
    };
}
const Pb = {
  I16: "I16"
};
function wb(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function Mb(e) {
  return Qo(e);
}
function Qo(e, t) {
  return e == null ? e : {
    value: e.value,
    kind: n(e, "kind") ? e.kind : void 0
  };
}
function xb(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      kind: e.kind
    };
}
const Cb = {
  I32: "I32"
};
function qb(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function Ub(e) {
  return Yo(e);
}
function Yo(e, t) {
  return e == null ? e : {
    value: e.value,
    kind: n(e, "kind") ? e.kind : void 0
  };
}
function Kb(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      kind: e.kind
    };
}
const Lb = {
  I64: "I64"
};
function Bb(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function Gb(e) {
  return jo(e);
}
function jo(e, t) {
  return e == null ? e : {
    value: e.value,
    kind: n(e, "kind") ? e.kind : void 0
  };
}
function Hb(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      kind: e.kind
    };
}
const $b = {
  I8: "I8"
};
function Wb(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function zb(e) {
  return eu(e);
}
function eu(e, t) {
  return e == null ? e : {
    value: e.value,
    kind: n(e, "kind") ? e.kind : void 0
  };
}
function Xb(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      kind: e.kind
    };
}
const Zb = {
  Map: "Map"
};
function Qb(e) {
  let t = !0;
  return t = t && "key_kind" in e, t = t && "value_kind" in e, t = t && "entries" in e, t;
}
function Yb(e) {
  return tu(e);
}
function tu(e, t) {
  return e == null ? e : {
    key_kind: b(e.key_kind),
    key_type_name: n(e, "key_type_name") ? e.key_type_name : void 0,
    value_kind: b(e.value_kind),
    value_type_name: n(e, "value_type_name") ? e.value_type_name : void 0,
    entries: e.entries.map(Te),
    kind: n(e, "kind") ? e.kind : void 0
  };
}
function jb(e) {
  if (e !== void 0)
    return e === null ? null : {
      key_kind: e.key_kind,
      key_type_name: e.key_type_name,
      value_kind: e.value_kind,
      value_type_name: e.value_type_name,
      entries: e.entries.map(Je),
      kind: e.kind
    };
}
const eN = {
  NonFungibleLocalId: "NonFungibleLocalId"
};
function tN(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function nN(e) {
  return nu(e);
}
function nu(e, t) {
  return e == null ? e : {
    value: e.value,
    kind: n(e, "kind") ? e.kind : void 0
  };
}
function rN(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      kind: e.kind
    };
}
const iN = {
  Own: "Own"
};
function aN(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function oN(e) {
  return ru(e);
}
function ru(e, t) {
  return e == null ? e : {
    value: e.value,
    kind: n(e, "kind") ? e.kind : void 0
  };
}
function uN(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      kind: e.kind
    };
}
const lN = {
  PreciseDecimal: "PreciseDecimal"
};
function sN(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function cN(e) {
  return iu(e);
}
function iu(e, t) {
  return e == null ? e : {
    value: e.value,
    kind: n(e, "kind") ? e.kind : void 0
  };
}
function dN(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      kind: e.kind
    };
}
const fN = {
  Reference: "Reference"
};
function _N(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function mN(e) {
  return au(e);
}
function au(e, t) {
  return e == null ? e : {
    value: e.value,
    kind: n(e, "kind") ? e.kind : void 0
  };
}
function yN(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      kind: e.kind
    };
}
const pN = {
  String: "String"
};
function gN(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function SN(e) {
  return ou(e);
}
function ou(e, t) {
  return e == null ? e : {
    value: e.value,
    kind: n(e, "kind") ? e.kind : void 0
  };
}
function ON(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      kind: e.kind
    };
}
const bN = {
  Tuple: "Tuple"
};
function NN(e) {
  let t = !0;
  return t = t && "fields" in e, t;
}
function FN(e) {
  return uu(e);
}
function uu(e, t) {
  return e == null ? e : {
    fields: e.fields.map(p),
    kind: n(e, "kind") ? e.kind : void 0
  };
}
function hN(e) {
  if (e !== void 0)
    return e === null ? null : {
      fields: e.fields.map(g),
      kind: e.kind
    };
}
const AN = {
  U128: "U128"
};
function IN(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function TN(e) {
  return lu(e);
}
function lu(e, t) {
  return e == null ? e : {
    value: e.value,
    kind: n(e, "kind") ? e.kind : void 0
  };
}
function JN(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      kind: e.kind
    };
}
const vN = {
  U16: "U16"
};
function VN(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function RN(e) {
  return su(e);
}
function su(e, t) {
  return e == null ? e : {
    value: e.value,
    kind: n(e, "kind") ? e.kind : void 0
  };
}
function kN(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      kind: e.kind
    };
}
const EN = {
  U32: "U32"
};
function DN(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function PN(e) {
  return cu(e);
}
function cu(e, t) {
  return e == null ? e : {
    value: e.value,
    kind: n(e, "kind") ? e.kind : void 0
  };
}
function wN(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      kind: e.kind
    };
}
const MN = {
  U64: "U64"
};
function xN(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function CN(e) {
  return du(e);
}
function du(e, t) {
  return e == null ? e : {
    value: e.value,
    kind: n(e, "kind") ? e.kind : void 0
  };
}
function qN(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      kind: e.kind
    };
}
const UN = {
  U8: "U8"
};
function KN(e) {
  let t = !0;
  return t = t && "value" in e, t;
}
function LN(e) {
  return fu(e);
}
function fu(e, t) {
  return e == null ? e : {
    value: e.value,
    kind: n(e, "kind") ? e.kind : void 0
  };
}
function BN(e) {
  if (e !== void 0)
    return e === null ? null : {
      value: e.value,
      kind: e.kind
    };
}
const GN = {
  EcdsaSecp256k1: "EcdsaSecp256k1",
  EddsaEd25519: "EddsaEd25519"
};
function _u(e) {
  return mu(e);
}
function mu(e, t) {
  return e;
}
function HN(e) {
  return e;
}
function $N(e) {
  let t = !0;
  return t = t && "key_type" in e, t;
}
function WN(e) {
  return yu(e);
}
function yu(e, t) {
  return e == null ? e : {
    key_type: _u(e.key_type)
  };
}
function zN(e) {
  if (e !== void 0)
    return e === null ? null : {
      key_type: e.key_type
    };
}
const XN = {
  EcdsaSecp256k1: "EcdsaSecp256k1"
};
function ZN(e) {
  let t = !0;
  return t = t && "key_hex" in e, t;
}
function QN(e) {
  return pu(e);
}
function pu(e, t) {
  return e == null ? e : {
    key_hex: e.key_hex,
    key_type: n(e, "key_type") ? e.key_type : void 0
  };
}
function YN(e) {
  if (e !== void 0)
    return e === null ? null : {
      key_hex: e.key_hex,
      key_type: e.key_type
    };
}
const jN = {
  EddsaEd25519: "EddsaEd25519"
};
function e0(e) {
  let t = !0;
  return t = t && "key_hex" in e, t;
}
function t0(e) {
  return gu(e);
}
function gu(e, t) {
  return e == null ? e : {
    key_hex: e.key_hex,
    key_type: n(e, "key_type") ? e.key_type : void 0
  };
}
function n0(e) {
  if (e !== void 0)
    return e === null ? null : {
      key_hex: e.key_hex,
      key_type: e.key_type
    };
}
const r0 = {
  EcdsaSecp256k1: "EcdsaSecp256k1",
  EddsaEd25519: "EddsaEd25519"
};
function Su(e) {
  return Ou(e);
}
function Ou(e, t) {
  return e;
}
function i0(e) {
  return e;
}
function a0(e) {
  let t = !0;
  return t = t && "key_hash_type" in e, t;
}
function o0(e) {
  return bu(e);
}
function bu(e, t) {
  return e == null ? e : {
    key_hash_type: Su(e.key_hash_type)
  };
}
function u0(e) {
  if (e !== void 0)
    return e === null ? null : {
      key_hash_type: e.key_hash_type
    };
}
const l0 = {
  EcdsaSecp256k1: "EcdsaSecp256k1"
};
function s0(e) {
  let t = !0;
  return t = t && "hash_hex" in e, t;
}
function c0(e) {
  return Nu(e);
}
function Nu(e, t) {
  return e == null ? e : {
    hash_hex: e.hash_hex,
    key_hash_type: n(e, "key_hash_type") ? e.key_hash_type : void 0
  };
}
function d0(e) {
  if (e !== void 0)
    return e === null ? null : {
      hash_hex: e.hash_hex,
      key_hash_type: e.key_hash_type
    };
}
const f0 = {
  EddsaEd25519: "EddsaEd25519"
};
function _0(e) {
  let t = !0;
  return t = t && "hash_hex" in e, t;
}
function m0(e) {
  return Fu(e);
}
function Fu(e, t) {
  return e == null ? e : {
    hash_hex: e.hash_hex,
    key_hash_type: n(e, "key_hash_type") ? e.key_hash_type : void 0
  };
}
function y0(e) {
  if (e !== void 0)
    return e === null ? null : {
      hash_hex: e.hash_hex,
      key_hash_type: e.key_hash_type
    };
}
function p0(e) {
  return !0;
}
function g0(e) {
  return hu(e);
}
function hu(e, t) {
  return e == null ? e : {
    total_count: n(e, "total_count") ? e.total_count : void 0,
    next_cursor: n(e, "next_cursor") ? e.next_cursor : void 0
  };
}
function S0(e) {
  if (e !== void 0)
    return e === null ? null : {
      total_count: e.total_count,
      next_cursor: e.next_cursor
    };
}
function O0(e) {
  let t = !0;
  return t = t && "raw_hex" in e, t = t && "programmatic_json" in e, t;
}
function Y(e) {
  return Au(e);
}
function Au(e, t) {
  return e == null ? e : {
    raw_hex: e.raw_hex,
    programmatic_json: p(e.programmatic_json)
  };
}
function j(e) {
  if (e !== void 0)
    return e === null ? null : {
      raw_hex: e.raw_hex,
      programmatic_json: g(e.programmatic_json)
    };
}
function b0(e) {
  return !0;
}
function Xt(e) {
  return Iu(e);
}
function Iu(e, t) {
  return e == null ? e : {
    ancestor_identities: n(e, "ancestor_identities") ? e.ancestor_identities : void 0,
    component_royalty_vault_balance: n(e, "component_royalty_vault_balance") ? e.component_royalty_vault_balance : void 0,
    package_royalty_vault_balance: n(e, "package_royalty_vault_balance") ? e.package_royalty_vault_balance : void 0,
    non_fungible_include_nfids: n(e, "non_fungible_include_nfids") ? e.non_fungible_include_nfids : void 0,
    explicit_metadata: n(e, "explicit_metadata") ? e.explicit_metadata : void 0
  };
}
function Zt(e) {
  if (e !== void 0)
    return e === null ? null : {
      ancestor_identities: e.ancestor_identities,
      component_royalty_vault_balance: e.component_royalty_vault_balance,
      package_royalty_vault_balance: e.package_royalty_vault_balance,
      non_fungible_include_nfids: e.non_fungible_include_nfids,
      explicit_metadata: e.explicit_metadata
    };
}
function N0(e) {
  let t = !0;
  return t = t && "addresses" in e, t;
}
function F0(e) {
  return Tu(e);
}
function Tu(e, t) {
  return e == null ? e : {
    at_ledger_state: n(e, "at_ledger_state") ? c(e.at_ledger_state) : void 0,
    opt_ins: n(e, "opt_ins") ? Xt(e.opt_ins) : void 0,
    addresses: e.addresses,
    aggregation_level: n(e, "aggregation_level") ? A(e.aggregation_level) : void 0
  };
}
function Ju(e) {
  if (e !== void 0)
    return e === null ? null : {
      at_ledger_state: d(e.at_ledger_state),
      opt_ins: Zt(e.opt_ins),
      addresses: e.addresses,
      aggregation_level: e.aggregation_level
    };
}
function h0(e) {
  let t = !0;
  return t = t && "addresses" in e, t;
}
function A0(e) {
  return vu(e);
}
function vu(e, t) {
  return e == null ? e : {
    opt_ins: n(e, "opt_ins") ? Xt(e.opt_ins) : void 0,
    addresses: e.addresses,
    aggregation_level: n(e, "aggregation_level") ? A(e.aggregation_level) : void 0
  };
}
function I0(e) {
  if (e !== void 0)
    return e === null ? null : {
      opt_ins: Zt(e.opt_ins),
      addresses: e.addresses,
      aggregation_level: e.aggregation_level
    };
}
function T0(e) {
  return !0;
}
function Vu(e) {
  return Ru(e);
}
function Ru(e, t) {
  return e == null ? e : {
    parent_address: n(e, "parent_address") ? e.parent_address : void 0,
    owner_address: n(e, "owner_address") ? e.owner_address : void 0,
    global_address: n(e, "global_address") ? e.global_address : void 0
  };
}
function ku(e) {
  if (e !== void 0)
    return e === null ? null : {
      parent_address: e.parent_address,
      owner_address: e.owner_address,
      global_address: e.global_address
    };
}
const J0 = {
  Component: "Component"
};
function v0(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "blueprint_name" in e, t = t && "blueprint_version" in e, t;
}
function V0(e) {
  return Qt(e);
}
function Qt(e, t) {
  return e == null ? e : {
    type: e.type,
    package_address: n(e, "package_address") ? e.package_address : void 0,
    blueprint_name: e.blueprint_name,
    blueprint_version: e.blueprint_version,
    state: n(e, "state") ? e.state : void 0,
    role_assignments: n(e, "role_assignments") ? v(e.role_assignments) : void 0,
    royalty_vault_balance: n(e, "royalty_vault_balance") ? e.royalty_vault_balance : void 0
  };
}
function Eu(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      package_address: e.package_address,
      blueprint_name: e.blueprint_name,
      blueprint_version: e.blueprint_version,
      state: e.state,
      role_assignments: V(e.role_assignments),
      royalty_vault_balance: e.royalty_vault_balance
    };
}
const R0 = {
  FungibleResource: "FungibleResource"
};
function k0(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "role_assignments" in e, t = t && "divisibility" in e, t = t && "total_supply" in e, t = t && "total_minted" in e, t = t && "total_burned" in e, t;
}
function E0(e) {
  return Yt(e);
}
function Yt(e, t) {
  return e == null ? e : {
    type: e.type,
    role_assignments: v(e.role_assignments),
    divisibility: e.divisibility,
    total_supply: e.total_supply,
    total_minted: e.total_minted,
    total_burned: e.total_burned
  };
}
function Du(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      role_assignments: V(e.role_assignments),
      divisibility: e.divisibility,
      total_supply: e.total_supply,
      total_minted: e.total_minted,
      total_burned: e.total_burned
    };
}
const D0 = {
  FungibleVault: "FungibleVault"
};
function P0(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "resource_address" in e, t = t && "balance" in e, t;
}
function w0(e) {
  return jt(e);
}
function jt(e, t) {
  return e == null ? e : {
    type: e.type,
    resource_address: e.resource_address,
    balance: x(e.balance)
  };
}
function Pu(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      resource_address: e.resource_address,
      balance: C(e.balance)
    };
}
const M0 = {
  NonFungibleResource: "NonFungibleResource"
};
function x0(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "role_assignments" in e, t = t && "non_fungible_id_type" in e, t = t && "total_supply" in e, t = t && "total_minted" in e, t = t && "total_burned" in e, t;
}
function C0(e) {
  return en(e);
}
function en(e, t) {
  return e == null ? e : {
    type: e.type,
    role_assignments: v(e.role_assignments),
    non_fungible_id_type: X(e.non_fungible_id_type),
    total_supply: e.total_supply,
    total_minted: e.total_minted,
    total_burned: e.total_burned
  };
}
function wu(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      role_assignments: V(e.role_assignments),
      non_fungible_id_type: e.non_fungible_id_type,
      total_supply: e.total_supply,
      total_minted: e.total_minted,
      total_burned: e.total_burned
    };
}
const q0 = {
  NonFungibleVault: "NonFungibleVault"
};
function U0(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "resource_address" in e, t = t && "balance" in e, t;
}
function K0(e) {
  return tn(e);
}
function tn(e, t) {
  return e == null ? e : {
    type: e.type,
    resource_address: e.resource_address,
    balance: q(e.balance)
  };
}
function Mu(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      resource_address: e.resource_address,
      balance: U(e.balance)
    };
}
function L0(e) {
  let t = !0;
  return t = t && "name" in e, t = t && "version" in e, t = t && "definition" in e, t;
}
function nn(e) {
  return xu(e);
}
function xu(e, t) {
  return e == null ? e : {
    name: e.name,
    version: e.version,
    definition: e.definition,
    dependant_entities: n(e, "dependant_entities") ? e.dependant_entities : void 0,
    auth_template: n(e, "auth_template") ? e.auth_template : void 0,
    auth_template_is_locked: n(e, "auth_template_is_locked") ? e.auth_template_is_locked : void 0,
    royalty_config: n(e, "royalty_config") ? e.royalty_config : void 0,
    royalty_config_is_locked: n(e, "royalty_config_is_locked") ? e.royalty_config_is_locked : void 0
  };
}
function rn(e) {
  if (e !== void 0)
    return e === null ? null : {
      name: e.name,
      version: e.version,
      definition: e.definition,
      dependant_entities: e.dependant_entities,
      auth_template: e.auth_template,
      auth_template_is_locked: e.auth_template_is_locked,
      royalty_config: e.royalty_config,
      royalty_config_is_locked: e.royalty_config_is_locked
    };
}
function B0(e) {
  let t = !0;
  return t = t && "items" in e, t;
}
function an(e) {
  return Cu(e);
}
function Cu(e, t) {
  return e == null ? e : {
    total_count: n(e, "total_count") ? e.total_count : void 0,
    next_cursor: n(e, "next_cursor") ? e.next_cursor : void 0,
    items: e.items.map(nn)
  };
}
function on(e) {
  if (e !== void 0)
    return e === null ? null : {
      total_count: e.total_count,
      next_cursor: e.next_cursor,
      items: e.items.map(rn)
    };
}
function G0(e) {
  let t = !0;
  return t = t && "items" in e, t;
}
function un(e) {
  return qu(e);
}
function qu(e, t) {
  return e == null ? e : {
    total_count: n(e, "total_count") ? e.total_count : void 0,
    next_cursor: n(e, "next_cursor") ? e.next_cursor : void 0,
    items: e.items.map(Wt)
  };
}
function ln(e) {
  if (e !== void 0)
    return e === null ? null : {
      total_count: e.total_count,
      next_cursor: e.next_cursor,
      items: e.items.map(zt)
    };
}
function H0(e) {
  let t = !0;
  return t = t && "schema_hash_hex" in e, t = t && "schema_hex" in e, t;
}
function sn(e) {
  return Uu(e);
}
function Uu(e, t) {
  return e == null ? e : {
    schema_hash_hex: e.schema_hash_hex,
    schema_hex: e.schema_hex
  };
}
function cn(e) {
  if (e !== void 0)
    return e === null ? null : {
      schema_hash_hex: e.schema_hash_hex,
      schema_hex: e.schema_hex
    };
}
function $0(e) {
  let t = !0;
  return t = t && "items" in e, t;
}
function dn(e) {
  return Ku(e);
}
function Ku(e, t) {
  return e == null ? e : {
    total_count: n(e, "total_count") ? e.total_count : void 0,
    next_cursor: n(e, "next_cursor") ? e.next_cursor : void 0,
    items: e.items.map(sn)
  };
}
function fn(e) {
  if (e !== void 0)
    return e === null ? null : {
      total_count: e.total_count,
      next_cursor: e.next_cursor,
      items: e.items.map(cn)
    };
}
const W0 = {
  Package: "Package"
};
function z0(e) {
  let t = !0;
  return t = t && "type" in e, t = t && "codes" in e, t = t && "vm_type" in e, t = t && "code_hash_hex" in e, t = t && "code_hex" in e, t;
}
function X0(e) {
  return _n(e);
}
function _n(e, t) {
  return e == null ? e : {
    type: e.type,
    codes: un(e.codes),
    vm_type: le(e.vm_type),
    code_hash_hex: e.code_hash_hex,
    code_hex: e.code_hex,
    royalty_vault_balance: n(e, "royalty_vault_balance") ? e.royalty_vault_balance : void 0,
    blueprints: n(e, "blueprints") ? an(e.blueprints) : void 0,
    schemas: n(e, "schemas") ? dn(e.schemas) : void 0
  };
}
function Lu(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type,
      codes: ln(e.codes),
      vm_type: e.vm_type,
      code_hash_hex: e.code_hash_hex,
      code_hex: e.code_hex,
      royalty_vault_balance: e.royalty_vault_balance,
      blueprints: on(e.blueprints),
      schemas: fn(e.schemas)
    };
}
function Bu(e) {
  return Gu(e);
}
function Gu(e, t) {
  if (e == null)
    return e;
  switch (e.type) {
    case "Component":
      return { ...Qt(e), type: "Component" };
    case "FungibleResource":
      return { ...Yt(e), type: "FungibleResource" };
    case "FungibleVault":
      return { ...jt(e), type: "FungibleVault" };
    case "NonFungibleResource":
      return { ...en(e), type: "NonFungibleResource" };
    case "NonFungibleVault":
      return { ...tn(e), type: "NonFungibleVault" };
    case "Package":
      return { ..._n(e), type: "Package" };
    default:
      throw new Error(`No variant of StateEntityDetailsResponseItemDetails exists with 'type=${e.type}'`);
  }
}
function Hu(e) {
  if (e !== void 0) {
    if (e === null)
      return null;
    switch (e.type) {
      case "Component":
        return Eu(e);
      case "FungibleResource":
        return Du(e);
      case "FungibleVault":
        return Pu(e);
      case "NonFungibleResource":
        return wu(e);
      case "NonFungibleVault":
        return Mu(e);
      case "Package":
        return Lu(e);
      default:
        throw new Error(`No variant of StateEntityDetailsResponseItemDetails exists with 'type=${e.type}'`);
    }
  }
}
function Z0(e) {
  let t = !0;
  return t = t && "address" in e, t = t && "metadata" in e, t;
}
function mn(e) {
  return $u(e);
}
function $u(e, t) {
  return e == null ? e : {
    address: e.address,
    fungible_resources: n(e, "fungible_resources") ? _a(e.fungible_resources) : void 0,
    non_fungible_resources: n(e, "non_fungible_resources") ? Ro(e.non_fungible_resources) : void 0,
    ancestor_identities: n(e, "ancestor_identities") ? Vu(e.ancestor_identities) : void 0,
    metadata: N(e.metadata),
    explicit_metadata: n(e, "explicit_metadata") ? N(e.explicit_metadata) : void 0,
    details: n(e, "details") ? Bu(e.details) : void 0
  };
}
function yn(e) {
  if (e !== void 0)
    return e === null ? null : {
      address: e.address,
      fungible_resources: ya(e.fungible_resources),
      non_fungible_resources: Eo(e.non_fungible_resources),
      ancestor_identities: ku(e.ancestor_identities),
      metadata: F(e.metadata),
      explicit_metadata: F(e.explicit_metadata),
      details: Hu(e.details)
    };
}
function Q0(e) {
  let t = !0;
  return t = t && "ledger_state" in e, t = t && "items" in e, t;
}
function Wu(e) {
  return zu(e);
}
function zu(e, t) {
  return e == null ? e : {
    ledger_state: f(e.ledger_state),
    items: e.items.map(mn)
  };
}
function Y0(e) {
  if (e !== void 0)
    return e === null ? null : {
      ledger_state: _(e.ledger_state),
      items: e.items.map(yn)
    };
}
function j0(e) {
  let t = !0;
  return t = t && "items" in e, t;
}
function eF(e) {
  return Xu(e);
}
function Xu(e, t) {
  return e == null ? e : {
    items: e.items.map(mn)
  };
}
function tF(e) {
  if (e !== void 0)
    return e === null ? null : {
      items: e.items.map(yn)
    };
}
const nF = {
  Component: "Component"
};
function rF(e) {
  let t = !0;
  return t = t && "blueprint_name" in e, t = t && "blueprint_version" in e, t;
}
function iF(e) {
  return Zu(e);
}
function Zu(e, t) {
  return e == null ? e : {
    package_address: n(e, "package_address") ? e.package_address : void 0,
    blueprint_name: e.blueprint_name,
    blueprint_version: e.blueprint_version,
    state: n(e, "state") ? e.state : void 0,
    role_assignments: n(e, "role_assignments") ? v(e.role_assignments) : void 0,
    royalty_vault_balance: n(e, "royalty_vault_balance") ? e.royalty_vault_balance : void 0,
    type: n(e, "type") ? e.type : void 0
  };
}
function aF(e) {
  if (e !== void 0)
    return e === null ? null : {
      package_address: e.package_address,
      blueprint_name: e.blueprint_name,
      blueprint_version: e.blueprint_version,
      state: e.state,
      role_assignments: V(e.role_assignments),
      royalty_vault_balance: e.royalty_vault_balance,
      type: e.type
    };
}
const oF = {
  FungibleResource: "FungibleResource"
};
function uF(e) {
  let t = !0;
  return t = t && "role_assignments" in e, t = t && "divisibility" in e, t = t && "total_supply" in e, t = t && "total_minted" in e, t = t && "total_burned" in e, t;
}
function lF(e) {
  return Qu(e);
}
function Qu(e, t) {
  return e == null ? e : {
    role_assignments: v(e.role_assignments),
    divisibility: e.divisibility,
    total_supply: e.total_supply,
    total_minted: e.total_minted,
    total_burned: e.total_burned,
    type: n(e, "type") ? e.type : void 0
  };
}
function sF(e) {
  if (e !== void 0)
    return e === null ? null : {
      role_assignments: V(e.role_assignments),
      divisibility: e.divisibility,
      total_supply: e.total_supply,
      total_minted: e.total_minted,
      total_burned: e.total_burned,
      type: e.type
    };
}
const cF = {
  FungibleVault: "FungibleVault"
};
function dF(e) {
  let t = !0;
  return t = t && "resource_address" in e, t = t && "balance" in e, t;
}
function fF(e) {
  return Yu(e);
}
function Yu(e, t) {
  return e == null ? e : {
    resource_address: e.resource_address,
    balance: x(e.balance),
    type: n(e, "type") ? e.type : void 0
  };
}
function _F(e) {
  if (e !== void 0)
    return e === null ? null : {
      resource_address: e.resource_address,
      balance: C(e.balance),
      type: e.type
    };
}
const mF = {
  FungibleResource: "FungibleResource",
  NonFungibleResource: "NonFungibleResource",
  FungibleVault: "FungibleVault",
  NonFungibleVault: "NonFungibleVault",
  Package: "Package",
  Component: "Component"
};
function ju(e) {
  return el(e);
}
function el(e, t) {
  return e;
}
function yF(e) {
  return e;
}
function pF(e) {
  let t = !0;
  return t = t && "type" in e, t;
}
function gF(e) {
  return tl(e);
}
function tl(e, t) {
  return e == null ? e : {
    type: ju(e.type)
  };
}
function SF(e) {
  if (e !== void 0)
    return e === null ? null : {
      type: e.type
    };
}
const OF = {
  NonFungibleResource: "NonFungibleResource"
};
function bF(e) {
  let t = !0;
  return t = t && "role_assignments" in e, t = t && "non_fungible_id_type" in e, t = t && "total_supply" in e, t = t && "total_minted" in e, t = t && "total_burned" in e, t;
}
function NF(e) {
  return nl(e);
}
function nl(e, t) {
  return e == null ? e : {
    role_assignments: v(e.role_assignments),
    non_fungible_id_type: X(e.non_fungible_id_type),
    total_supply: e.total_supply,
    total_minted: e.total_minted,
    total_burned: e.total_burned,
    type: n(e, "type") ? e.type : void 0
  };
}
function FF(e) {
  if (e !== void 0)
    return e === null ? null : {
      role_assignments: V(e.role_assignments),
      non_fungible_id_type: e.non_fungible_id_type,
      total_supply: e.total_supply,
      total_minted: e.total_minted,
      total_burned: e.total_burned,
      type: e.type
    };
}
const hF = {
  NonFungibleVault: "NonFungibleVault"
};
function AF(e) {
  let t = !0;
  return t = t && "resource_address" in e, t = t && "balance" in e, t;
}
function IF(e) {
  return rl(e);
}
function rl(e, t) {
  return e == null ? e : {
    resource_address: e.resource_address,
    balance: q(e.balance),
    type: n(e, "type") ? e.type : void 0
  };
}
function TF(e) {
  if (e !== void 0)
    return e === null ? null : {
      resource_address: e.resource_address,
      balance: U(e.balance),
      type: e.type
    };
}
const JF = {
  Package: "Package"
};
function vF(e) {
  let t = !0;
  return t = t && "codes" in e, t = t && "vm_type" in e, t = t && "code_hash_hex" in e, t = t && "code_hex" in e, t;
}
function VF(e) {
  return il(e);
}
function il(e, t) {
  return e == null ? e : {
    codes: un(e.codes),
    vm_type: le(e.vm_type),
    code_hash_hex: e.code_hash_hex,
    code_hex: e.code_hex,
    royalty_vault_balance: n(e, "royalty_vault_balance") ? e.royalty_vault_balance : void 0,
    blueprints: n(e, "blueprints") ? an(e.blueprints) : void 0,
    schemas: n(e, "schemas") ? dn(e.schemas) : void 0,
    type: n(e, "type") ? e.type : void 0
  };
}
function RF(e) {
  if (e !== void 0)
    return e === null ? null : {
      codes: ln(e.codes),
      vm_type: e.vm_type,
      code_hash_hex: e.code_hash_hex,
      code_hex: e.code_hex,
      royalty_vault_balance: e.royalty_vault_balance,
      blueprints: on(e.blueprints),
      schemas: fn(e.schemas),
      type: e.type
    };
}
function kF(e) {
  let t = !0;
  return t = t && "items" in e, t;
}
function EF(e) {
  return al(e);
}
function al(e, t) {
  return e == null ? e : {
    items: e.items.map(nn)
  };
}
function DF(e) {
  if (e !== void 0)
    return e === null ? null : {
      items: e.items.map(rn)
    };
}
function PF(e) {
  let t = !0;
  return t = t && "items" in e, t;
}
function wF(e) {
  return ol(e);
}
function ol(e, t) {
  return e == null ? e : {
    items: e.items.map(Wt)
  };
}
function MF(e) {
  if (e !== void 0)
    return e === null ? null : {
      items: e.items.map(zt)
    };
}
function xF(e) {
  let t = !0;
  return t = t && "items" in e, t;
}
function CF(e) {
  return ul(e);
}
function ul(e, t) {
  return e == null ? e : {
    items: e.items.map(sn)
  };
}
function qF(e) {
  if (e !== void 0)
    return e === null ? null : {
      items: e.items.map(cn)
    };
}
function UF(e) {
  let t = !0;
  return t = t && "address" in e, t = t && "resource_address" in e, t;
}
function KF(e) {
  return ll(e);
}
function ll(e, t) {
  return e == null ? e : {
    at_ledger_state: n(e, "at_ledger_state") ? c(e.at_ledger_state) : void 0,
    cursor: n(e, "cursor") ? e.cursor : void 0,
    limit_per_page: n(e, "limit_per_page") ? e.limit_per_page : void 0,
    address: e.address,
    resource_address: e.resource_address
  };
}
function sl(e) {
  if (e !== void 0)
    return e === null ? null : {
      at_ledger_state: d(e.at_ledger_state),
      cursor: e.cursor,
      limit_per_page: e.limit_per_page,
      address: e.address,
      resource_address: e.resource_address
    };
}
function LF(e) {
  let t = !0;
  return t = t && "address" in e, t = t && "resource_address" in e, t;
}
function BF(e) {
  return cl(e);
}
function cl(e, t) {
  return e == null ? e : {
    address: e.address,
    resource_address: e.resource_address
  };
}
function GF(e) {
  if (e !== void 0)
    return e === null ? null : {
      address: e.address,
      resource_address: e.resource_address
    };
}
function HF(e) {
  let t = !0;
  return t = t && "ledger_state" in e, t = t && "items" in e, t = t && "address" in e, t = t && "resource_address" in e, t;
}
function dl(e) {
  return fl(e);
}
function fl(e, t) {
  return e == null ? e : {
    ledger_state: f(e.ledger_state),
    total_count: n(e, "total_count") ? e.total_count : void 0,
    next_cursor: n(e, "next_cursor") ? e.next_cursor : void 0,
    items: e.items.map(x),
    address: e.address,
    resource_address: e.resource_address
  };
}
function $F(e) {
  if (e !== void 0)
    return e === null ? null : {
      ledger_state: _(e.ledger_state),
      total_count: e.total_count,
      next_cursor: e.next_cursor,
      items: e.items.map(C),
      address: e.address,
      resource_address: e.resource_address
    };
}
function WF(e) {
  return !0;
}
function pn(e) {
  return _l(e);
}
function _l(e, t) {
  return e == null ? e : {
    explicit_metadata: n(e, "explicit_metadata") ? e.explicit_metadata : void 0
  };
}
function gn(e) {
  if (e !== void 0)
    return e === null ? null : {
      explicit_metadata: e.explicit_metadata
    };
}
function zF(e) {
  let t = !0;
  return t = t && "address" in e, t;
}
function XF(e) {
  return ml(e);
}
function ml(e, t) {
  return e == null ? e : {
    at_ledger_state: n(e, "at_ledger_state") ? c(e.at_ledger_state) : void 0,
    cursor: n(e, "cursor") ? e.cursor : void 0,
    limit_per_page: n(e, "limit_per_page") ? e.limit_per_page : void 0,
    address: e.address,
    aggregation_level: n(e, "aggregation_level") ? A(e.aggregation_level) : void 0,
    opt_ins: n(e, "opt_ins") ? pn(e.opt_ins) : void 0
  };
}
function yl(e) {
  if (e !== void 0)
    return e === null ? null : {
      at_ledger_state: d(e.at_ledger_state),
      cursor: e.cursor,
      limit_per_page: e.limit_per_page,
      address: e.address,
      aggregation_level: e.aggregation_level,
      opt_ins: gn(e.opt_ins)
    };
}
function ZF(e) {
  let t = !0;
  return t = t && "address" in e, t;
}
function QF(e) {
  return pl(e);
}
function pl(e, t) {
  return e == null ? e : {
    address: e.address,
    aggregation_level: n(e, "aggregation_level") ? A(e.aggregation_level) : void 0,
    opt_ins: n(e, "opt_ins") ? pn(e.opt_ins) : void 0
  };
}
function YF(e) {
  if (e !== void 0)
    return e === null ? null : {
      address: e.address,
      aggregation_level: e.aggregation_level,
      opt_ins: gn(e.opt_ins)
    };
}
function jF(e) {
  let t = !0;
  return t = t && "ledger_state" in e, t = t && "items" in e, t = t && "address" in e, t;
}
function gl(e) {
  return Sl(e);
}
function Sl(e, t) {
  return e == null ? e : {
    ledger_state: f(e.ledger_state),
    total_count: n(e, "total_count") ? e.total_count : void 0,
    next_cursor: n(e, "next_cursor") ? e.next_cursor : void 0,
    items: e.items.map(ie),
    address: e.address
  };
}
function eh(e) {
  if (e !== void 0)
    return e === null ? null : {
      ledger_state: _(e.ledger_state),
      total_count: e.total_count,
      next_cursor: e.next_cursor,
      items: e.items.map(ae),
      address: e.address
    };
}
function th(e) {
  let t = !0;
  return t = t && "address" in e, t;
}
function nh(e) {
  return Ol(e);
}
function Ol(e, t) {
  return e == null ? e : {
    at_ledger_state: n(e, "at_ledger_state") ? c(e.at_ledger_state) : void 0,
    cursor: n(e, "cursor") ? e.cursor : void 0,
    limit_per_page: n(e, "limit_per_page") ? e.limit_per_page : void 0,
    address: e.address
  };
}
function bl(e) {
  if (e !== void 0)
    return e === null ? null : {
      at_ledger_state: d(e.at_ledger_state),
      cursor: e.cursor,
      limit_per_page: e.limit_per_page,
      address: e.address
    };
}
function rh(e) {
  let t = !0;
  return t = t && "address" in e, t;
}
function ih(e) {
  return Nl(e);
}
function Nl(e, t) {
  return e == null ? e : {
    address: e.address
  };
}
function ah(e) {
  if (e !== void 0)
    return e === null ? null : {
      address: e.address
    };
}
function oh(e) {
  let t = !0;
  return t = t && "ledger_state" in e, t = t && "items" in e, t = t && "address" in e, t;
}
function Fl(e) {
  return hl(e);
}
function hl(e, t) {
  return e == null ? e : {
    ledger_state: f(e.ledger_state),
    total_count: n(e, "total_count") ? e.total_count : void 0,
    next_cursor: n(e, "next_cursor") ? e.next_cursor : void 0,
    items: e.items.map(ne),
    address: e.address
  };
}
function uh(e) {
  if (e !== void 0)
    return e === null ? null : {
      ledger_state: _(e.ledger_state),
      total_count: e.total_count,
      next_cursor: e.next_cursor,
      items: e.items.map(re),
      address: e.address
    };
}
function lh(e) {
  let t = !0;
  return t = t && "address" in e, t = t && "vault_address" in e, t = t && "resource_address" in e, t;
}
function sh(e) {
  return Al(e);
}
function Al(e, t) {
  return e == null ? e : {
    at_ledger_state: n(e, "at_ledger_state") ? c(e.at_ledger_state) : void 0,
    cursor: n(e, "cursor") ? e.cursor : void 0,
    limit_per_page: n(e, "limit_per_page") ? e.limit_per_page : void 0,
    address: e.address,
    vault_address: e.vault_address,
    resource_address: e.resource_address
  };
}
function Il(e) {
  if (e !== void 0)
    return e === null ? null : {
      at_ledger_state: d(e.at_ledger_state),
      cursor: e.cursor,
      limit_per_page: e.limit_per_page,
      address: e.address,
      vault_address: e.vault_address,
      resource_address: e.resource_address
    };
}
function ch(e) {
  let t = !0;
  return t = t && "address" in e, t = t && "vault_address" in e, t = t && "resource_address" in e, t;
}
function dh(e) {
  return Tl(e);
}
function Tl(e, t) {
  return e == null ? e : {
    address: e.address,
    vault_address: e.vault_address,
    resource_address: e.resource_address
  };
}
function fh(e) {
  if (e !== void 0)
    return e === null ? null : {
      address: e.address,
      vault_address: e.vault_address,
      resource_address: e.resource_address
    };
}
function _h(e) {
  let t = !0;
  return t = t && "ledger_state" in e, t = t && "items" in e, t = t && "address" in e, t = t && "resource_address" in e, t;
}
function Jl(e) {
  return vl(e);
}
function vl(e, t) {
  return e == null ? e : {
    ledger_state: f(e.ledger_state),
    total_count: n(e, "total_count") ? e.total_count : void 0,
    next_cursor: n(e, "next_cursor") ? e.next_cursor : void 0,
    items: e.items,
    address: e.address,
    resource_address: e.resource_address
  };
}
function mh(e) {
  if (e !== void 0)
    return e === null ? null : {
      ledger_state: _(e.ledger_state),
      total_count: e.total_count,
      next_cursor: e.next_cursor,
      items: e.items,
      address: e.address,
      resource_address: e.resource_address
    };
}
function yh(e) {
  return !0;
}
function Sn(e) {
  return Vl(e);
}
function Vl(e, t) {
  return e == null ? e : {
    non_fungible_include_nfids: n(e, "non_fungible_include_nfids") ? e.non_fungible_include_nfids : void 0
  };
}
function On(e) {
  if (e !== void 0)
    return e === null ? null : {
      non_fungible_include_nfids: e.non_fungible_include_nfids
    };
}
function ph(e) {
  let t = !0;
  return t = t && "address" in e, t = t && "resource_address" in e, t;
}
function gh(e) {
  return Rl(e);
}
function Rl(e, t) {
  return e == null ? e : {
    at_ledger_state: n(e, "at_ledger_state") ? c(e.at_ledger_state) : void 0,
    cursor: n(e, "cursor") ? e.cursor : void 0,
    limit_per_page: n(e, "limit_per_page") ? e.limit_per_page : void 0,
    address: e.address,
    resource_address: e.resource_address,
    opt_ins: n(e, "opt_ins") ? Sn(e.opt_ins) : void 0
  };
}
function kl(e) {
  if (e !== void 0)
    return e === null ? null : {
      at_ledger_state: d(e.at_ledger_state),
      cursor: e.cursor,
      limit_per_page: e.limit_per_page,
      address: e.address,
      resource_address: e.resource_address,
      opt_ins: On(e.opt_ins)
    };
}
function Sh(e) {
  let t = !0;
  return t = t && "address" in e, t = t && "resource_address" in e, t;
}
function Oh(e) {
  return El(e);
}
function El(e, t) {
  return e == null ? e : {
    address: e.address,
    resource_address: e.resource_address,
    opt_ins: n(e, "opt_ins") ? Sn(e.opt_ins) : void 0
  };
}
function bh(e) {
  if (e !== void 0)
    return e === null ? null : {
      address: e.address,
      resource_address: e.resource_address,
      opt_ins: On(e.opt_ins)
    };
}
function Nh(e) {
  let t = !0;
  return t = t && "ledger_state" in e, t = t && "items" in e, t = t && "address" in e, t = t && "resource_address" in e, t;
}
function Dl(e) {
  return Pl(e);
}
function Pl(e, t) {
  return e == null ? e : {
    ledger_state: f(e.ledger_state),
    total_count: n(e, "total_count") ? e.total_count : void 0,
    next_cursor: n(e, "next_cursor") ? e.next_cursor : void 0,
    items: e.items.map(q),
    address: e.address,
    resource_address: e.resource_address
  };
}
function Fh(e) {
  if (e !== void 0)
    return e === null ? null : {
      ledger_state: _(e.ledger_state),
      total_count: e.total_count,
      next_cursor: e.next_cursor,
      items: e.items.map(U),
      address: e.address,
      resource_address: e.resource_address
    };
}
function hh(e) {
  return !0;
}
function bn(e) {
  return wl(e);
}
function wl(e, t) {
  return e == null ? e : {
    non_fungible_include_nfids: n(e, "non_fungible_include_nfids") ? e.non_fungible_include_nfids : void 0,
    explicit_metadata: n(e, "explicit_metadata") ? e.explicit_metadata : void 0
  };
}
function Nn(e) {
  if (e !== void 0)
    return e === null ? null : {
      non_fungible_include_nfids: e.non_fungible_include_nfids,
      explicit_metadata: e.explicit_metadata
    };
}
function Ah(e) {
  let t = !0;
  return t = t && "address" in e, t;
}
function Ih(e) {
  return Ml(e);
}
function Ml(e, t) {
  return e == null ? e : {
    at_ledger_state: n(e, "at_ledger_state") ? c(e.at_ledger_state) : void 0,
    cursor: n(e, "cursor") ? e.cursor : void 0,
    limit_per_page: n(e, "limit_per_page") ? e.limit_per_page : void 0,
    address: e.address,
    aggregation_level: n(e, "aggregation_level") ? A(e.aggregation_level) : void 0,
    opt_ins: n(e, "opt_ins") ? bn(e.opt_ins) : void 0
  };
}
function xl(e) {
  if (e !== void 0)
    return e === null ? null : {
      at_ledger_state: d(e.at_ledger_state),
      cursor: e.cursor,
      limit_per_page: e.limit_per_page,
      address: e.address,
      aggregation_level: e.aggregation_level,
      opt_ins: Nn(e.opt_ins)
    };
}
function Th(e) {
  let t = !0;
  return t = t && "address" in e, t;
}
function Jh(e) {
  return Cl(e);
}
function Cl(e, t) {
  return e == null ? e : {
    address: e.address,
    aggregation_level: n(e, "aggregation_level") ? A(e.aggregation_level) : void 0,
    opt_ins: n(e, "opt_ins") ? bn(e.opt_ins) : void 0
  };
}
function vh(e) {
  if (e !== void 0)
    return e === null ? null : {
      address: e.address,
      aggregation_level: e.aggregation_level,
      opt_ins: Nn(e.opt_ins)
    };
}
function Vh(e) {
  let t = !0;
  return t = t && "ledger_state" in e, t = t && "items" in e, t = t && "address" in e, t;
}
function ql(e) {
  return Ul(e);
}
function Ul(e, t) {
  return e == null ? e : {
    ledger_state: f(e.ledger_state),
    total_count: n(e, "total_count") ? e.total_count : void 0,
    next_cursor: n(e, "next_cursor") ? e.next_cursor : void 0,
    items: e.items.map(oe),
    address: e.address
  };
}
function Rh(e) {
  if (e !== void 0)
    return e === null ? null : {
      ledger_state: _(e.ledger_state),
      total_count: e.total_count,
      next_cursor: e.next_cursor,
      items: e.items.map(ue),
      address: e.address
    };
}
function kh(e) {
  return !0;
}
function Fn(e) {
  return Kl(e);
}
function Kl(e, t) {
  return e == null ? e : {
    key_hex: n(e, "key_hex") ? e.key_hex : void 0,
    key_json: n(e, "key_json") ? p(e.key_json) : void 0
  };
}
function hn(e) {
  if (e !== void 0)
    return e === null ? null : {
      key_hex: e.key_hex,
      key_json: g(e.key_json)
    };
}
function Eh(e) {
  let t = !0;
  return t = t && "key_value_store_address" in e, t = t && "keys" in e, t;
}
function Dh(e) {
  return Ll(e);
}
function Ll(e, t) {
  return e == null ? e : {
    at_ledger_state: n(e, "at_ledger_state") ? c(e.at_ledger_state) : void 0,
    key_value_store_address: e.key_value_store_address,
    keys: e.keys.map(Fn)
  };
}
function Bl(e) {
  if (e !== void 0)
    return e === null ? null : {
      at_ledger_state: d(e.at_ledger_state),
      key_value_store_address: e.key_value_store_address,
      keys: e.keys.map(hn)
    };
}
function Ph(e) {
  let t = !0;
  return t = t && "key_value_store_address" in e, t = t && "keys" in e, t;
}
function wh(e) {
  return Gl(e);
}
function Gl(e, t) {
  return e == null ? e : {
    key_value_store_address: e.key_value_store_address,
    keys: e.keys.map(Fn)
  };
}
function Mh(e) {
  if (e !== void 0)
    return e === null ? null : {
      key_value_store_address: e.key_value_store_address,
      keys: e.keys.map(hn)
    };
}
function xh(e) {
  let t = !0;
  return t = t && "key" in e, t = t && "value" in e, t = t && "last_updated_at_state_version" in e, t = t && "is_locked" in e, t;
}
function An(e) {
  return Hl(e);
}
function Hl(e, t) {
  return e == null ? e : {
    key: Y(e.key),
    value: Y(e.value),
    last_updated_at_state_version: e.last_updated_at_state_version,
    is_locked: e.is_locked
  };
}
function In(e) {
  if (e !== void 0)
    return e === null ? null : {
      key: j(e.key),
      value: j(e.value),
      last_updated_at_state_version: e.last_updated_at_state_version,
      is_locked: e.is_locked
    };
}
function Ch(e) {
  let t = !0;
  return t = t && "ledger_state" in e, t = t && "key_value_store_address" in e, t = t && "entries" in e, t;
}
function $l(e) {
  return Wl(e);
}
function Wl(e, t) {
  return e == null ? e : {
    ledger_state: f(e.ledger_state),
    key_value_store_address: e.key_value_store_address,
    entries: e.entries.map(An)
  };
}
function qh(e) {
  if (e !== void 0)
    return e === null ? null : {
      ledger_state: _(e.ledger_state),
      key_value_store_address: e.key_value_store_address,
      entries: e.entries.map(In)
    };
}
function Uh(e) {
  let t = !0;
  return t = t && "key_value_store_address" in e, t = t && "entries" in e, t;
}
function Kh(e) {
  return zl(e);
}
function zl(e, t) {
  return e == null ? e : {
    key_value_store_address: e.key_value_store_address,
    entries: e.entries.map(An)
  };
}
function Lh(e) {
  if (e !== void 0)
    return e === null ? null : {
      key_value_store_address: e.key_value_store_address,
      entries: e.entries.map(In)
    };
}
function Bh(e) {
  let t = !0;
  return t = t && "resource_address" in e, t = t && "non_fungible_ids" in e, t;
}
function Gh(e) {
  return Xl(e);
}
function Xl(e, t) {
  return e == null ? e : {
    at_ledger_state: n(e, "at_ledger_state") ? c(e.at_ledger_state) : void 0,
    resource_address: e.resource_address,
    non_fungible_ids: e.non_fungible_ids
  };
}
function Zl(e) {
  if (e !== void 0)
    return e === null ? null : {
      at_ledger_state: d(e.at_ledger_state),
      resource_address: e.resource_address,
      non_fungible_ids: e.non_fungible_ids
    };
}
function Hh(e) {
  let t = !0;
  return t = t && "is_burned" in e, t = t && "non_fungible_id" in e, t = t && "last_updated_at_state_version" in e, t;
}
function Tn(e) {
  return Ql(e);
}
function Ql(e, t) {
  return e == null ? e : {
    is_burned: e.is_burned,
    non_fungible_id: e.non_fungible_id,
    data: n(e, "data") ? Y(e.data) : void 0,
    last_updated_at_state_version: e.last_updated_at_state_version
  };
}
function Jn(e) {
  if (e !== void 0)
    return e === null ? null : {
      is_burned: e.is_burned,
      non_fungible_id: e.non_fungible_id,
      data: j(e.data),
      last_updated_at_state_version: e.last_updated_at_state_version
    };
}
function $h(e) {
  let t = !0;
  return t = t && "ledger_state" in e, t = t && "resource_address" in e, t = t && "non_fungible_id_type" in e, t = t && "non_fungible_ids" in e, t;
}
function Yl(e) {
  return jl(e);
}
function jl(e, t) {
  return e == null ? e : {
    ledger_state: f(e.ledger_state),
    resource_address: e.resource_address,
    non_fungible_id_type: X(e.non_fungible_id_type),
    non_fungible_ids: e.non_fungible_ids.map(Tn)
  };
}
function Wh(e) {
  if (e !== void 0)
    return e === null ? null : {
      ledger_state: _(e.ledger_state),
      resource_address: e.resource_address,
      non_fungible_id_type: e.non_fungible_id_type,
      non_fungible_ids: e.non_fungible_ids.map(Jn)
    };
}
function zh(e) {
  let t = !0;
  return t = t && "resource_address" in e, t = t && "non_fungible_id_type" in e, t = t && "non_fungible_ids" in e, t;
}
function Xh(e) {
  return es(e);
}
function es(e, t) {
  return e == null ? e : {
    resource_address: e.resource_address,
    non_fungible_id_type: X(e.non_fungible_id_type),
    non_fungible_ids: e.non_fungible_ids.map(Tn)
  };
}
function Zh(e) {
  if (e !== void 0)
    return e === null ? null : {
      resource_address: e.resource_address,
      non_fungible_id_type: e.non_fungible_id_type,
      non_fungible_ids: e.non_fungible_ids.map(Jn)
    };
}
function Qh(e) {
  let t = !0;
  return t = t && "resource_address" in e, t;
}
function Yh(e) {
  return ts(e);
}
function ts(e, t) {
  return e == null ? e : {
    at_ledger_state: n(e, "at_ledger_state") ? c(e.at_ledger_state) : void 0,
    cursor: n(e, "cursor") ? e.cursor : void 0,
    limit_per_page: n(e, "limit_per_page") ? e.limit_per_page : void 0,
    resource_address: e.resource_address
  };
}
function ns(e) {
  if (e !== void 0)
    return e === null ? null : {
      at_ledger_state: d(e.at_ledger_state),
      cursor: e.cursor,
      limit_per_page: e.limit_per_page,
      resource_address: e.resource_address
    };
}
function jh(e) {
  let t = !0;
  return t = t && "resource_address" in e, t;
}
function eA(e) {
  return rs(e);
}
function rs(e, t) {
  return e == null ? e : {
    resource_address: e.resource_address
  };
}
function tA(e) {
  if (e !== void 0)
    return e === null ? null : {
      resource_address: e.resource_address
    };
}
function nA(e) {
  let t = !0;
  return t = t && "ledger_state" in e, t = t && "resource_address" in e, t = t && "non_fungible_ids" in e, t;
}
function is(e) {
  return as(e);
}
function as(e, t) {
  return e == null ? e : {
    ledger_state: f(e.ledger_state),
    resource_address: e.resource_address,
    non_fungible_ids: Kt(e.non_fungible_ids)
  };
}
function rA(e) {
  if (e !== void 0)
    return e === null ? null : {
      ledger_state: _(e.ledger_state),
      resource_address: e.resource_address,
      non_fungible_ids: Lt(e.non_fungible_ids)
    };
}
function iA(e) {
  let t = !0;
  return t = t && "resource_address" in e, t = t && "non_fungible_ids" in e, t;
}
function aA(e) {
  return os(e);
}
function os(e, t) {
  return e == null ? e : {
    resource_address: e.resource_address,
    non_fungible_ids: Kt(e.non_fungible_ids)
  };
}
function oA(e) {
  if (e !== void 0)
    return e === null ? null : {
      resource_address: e.resource_address,
      non_fungible_ids: Lt(e.non_fungible_ids)
    };
}
function uA(e) {
  let t = !0;
  return t = t && "resource_address" in e, t = t && "non_fungible_ids" in e, t;
}
function lA(e) {
  return us(e);
}
function us(e, t) {
  return e == null ? e : {
    at_ledger_state: n(e, "at_ledger_state") ? c(e.at_ledger_state) : void 0,
    resource_address: e.resource_address,
    non_fungible_ids: e.non_fungible_ids
  };
}
function ls(e) {
  if (e !== void 0)
    return e === null ? null : {
      at_ledger_state: d(e.at_ledger_state),
      resource_address: e.resource_address,
      non_fungible_ids: e.non_fungible_ids
    };
}
function sA(e) {
  let t = !0;
  return t = t && "resource_address" in e, t = t && "non_fungible_ids" in e, t;
}
function cA(e) {
  return ss(e);
}
function ss(e, t) {
  return e == null ? e : {
    resource_address: e.resource_address,
    non_fungible_ids: e.non_fungible_ids
  };
}
function dA(e) {
  if (e !== void 0)
    return e === null ? null : {
      resource_address: e.resource_address,
      non_fungible_ids: e.non_fungible_ids
    };
}
function fA(e) {
  let t = !0;
  return t = t && "non_fungible_id" in e, t = t && "is_burned" in e, t = t && "last_updated_at_state_version" in e, t;
}
function vn(e) {
  return cs(e);
}
function cs(e, t) {
  return e == null ? e : {
    non_fungible_id: e.non_fungible_id,
    owning_vault_address: n(e, "owning_vault_address") ? e.owning_vault_address : void 0,
    is_burned: e.is_burned,
    last_updated_at_state_version: e.last_updated_at_state_version
  };
}
function Vn(e) {
  if (e !== void 0)
    return e === null ? null : {
      non_fungible_id: e.non_fungible_id,
      owning_vault_address: e.owning_vault_address,
      is_burned: e.is_burned,
      last_updated_at_state_version: e.last_updated_at_state_version
    };
}
function _A(e) {
  let t = !0;
  return t = t && "ledger_state" in e, t = t && "resource_address" in e, t = t && "non_fungible_ids" in e, t;
}
function ds(e) {
  return fs(e);
}
function fs(e, t) {
  return e == null ? e : {
    ledger_state: f(e.ledger_state),
    resource_address: e.resource_address,
    non_fungible_ids: e.non_fungible_ids.map(vn)
  };
}
function mA(e) {
  if (e !== void 0)
    return e === null ? null : {
      ledger_state: _(e.ledger_state),
      resource_address: e.resource_address,
      non_fungible_ids: e.non_fungible_ids.map(Vn)
    };
}
function yA(e) {
  let t = !0;
  return t = t && "resource_address" in e, t = t && "non_fungible_ids" in e, t;
}
function pA(e) {
  return _s(e);
}
function _s(e, t) {
  return e == null ? e : {
    resource_address: e.resource_address,
    non_fungible_ids: e.non_fungible_ids.map(vn)
  };
}
function gA(e) {
  if (e !== void 0)
    return e === null ? null : {
      resource_address: e.resource_address,
      non_fungible_ids: e.non_fungible_ids.map(Vn)
    };
}
function SA(e) {
  return !0;
}
function OA(e) {
  return ms(e);
}
function ms(e, t) {
  return e == null ? e : {
    at_ledger_state: n(e, "at_ledger_state") ? c(e.at_ledger_state) : void 0,
    cursor: n(e, "cursor") ? e.cursor : void 0
  };
}
function ys(e) {
  if (e !== void 0)
    return e === null ? null : {
      at_ledger_state: d(e.at_ledger_state),
      cursor: e.cursor
    };
}
function bA(e) {
  return !0;
}
function NA(e) {
  return ps(e);
}
function ps(e, t) {
  return e == null ? e : {
    cursor: n(e, "cursor") ? e.cursor : void 0
  };
}
function FA(e) {
  if (e !== void 0)
    return e === null ? null : {
      cursor: e.cursor
    };
}
function hA(e) {
  let t = !0;
  return t = t && "stake" in e, t = t && "stake_percentage" in e, t = t && "key" in e, t;
}
function gs(e) {
  return Ss(e);
}
function Ss(e, t) {
  return e == null ? e : {
    stake: e.stake,
    stake_percentage: e.stake_percentage,
    key: I(e.key)
  };
}
function Os(e) {
  if (e !== void 0)
    return e === null ? null : {
      stake: e.stake,
      stake_percentage: e.stake_percentage,
      key: T(e.key)
    };
}
function AA(e) {
  let t = !0;
  return t = t && "fee_factor" in e, t;
}
function bs(e) {
  return Ns(e);
}
function Ns(e, t) {
  return e == null ? e : {
    fee_factor: e.fee_factor
  };
}
function Fs(e) {
  if (e !== void 0)
    return e === null ? null : {
      fee_factor: e.fee_factor
    };
}
function IA(e) {
  let t = !0;
  return t = t && "fee_factor" in e, t = t && "effective_at_epoch" in e, t;
}
function hs(e) {
  return As(e);
}
function As(e, t) {
  return e == null ? e : {
    fee_factor: e.fee_factor,
    effective_at_epoch: e.effective_at_epoch
  };
}
function Is(e) {
  if (e !== void 0)
    return e === null ? null : {
      fee_factor: e.fee_factor,
      effective_at_epoch: e.effective_at_epoch
    };
}
function TA(e) {
  let t = !0;
  return t = t && "current" in e, t;
}
function Ts(e) {
  return Js(e);
}
function Js(e, t) {
  return e == null ? e : {
    current: bs(e.current),
    pending: n(e, "pending") ? hs(e.pending) : void 0
  };
}
function vs(e) {
  if (e !== void 0)
    return e === null ? null : {
      current: Fs(e.current),
      pending: Is(e.pending)
    };
}
function JA(e) {
  let t = !0;
  return t = t && "balance" in e, t = t && "last_changed_at_state_version" in e, t = t && "address" in e, t;
}
function K(e) {
  return Vs(e);
}
function Vs(e, t) {
  return e == null ? e : {
    balance: e.balance,
    last_changed_at_state_version: e.last_changed_at_state_version,
    address: e.address
  };
}
function L(e) {
  if (e !== void 0)
    return e === null ? null : {
      balance: e.balance,
      last_changed_at_state_version: e.last_changed_at_state_version,
      address: e.address
    };
}
function vA(e) {
  let t = !0;
  return t = t && "address" in e, t = t && "stake_vault" in e, t = t && "pending_xrd_withdraw_vault" in e, t = t && "locked_owner_stake_unit_vault" in e, t = t && "pending_owner_stake_unit_unlock_vault" in e, t = t && "state" in e, t = t && "metadata" in e, t = t && "effective_fee_factor" in e, t;
}
function Rn(e) {
  return Rs(e);
}
function Rs(e, t) {
  return e == null ? e : {
    address: e.address,
    stake_vault: K(e.stake_vault),
    pending_xrd_withdraw_vault: K(e.pending_xrd_withdraw_vault),
    locked_owner_stake_unit_vault: K(e.locked_owner_stake_unit_vault),
    pending_owner_stake_unit_unlock_vault: K(e.pending_owner_stake_unit_unlock_vault),
    state: e.state,
    active_in_epoch: n(e, "active_in_epoch") ? gs(e.active_in_epoch) : void 0,
    metadata: N(e.metadata),
    effective_fee_factor: Ts(e.effective_fee_factor)
  };
}
function kn(e) {
  if (e !== void 0)
    return e === null ? null : {
      address: e.address,
      stake_vault: L(e.stake_vault),
      pending_xrd_withdraw_vault: L(e.pending_xrd_withdraw_vault),
      locked_owner_stake_unit_vault: L(e.locked_owner_stake_unit_vault),
      pending_owner_stake_unit_unlock_vault: L(e.pending_owner_stake_unit_unlock_vault),
      state: e.state,
      active_in_epoch: Os(e.active_in_epoch),
      metadata: F(e.metadata),
      effective_fee_factor: vs(e.effective_fee_factor)
    };
}
function VA(e) {
  let t = !0;
  return t = t && "items" in e, t;
}
function En(e) {
  return ks(e);
}
function ks(e, t) {
  return e == null ? e : {
    total_count: n(e, "total_count") ? e.total_count : void 0,
    next_cursor: n(e, "next_cursor") ? e.next_cursor : void 0,
    items: e.items.map(Rn)
  };
}
function Dn(e) {
  if (e !== void 0)
    return e === null ? null : {
      total_count: e.total_count,
      next_cursor: e.next_cursor,
      items: e.items.map(kn)
    };
}
function RA(e) {
  let t = !0;
  return t = t && "ledger_state" in e, t = t && "validators" in e, t;
}
function Es(e) {
  return Ds(e);
}
function Ds(e, t) {
  return e == null ? e : {
    ledger_state: f(e.ledger_state),
    validators: En(e.validators)
  };
}
function kA(e) {
  if (e !== void 0)
    return e === null ? null : {
      ledger_state: _(e.ledger_state),
      validators: Dn(e.validators)
    };
}
function EA(e) {
  let t = !0;
  return t = t && "validators" in e, t;
}
function DA(e) {
  return Ps(e);
}
function Ps(e, t) {
  return e == null ? e : {
    validators: En(e.validators)
  };
}
function PA(e) {
  if (e !== void 0)
    return e === null ? null : {
      validators: Dn(e.validators)
    };
}
const wA = {
  Deposit: "Deposit",
  Withdrawal: "Withdrawal"
};
function MA(e) {
  let t = !0;
  return t = t && "event" in e, t;
}
function Pn(e) {
  return ws(e);
}
function ws(e, t) {
  return e == null ? e : {
    event: e.event,
    emitter_address: n(e, "emitter_address") ? e.emitter_address : void 0,
    resource_address: n(e, "resource_address") ? e.resource_address : void 0
  };
}
function wn(e) {
  if (e !== void 0)
    return e === null ? null : {
      event: e.event,
      emitter_address: e.emitter_address,
      resource_address: e.resource_address
    };
}
function xA(e) {
  return !0;
}
function Z(e) {
  return Ms(e);
}
function Ms(e, t) {
  return e == null ? e : {
    raw_hex: n(e, "raw_hex") ? e.raw_hex : void 0,
    receipt_state_changes: n(e, "receipt_state_changes") ? e.receipt_state_changes : void 0,
    receipt_fee_summary: n(e, "receipt_fee_summary") ? e.receipt_fee_summary : void 0,
    receipt_fee_source: n(e, "receipt_fee_source") ? e.receipt_fee_source : void 0,
    receipt_fee_destination: n(e, "receipt_fee_destination") ? e.receipt_fee_destination : void 0,
    receipt_costing_parameters: n(e, "receipt_costing_parameters") ? e.receipt_costing_parameters : void 0,
    receipt_events: n(e, "receipt_events") ? e.receipt_events : void 0,
    receipt_output: n(e, "receipt_output") ? e.receipt_output : void 0,
    affected_global_entities: n(e, "affected_global_entities") ? e.affected_global_entities : void 0,
    balance_changes: n(e, "balance_changes") ? e.balance_changes : void 0
  };
}
function Q(e) {
  if (e !== void 0)
    return e === null ? null : {
      raw_hex: e.raw_hex,
      receipt_state_changes: e.receipt_state_changes,
      receipt_fee_summary: e.receipt_fee_summary,
      receipt_fee_source: e.receipt_fee_source,
      receipt_fee_destination: e.receipt_fee_destination,
      receipt_costing_parameters: e.receipt_costing_parameters,
      receipt_events: e.receipt_events,
      receipt_output: e.receipt_output,
      affected_global_entities: e.affected_global_entities,
      balance_changes: e.balance_changes
    };
}
const CA = {
  User: "User",
  EpochChange: "EpochChange",
  All: "All"
}, qA = {
  Asc: "Asc",
  Desc: "Desc"
};
function UA(e) {
  return !0;
}
function KA(e) {
  return xs(e);
}
function xs(e, t) {
  return e == null ? e : {
    at_ledger_state: n(e, "at_ledger_state") ? c(e.at_ledger_state) : void 0,
    from_ledger_state: n(e, "from_ledger_state") ? c(e.from_ledger_state) : void 0,
    cursor: n(e, "cursor") ? e.cursor : void 0,
    limit_per_page: n(e, "limit_per_page") ? e.limit_per_page : void 0,
    kind_filter: n(e, "kind_filter") ? e.kind_filter : void 0,
    manifest_accounts_withdrawn_from_filter: n(e, "manifest_accounts_withdrawn_from_filter") ? e.manifest_accounts_withdrawn_from_filter : void 0,
    manifest_accounts_deposited_into_filter: n(e, "manifest_accounts_deposited_into_filter") ? e.manifest_accounts_deposited_into_filter : void 0,
    manifest_resources_filter: n(e, "manifest_resources_filter") ? e.manifest_resources_filter : void 0,
    affected_global_entities_filter: n(e, "affected_global_entities_filter") ? e.affected_global_entities_filter : void 0,
    events_filter: n(e, "events_filter") ? e.events_filter.map(Pn) : void 0,
    order: n(e, "order") ? e.order : void 0,
    opt_ins: n(e, "opt_ins") ? Z(e.opt_ins) : void 0
  };
}
function Cs(e) {
  if (e !== void 0)
    return e === null ? null : {
      at_ledger_state: d(e.at_ledger_state),
      from_ledger_state: d(e.from_ledger_state),
      cursor: e.cursor,
      limit_per_page: e.limit_per_page,
      kind_filter: e.kind_filter,
      manifest_accounts_withdrawn_from_filter: e.manifest_accounts_withdrawn_from_filter,
      manifest_accounts_deposited_into_filter: e.manifest_accounts_deposited_into_filter,
      manifest_resources_filter: e.manifest_resources_filter,
      affected_global_entities_filter: e.affected_global_entities_filter,
      events_filter: e.events_filter === void 0 ? void 0 : e.events_filter.map(wn),
      order: e.order,
      opt_ins: Q(e.opt_ins)
    };
}
const LA = {
  User: "User",
  EpochChange: "EpochChange",
  All: "All"
}, BA = {
  Asc: "Asc",
  Desc: "Desc"
};
function GA(e) {
  return !0;
}
function HA(e) {
  return qs(e);
}
function qs(e, t) {
  return e == null ? e : {
    kind_filter: n(e, "kind_filter") ? e.kind_filter : void 0,
    manifest_accounts_withdrawn_from_filter: n(e, "manifest_accounts_withdrawn_from_filter") ? e.manifest_accounts_withdrawn_from_filter : void 0,
    manifest_accounts_deposited_into_filter: n(e, "manifest_accounts_deposited_into_filter") ? e.manifest_accounts_deposited_into_filter : void 0,
    manifest_resources_filter: n(e, "manifest_resources_filter") ? e.manifest_resources_filter : void 0,
    affected_global_entities_filter: n(e, "affected_global_entities_filter") ? e.affected_global_entities_filter : void 0,
    events_filter: n(e, "events_filter") ? e.events_filter.map(Pn) : void 0,
    order: n(e, "order") ? e.order : void 0,
    opt_ins: n(e, "opt_ins") ? Z(e.opt_ins) : void 0
  };
}
function $A(e) {
  if (e !== void 0)
    return e === null ? null : {
      kind_filter: e.kind_filter,
      manifest_accounts_withdrawn_from_filter: e.manifest_accounts_withdrawn_from_filter,
      manifest_accounts_deposited_into_filter: e.manifest_accounts_deposited_into_filter,
      manifest_resources_filter: e.manifest_resources_filter,
      affected_global_entities_filter: e.affected_global_entities_filter,
      events_filter: e.events_filter === void 0 ? void 0 : e.events_filter.map(wn),
      order: e.order,
      opt_ins: Q(e.opt_ins)
    };
}
function WA(e) {
  let t = !0;
  return t = t && "ledger_state" in e, t = t && "items" in e, t;
}
function Us(e) {
  return Ks(e);
}
function Ks(e, t) {
  return e == null ? e : {
    ledger_state: f(e.ledger_state),
    total_count: n(e, "total_count") ? e.total_count : void 0,
    next_cursor: n(e, "next_cursor") ? e.next_cursor : void 0,
    items: e.items.map(H)
  };
}
function zA(e) {
  if (e !== void 0)
    return e === null ? null : {
      ledger_state: _(e.ledger_state),
      total_count: e.total_count,
      next_cursor: e.next_cursor,
      items: e.items.map($)
    };
}
function XA(e) {
  let t = !0;
  return t = t && "items" in e, t;
}
function ZA(e) {
  return Ls(e);
}
function Ls(e, t) {
  return e == null ? e : {
    items: e.items.map(H)
  };
}
function QA(e) {
  if (e !== void 0)
    return e === null ? null : {
      items: e.items.map($)
    };
}
function YA(e) {
  let t = !0;
  return t = t && "intent_hash" in e, t;
}
function jA(e) {
  return Bs(e);
}
function Bs(e, t) {
  return e == null ? e : {
    at_ledger_state: n(e, "at_ledger_state") ? c(e.at_ledger_state) : void 0,
    intent_hash: e.intent_hash,
    opt_ins: n(e, "opt_ins") ? Z(e.opt_ins) : void 0
  };
}
function Gs(e) {
  if (e !== void 0)
    return e === null ? null : {
      at_ledger_state: d(e.at_ledger_state),
      intent_hash: e.intent_hash,
      opt_ins: Q(e.opt_ins)
    };
}
function eI(e) {
  let t = !0;
  return t = t && "intent_hash" in e, t;
}
function tI(e) {
  return Hs(e);
}
function Hs(e, t) {
  return e == null ? e : {
    intent_hash: e.intent_hash,
    opt_ins: n(e, "opt_ins") ? Z(e.opt_ins) : void 0
  };
}
function nI(e) {
  if (e !== void 0)
    return e === null ? null : {
      intent_hash: e.intent_hash,
      opt_ins: Q(e.opt_ins)
    };
}
function rI(e) {
  let t = !0;
  return t = t && "ledger_state" in e, t = t && "transaction" in e, t;
}
function $s(e) {
  return Ws(e);
}
function Ws(e, t) {
  return e == null ? e : {
    ledger_state: f(e.ledger_state),
    transaction: H(e.transaction)
  };
}
function iI(e) {
  if (e !== void 0)
    return e === null ? null : {
      ledger_state: _(e.ledger_state),
      transaction: $(e.transaction)
    };
}
function aI(e) {
  let t = !0;
  return t = t && "transaction" in e, t;
}
function oI(e) {
  return zs(e);
}
function zs(e, t) {
  return e == null ? e : {
    transaction: H(e.transaction)
  };
}
function uI(e) {
  if (e !== void 0)
    return e === null ? null : {
      transaction: $(e.transaction)
    };
}
function lI(e) {
  let t = !0;
  return t = t && "ledger_state" in e, t;
}
function Xs(e) {
  return Zs(e);
}
function Zs(e, t) {
  return e == null ? e : {
    ledger_state: f(e.ledger_state)
  };
}
function sI(e) {
  if (e !== void 0)
    return e === null ? null : {
      ledger_state: _(e.ledger_state)
    };
}
const cI = {
  Unknown: "Unknown",
  CommittedSuccess: "CommittedSuccess",
  CommittedFailure: "CommittedFailure",
  CommitPendingOutcomeUnknown: "CommitPendingOutcomeUnknown",
  PermanentlyRejected: "PermanentlyRejected",
  LikelyButNotCertainRejection: "LikelyButNotCertainRejection",
  Pending: "Pending"
};
function Mn(e) {
  return Qs(e);
}
function Qs(e, t) {
  return e;
}
function dI(e) {
  return e;
}
const fI = {
  TransactionNotFoundError: "TransactionNotFoundError"
};
function _I(e) {
  let t = !0;
  return t = t && "intent_hash" in e, t;
}
function mI(e) {
  return Ys(e);
}
function Ys(e, t) {
  return e == null ? e : {
    intent_hash: e.intent_hash,
    type: n(e, "type") ? e.type : void 0
  };
}
function yI(e) {
  if (e !== void 0)
    return e === null ? null : {
      intent_hash: e.intent_hash,
      type: e.type
    };
}
const pI = {
  HandlingSubmission: "HandlingSubmission",
  Concluded: "Concluded"
};
function js(e) {
  return ec(e);
}
function ec(e, t) {
  return e;
}
function gI(e) {
  return e;
}
const SI = {
  Unknown: "Unknown",
  CommittedSuccess: "CommittedSuccess",
  CommittedFailure: "CommittedFailure",
  CommitPendingOutcomeUnknown: "CommitPendingOutcomeUnknown",
  PermanentlyRejected: "PermanentlyRejected",
  TemporarilyRejected: "TemporarilyRejected",
  Pending: "Pending"
};
function tc(e) {
  return nc(e);
}
function nc(e, t) {
  return e;
}
function OI(e) {
  return e;
}
function bI(e) {
  let t = !0;
  return t = t && "use_free_credit" in e, t = t && "assume_all_signature_proofs" in e, t = t && "skip_epoch_check" in e, t;
}
function rc(e) {
  return ic(e);
}
function ic(e, t) {
  return e == null ? e : {
    use_free_credit: e.use_free_credit,
    assume_all_signature_proofs: e.assume_all_signature_proofs,
    skip_epoch_check: e.skip_epoch_check
  };
}
function ac(e) {
  if (e !== void 0)
    return e === null ? null : {
      use_free_credit: e.use_free_credit,
      assume_all_signature_proofs: e.assume_all_signature_proofs,
      skip_epoch_check: e.skip_epoch_check
    };
}
function NI(e) {
  let t = !0;
  return t = t && "manifest" in e, t = t && "start_epoch_inclusive" in e, t = t && "end_epoch_exclusive" in e, t = t && "tip_percentage" in e, t = t && "nonce" in e, t = t && "signer_public_keys" in e, t = t && "flags" in e, t;
}
function FI(e) {
  return oc(e);
}
function oc(e, t) {
  return e == null ? e : {
    manifest: e.manifest,
    blobs_hex: n(e, "blobs_hex") ? e.blobs_hex : void 0,
    start_epoch_inclusive: e.start_epoch_inclusive,
    end_epoch_exclusive: e.end_epoch_exclusive,
    notary_public_key: n(e, "notary_public_key") ? I(e.notary_public_key) : void 0,
    notary_is_signatory: n(e, "notary_is_signatory") ? e.notary_is_signatory : void 0,
    tip_percentage: e.tip_percentage,
    nonce: e.nonce,
    signer_public_keys: e.signer_public_keys.map(I),
    flags: rc(e.flags)
  };
}
function uc(e) {
  if (e !== void 0)
    return e === null ? null : {
      manifest: e.manifest,
      blobs_hex: e.blobs_hex,
      start_epoch_inclusive: e.start_epoch_inclusive,
      end_epoch_exclusive: e.end_epoch_exclusive,
      notary_public_key: T(e.notary_public_key),
      notary_is_signatory: e.notary_is_signatory,
      tip_percentage: e.tip_percentage,
      nonce: e.nonce,
      signer_public_keys: e.signer_public_keys.map(T),
      flags: ac(e.flags)
    };
}
function hI(e) {
  let t = !0;
  return t = t && "level" in e, t = t && "message" in e, t;
}
function lc(e) {
  return sc(e);
}
function sc(e, t) {
  return e == null ? e : {
    level: e.level,
    message: e.message
  };
}
function cc(e) {
  if (e !== void 0)
    return e === null ? null : {
      level: e.level,
      message: e.message
    };
}
function AI(e) {
  let t = !0;
  return t = t && "encoded_receipt" in e, t = t && "receipt" in e, t = t && "resource_changes" in e, t = t && "logs" in e, t;
}
function dc(e) {
  return fc(e);
}
function fc(e, t) {
  return e == null ? e : {
    encoded_receipt: e.encoded_receipt,
    receipt: e.receipt,
    resource_changes: e.resource_changes,
    logs: e.logs.map(lc)
  };
}
function II(e) {
  if (e !== void 0)
    return e === null ? null : {
      encoded_receipt: e.encoded_receipt,
      receipt: e.receipt,
      resource_changes: e.resource_changes,
      logs: e.logs.map(cc)
    };
}
function TI(e) {
  let t = !0;
  return t = t && "intent_hash" in e, t;
}
function JI(e) {
  return _c(e);
}
function _c(e, t) {
  return e == null ? e : {
    intent_hash: e.intent_hash
  };
}
function mc(e) {
  if (e !== void 0)
    return e === null ? null : {
      intent_hash: e.intent_hash
    };
}
function vI(e) {
  let t = !0;
  return t = t && "intent_hash" in e, t;
}
function VI(e) {
  return yc(e);
}
function yc(e, t) {
  return e == null ? e : {
    intent_hash: e.intent_hash
  };
}
function RI(e) {
  if (e !== void 0)
    return e === null ? null : {
      intent_hash: e.intent_hash
    };
}
function kI(e) {
  let t = !0;
  return t = t && "payload_hash" in e, t = t && "status" in e, t;
}
function xn(e) {
  return pc(e);
}
function pc(e, t) {
  return e == null ? e : {
    payload_hash: e.payload_hash,
    status: M(e.status),
    payload_status: n(e, "payload_status") ? tc(e.payload_status) : void 0,
    payload_status_description: n(e, "payload_status_description") ? e.payload_status_description : void 0,
    error_message: n(e, "error_message") ? e.error_message : void 0,
    latest_error_message: n(e, "latest_error_message") ? e.latest_error_message : void 0,
    handling_status: n(e, "handling_status") ? js(e.handling_status) : void 0,
    handling_status_reason: n(e, "handling_status_reason") ? e.handling_status_reason : void 0,
    submission_error: n(e, "submission_error") ? e.submission_error : void 0
  };
}
function Cn(e) {
  if (e !== void 0)
    return e === null ? null : {
      payload_hash: e.payload_hash,
      status: e.status,
      payload_status: e.payload_status,
      payload_status_description: e.payload_status_description,
      error_message: e.error_message,
      latest_error_message: e.latest_error_message,
      handling_status: e.handling_status,
      handling_status_reason: e.handling_status_reason,
      submission_error: e.submission_error
    };
}
function EI(e) {
  let t = !0;
  return t = t && "ledger_state" in e, t = t && "status" in e, t = t && "intent_status" in e, t = t && "intent_status_description" in e, t = t && "known_payloads" in e, t;
}
function gc(e) {
  return Sc(e);
}
function Sc(e, t) {
  return e == null ? e : {
    ledger_state: f(e.ledger_state),
    status: M(e.status),
    intent_status: Mn(e.intent_status),
    intent_status_description: e.intent_status_description,
    known_payloads: e.known_payloads.map(xn),
    committed_state_version: n(e, "committed_state_version") ? e.committed_state_version : void 0,
    error_message: n(e, "error_message") ? e.error_message : void 0
  };
}
function DI(e) {
  if (e !== void 0)
    return e === null ? null : {
      ledger_state: _(e.ledger_state),
      status: e.status,
      intent_status: e.intent_status,
      intent_status_description: e.intent_status_description,
      known_payloads: e.known_payloads.map(Cn),
      committed_state_version: e.committed_state_version,
      error_message: e.error_message
    };
}
function PI(e) {
  let t = !0;
  return t = t && "status" in e, t = t && "intent_status" in e, t = t && "intent_status_description" in e, t = t && "known_payloads" in e, t;
}
function wI(e) {
  return Oc(e);
}
function Oc(e, t) {
  return e == null ? e : {
    status: M(e.status),
    intent_status: Mn(e.intent_status),
    intent_status_description: e.intent_status_description,
    known_payloads: e.known_payloads.map(xn),
    committed_state_version: n(e, "committed_state_version") ? e.committed_state_version : void 0,
    error_message: n(e, "error_message") ? e.error_message : void 0
  };
}
function MI(e) {
  if (e !== void 0)
    return e === null ? null : {
      status: e.status,
      intent_status: e.intent_status,
      intent_status_description: e.intent_status_description,
      known_payloads: e.known_payloads.map(Cn),
      committed_state_version: e.committed_state_version,
      error_message: e.error_message
    };
}
function xI(e) {
  let t = !0;
  return t = t && "notarized_transaction_hex" in e, t;
}
function CI(e) {
  return bc(e);
}
function bc(e, t) {
  return e == null ? e : {
    notarized_transaction_hex: e.notarized_transaction_hex
  };
}
function Nc(e) {
  if (e !== void 0)
    return e === null ? null : {
      notarized_transaction_hex: e.notarized_transaction_hex
    };
}
function qI(e) {
  let t = !0;
  return t = t && "duplicate" in e, t;
}
function Fc(e) {
  return hc(e);
}
function hc(e, t) {
  return e == null ? e : {
    duplicate: e.duplicate
  };
}
function UI(e) {
  if (e !== void 0)
    return e === null ? null : {
      duplicate: e.duplicate
    };
}
function KI(e) {
  let t = !0;
  return t = t && "items" in e, t;
}
function LI(e) {
  return Ac(e);
}
function Ac(e, t) {
  return e == null ? e : {
    items: e.items.map(Rn)
  };
}
function BI(e) {
  if (e !== void 0)
    return e === null ? null : {
      items: e.items.map(kn)
    };
}
function GI(e) {
  let t = !0;
  return t = t && "address" in e, t = t && "epochs_active_in" in e, t;
}
function Ic(e) {
  return Tc(e);
}
function Tc(e, t) {
  return e == null ? e : {
    address: e.address,
    proposals_made: n(e, "proposals_made") ? e.proposals_made : void 0,
    proposals_missed: n(e, "proposals_missed") ? e.proposals_missed : void 0,
    epochs_active_in: e.epochs_active_in
  };
}
function Jc(e) {
  if (e !== void 0)
    return e === null ? null : {
      address: e.address,
      proposals_made: e.proposals_made,
      proposals_missed: e.proposals_missed,
      epochs_active_in: e.epochs_active_in
    };
}
function HI(e) {
  let t = !0;
  return t = t && "items" in e, t;
}
function qn(e) {
  return vc(e);
}
function vc(e, t) {
  return e == null ? e : {
    items: e.items.map(Ic)
  };
}
function Un(e) {
  if (e !== void 0)
    return e === null ? null : {
      items: e.items.map(Jc)
    };
}
function $I(e) {
  return !0;
}
function WI(e) {
  return Vc(e);
}
function Vc(e, t) {
  return e == null ? e : {
    at_ledger_state: n(e, "at_ledger_state") ? c(e.at_ledger_state) : void 0,
    from_ledger_state: n(e, "from_ledger_state") ? c(e.from_ledger_state) : void 0,
    validator_addresses: n(e, "validator_addresses") ? e.validator_addresses : void 0
  };
}
function Rc(e) {
  if (e !== void 0)
    return e === null ? null : {
      at_ledger_state: d(e.at_ledger_state),
      from_ledger_state: d(e.from_ledger_state),
      validator_addresses: e.validator_addresses
    };
}
function zI(e) {
  return !0;
}
function XI(e) {
  return kc(e);
}
function kc(e, t) {
  return e == null ? e : {
    validator_addresses: n(e, "validator_addresses") ? e.validator_addresses : void 0
  };
}
function ZI(e) {
  if (e !== void 0)
    return e === null ? null : {
      validator_addresses: e.validator_addresses
    };
}
function QI(e) {
  let t = !0;
  return t = t && "ledger_state" in e, t = t && "validators" in e, t;
}
function Ec(e) {
  return Dc(e);
}
function Dc(e, t) {
  return e == null ? e : {
    ledger_state: f(e.ledger_state),
    validators: qn(e.validators)
  };
}
function YI(e) {
  if (e !== void 0)
    return e === null ? null : {
      ledger_state: _(e.ledger_state),
      validators: Un(e.validators)
    };
}
function jI(e) {
  let t = !0;
  return t = t && "validators" in e, t;
}
function eT(e) {
  return Pc(e);
}
function Pc(e, t) {
  return e == null ? e : {
    validators: qn(e.validators)
  };
}
function tT(e) {
  if (e !== void 0)
    return e === null ? null : {
      validators: Un(e.validators)
    };
}
class wc extends w {
  async entityFungibleResourceVaultPageRaw(t, r) {
    if (t.stateEntityFungibleResourceVaultsPageRequest === null || t.stateEntityFungibleResourceVaultsPageRequest === void 0)
      throw new m("stateEntityFungibleResourceVaultsPageRequest", "Required parameter requestParameters.stateEntityFungibleResourceVaultsPageRequest was null or undefined when calling entityFungibleResourceVaultPage.");
    const i = {}, a = {};
    a["Content-Type"] = "application/json";
    const o = await this.request({
      path: "/state/entity/page/fungible-vaults/",
      method: "POST",
      headers: a,
      query: i,
      body: sl(t.stateEntityFungibleResourceVaultsPageRequest)
    }, r);
    return new s(o, (u) => dl(u));
  }
  async entityFungibleResourceVaultPage(t, r) {
    return await (await this.entityFungibleResourceVaultPageRaw(t, r)).value();
  }
  async entityFungiblesPageRaw(t, r) {
    if (t.stateEntityFungiblesPageRequest === null || t.stateEntityFungiblesPageRequest === void 0)
      throw new m("stateEntityFungiblesPageRequest", "Required parameter requestParameters.stateEntityFungiblesPageRequest was null or undefined when calling entityFungiblesPage.");
    const i = {}, a = {};
    a["Content-Type"] = "application/json";
    const o = await this.request({
      path: "/state/entity/page/fungibles/",
      method: "POST",
      headers: a,
      query: i,
      body: yl(t.stateEntityFungiblesPageRequest)
    }, r);
    return new s(o, (u) => gl(u));
  }
  async entityFungiblesPage(t, r) {
    return await (await this.entityFungiblesPageRaw(t, r)).value();
  }
  async entityMetadataPageRaw(t, r) {
    if (t.stateEntityMetadataPageRequest === null || t.stateEntityMetadataPageRequest === void 0)
      throw new m("stateEntityMetadataPageRequest", "Required parameter requestParameters.stateEntityMetadataPageRequest was null or undefined when calling entityMetadataPage.");
    const i = {}, a = {};
    a["Content-Type"] = "application/json";
    const o = await this.request({
      path: "/state/entity/page/metadata",
      method: "POST",
      headers: a,
      query: i,
      body: bl(t.stateEntityMetadataPageRequest)
    }, r);
    return new s(o, (u) => Fl(u));
  }
  async entityMetadataPage(t, r) {
    return await (await this.entityMetadataPageRaw(t, r)).value();
  }
  async entityNonFungibleIdsPageRaw(t, r) {
    if (t.stateEntityNonFungibleIdsPageRequest === null || t.stateEntityNonFungibleIdsPageRequest === void 0)
      throw new m("stateEntityNonFungibleIdsPageRequest", "Required parameter requestParameters.stateEntityNonFungibleIdsPageRequest was null or undefined when calling entityNonFungibleIdsPage.");
    const i = {}, a = {};
    a["Content-Type"] = "application/json";
    const o = await this.request({
      path: "/state/entity/page/non-fungible-vault/ids",
      method: "POST",
      headers: a,
      query: i,
      body: Il(t.stateEntityNonFungibleIdsPageRequest)
    }, r);
    return new s(o, (u) => Jl(u));
  }
  async entityNonFungibleIdsPage(t, r) {
    return await (await this.entityNonFungibleIdsPageRaw(t, r)).value();
  }
  async entityNonFungibleResourceVaultPageRaw(t, r) {
    if (t.stateEntityNonFungibleResourceVaultsPageRequest === null || t.stateEntityNonFungibleResourceVaultsPageRequest === void 0)
      throw new m("stateEntityNonFungibleResourceVaultsPageRequest", "Required parameter requestParameters.stateEntityNonFungibleResourceVaultsPageRequest was null or undefined when calling entityNonFungibleResourceVaultPage.");
    const i = {}, a = {};
    a["Content-Type"] = "application/json";
    const o = await this.request({
      path: "/state/entity/page/non-fungible-vaults/",
      method: "POST",
      headers: a,
      query: i,
      body: kl(t.stateEntityNonFungibleResourceVaultsPageRequest)
    }, r);
    return new s(o, (u) => Dl(u));
  }
  async entityNonFungibleResourceVaultPage(t, r) {
    return await (await this.entityNonFungibleResourceVaultPageRaw(t, r)).value();
  }
  async entityNonFungiblesPageRaw(t, r) {
    if (t.stateEntityNonFungiblesPageRequest === null || t.stateEntityNonFungiblesPageRequest === void 0)
      throw new m("stateEntityNonFungiblesPageRequest", "Required parameter requestParameters.stateEntityNonFungiblesPageRequest was null or undefined when calling entityNonFungiblesPage.");
    const i = {}, a = {};
    a["Content-Type"] = "application/json";
    const o = await this.request({
      path: "/state/entity/page/non-fungibles/",
      method: "POST",
      headers: a,
      query: i,
      body: xl(t.stateEntityNonFungiblesPageRequest)
    }, r);
    return new s(o, (u) => ql(u));
  }
  async entityNonFungiblesPage(t, r) {
    return await (await this.entityNonFungiblesPageRaw(t, r)).value();
  }
  async keyValueStoreDataRaw(t, r) {
    if (t.stateKeyValueStoreDataRequest === null || t.stateKeyValueStoreDataRequest === void 0)
      throw new m("stateKeyValueStoreDataRequest", "Required parameter requestParameters.stateKeyValueStoreDataRequest was null or undefined when calling keyValueStoreData.");
    const i = {}, a = {};
    a["Content-Type"] = "application/json";
    const o = await this.request({
      path: "/state/key-value-store/data",
      method: "POST",
      headers: a,
      query: i,
      body: Bl(t.stateKeyValueStoreDataRequest)
    }, r);
    return new s(o, (u) => $l(u));
  }
  async keyValueStoreData(t, r) {
    return await (await this.keyValueStoreDataRaw(t, r)).value();
  }
  async nonFungibleDataRaw(t, r) {
    if (t.stateNonFungibleDataRequest === null || t.stateNonFungibleDataRequest === void 0)
      throw new m("stateNonFungibleDataRequest", "Required parameter requestParameters.stateNonFungibleDataRequest was null or undefined when calling nonFungibleData.");
    const i = {}, a = {};
    a["Content-Type"] = "application/json";
    const o = await this.request({
      path: "/state/non-fungible/data",
      method: "POST",
      headers: a,
      query: i,
      body: Zl(t.stateNonFungibleDataRequest)
    }, r);
    return new s(o, (u) => Yl(u));
  }
  async nonFungibleData(t, r) {
    return await (await this.nonFungibleDataRaw(t, r)).value();
  }
  async nonFungibleIdsRaw(t, r) {
    if (t.stateNonFungibleIdsRequest === null || t.stateNonFungibleIdsRequest === void 0)
      throw new m("stateNonFungibleIdsRequest", "Required parameter requestParameters.stateNonFungibleIdsRequest was null or undefined when calling nonFungibleIds.");
    const i = {}, a = {};
    a["Content-Type"] = "application/json";
    const o = await this.request({
      path: "/state/non-fungible/ids",
      method: "POST",
      headers: a,
      query: i,
      body: ns(t.stateNonFungibleIdsRequest)
    }, r);
    return new s(o, (u) => is(u));
  }
  async nonFungibleIds(t, r) {
    return await (await this.nonFungibleIdsRaw(t, r)).value();
  }
  async nonFungibleLocationRaw(t, r) {
    if (t.stateNonFungibleLocationRequest === null || t.stateNonFungibleLocationRequest === void 0)
      throw new m("stateNonFungibleLocationRequest", "Required parameter requestParameters.stateNonFungibleLocationRequest was null or undefined when calling nonFungibleLocation.");
    const i = {}, a = {};
    a["Content-Type"] = "application/json";
    const o = await this.request({
      path: "/state/non-fungible/location",
      method: "POST",
      headers: a,
      query: i,
      body: ls(t.stateNonFungibleLocationRequest)
    }, r);
    return new s(o, (u) => ds(u));
  }
  async nonFungibleLocation(t, r) {
    return await (await this.nonFungibleLocationRaw(t, r)).value();
  }
  async stateEntityDetailsRaw(t, r) {
    if (t.stateEntityDetailsRequest === null || t.stateEntityDetailsRequest === void 0)
      throw new m("stateEntityDetailsRequest", "Required parameter requestParameters.stateEntityDetailsRequest was null or undefined when calling stateEntityDetails.");
    const i = {}, a = {};
    a["Content-Type"] = "application/json";
    const o = await this.request({
      path: "/state/entity/details",
      method: "POST",
      headers: a,
      query: i,
      body: Ju(t.stateEntityDetailsRequest)
    }, r);
    return new s(o, (u) => Wu(u));
  }
  async stateEntityDetails(t, r) {
    return await (await this.stateEntityDetailsRaw(t, r)).value();
  }
  async stateValidatorsListRaw(t, r) {
    if (t.stateValidatorsListRequest === null || t.stateValidatorsListRequest === void 0)
      throw new m("stateValidatorsListRequest", "Required parameter requestParameters.stateValidatorsListRequest was null or undefined when calling stateValidatorsList.");
    const i = {}, a = {};
    a["Content-Type"] = "application/json";
    const o = await this.request({
      path: "/state/validators/list",
      method: "POST",
      headers: a,
      query: i,
      body: ys(t.stateValidatorsListRequest)
    }, r);
    return new s(o, (u) => Es(u));
  }
  async stateValidatorsList(t, r) {
    return await (await this.stateValidatorsListRaw(t, r)).value();
  }
}
class Mc extends w {
  async validatorsUptimeRaw(t, r) {
    if (t.validatorsUptimeRequest === null || t.validatorsUptimeRequest === void 0)
      throw new m("validatorsUptimeRequest", "Required parameter requestParameters.validatorsUptimeRequest was null or undefined when calling validatorsUptime.");
    const i = {}, a = {};
    a["Content-Type"] = "application/json";
    const o = await this.request({
      path: "/statistics/validators/uptime",
      method: "POST",
      headers: a,
      query: i,
      body: Rc(t.validatorsUptimeRequest)
    }, r);
    return new s(o, (u) => Ec(u));
  }
  async validatorsUptime(t, r) {
    return await (await this.validatorsUptimeRaw(t, r)).value();
  }
}
class xc extends w {
  async gatewayStatusRaw(t) {
    const r = {}, i = {}, a = await this.request({
      path: "/status/gateway-status",
      method: "POST",
      headers: i,
      query: r
    }, t);
    return new s(a, (o) => Ja(o));
  }
  async gatewayStatus(t) {
    return await (await this.gatewayStatusRaw(t)).value();
  }
  async networkConfigurationRaw(t) {
    const r = {}, i = {}, a = await this.request({
      path: "/status/network-configuration",
      method: "POST",
      headers: i,
      query: r
    }, t);
    return new s(a, (o) => bo(o));
  }
  async networkConfiguration(t) {
    return await (await this.networkConfigurationRaw(t)).value();
  }
}
class Cc extends w {
  async streamTransactionsRaw(t, r) {
    if (t.streamTransactionsRequest === null || t.streamTransactionsRequest === void 0)
      throw new m("streamTransactionsRequest", "Required parameter requestParameters.streamTransactionsRequest was null or undefined when calling streamTransactions.");
    const i = {}, a = {};
    a["Content-Type"] = "application/json";
    const o = await this.request({
      path: "/stream/transactions",
      method: "POST",
      headers: a,
      query: i,
      body: Cs(t.streamTransactionsRequest)
    }, r);
    return new s(o, (u) => Us(u));
  }
  async streamTransactions(t, r) {
    return await (await this.streamTransactionsRaw(t, r)).value();
  }
}
class qc extends w {
  async transactionCommittedDetailsRaw(t, r) {
    if (t.transactionCommittedDetailsRequest === null || t.transactionCommittedDetailsRequest === void 0)
      throw new m("transactionCommittedDetailsRequest", "Required parameter requestParameters.transactionCommittedDetailsRequest was null or undefined when calling transactionCommittedDetails.");
    const i = {}, a = {};
    a["Content-Type"] = "application/json";
    const o = await this.request({
      path: "/transaction/committed-details",
      method: "POST",
      headers: a,
      query: i,
      body: Gs(t.transactionCommittedDetailsRequest)
    }, r);
    return new s(o, (u) => $s(u));
  }
  async transactionCommittedDetails(t, r) {
    return await (await this.transactionCommittedDetailsRaw(t, r)).value();
  }
  async transactionConstructionRaw(t) {
    const r = {}, i = {}, a = await this.request({
      path: "/transaction/construction",
      method: "POST",
      headers: i,
      query: r
    }, t);
    return new s(a, (o) => Xs(o));
  }
  async transactionConstruction(t) {
    return await (await this.transactionConstructionRaw(t)).value();
  }
  async transactionPreviewRaw(t, r) {
    if (t.transactionPreviewRequest === null || t.transactionPreviewRequest === void 0)
      throw new m("transactionPreviewRequest", "Required parameter requestParameters.transactionPreviewRequest was null or undefined when calling transactionPreview.");
    const i = {}, a = {};
    a["Content-Type"] = "application/json";
    const o = await this.request({
      path: "/transaction/preview",
      method: "POST",
      headers: a,
      query: i,
      body: uc(t.transactionPreviewRequest)
    }, r);
    return new s(o, (u) => dc(u));
  }
  async transactionPreview(t, r) {
    return await (await this.transactionPreviewRaw(t, r)).value();
  }
  async transactionStatusRaw(t, r) {
    if (t.transactionStatusRequest === null || t.transactionStatusRequest === void 0)
      throw new m("transactionStatusRequest", "Required parameter requestParameters.transactionStatusRequest was null or undefined when calling transactionStatus.");
    const i = {}, a = {};
    a["Content-Type"] = "application/json";
    const o = await this.request({
      path: "/transaction/status",
      method: "POST",
      headers: a,
      query: i,
      body: mc(t.transactionStatusRequest)
    }, r);
    return new s(o, (u) => gc(u));
  }
  async transactionStatus(t, r) {
    return await (await this.transactionStatusRaw(t, r)).value();
  }
  async transactionSubmitRaw(t, r) {
    if (t.transactionSubmitRequest === null || t.transactionSubmitRequest === void 0)
      throw new m("transactionSubmitRequest", "Required parameter requestParameters.transactionSubmitRequest was null or undefined when calling transactionSubmit.");
    const i = {}, a = {};
    a["Content-Type"] = "application/json";
    const o = await this.request({
      path: "/transaction/submit",
      method: "POST",
      headers: a,
      query: i,
      body: Nc(t.transactionSubmitRequest)
    }, r);
    return new s(o, (u) => Fc(u));
  }
  async transactionSubmit(t, r) {
    return await (await this.transactionSubmitRaw(t, r)).value();
  }
}
const B = (e, t) => {
  const r = [];
  for (let i = 0, a = e.length; i < a; i += t)
    r.push(e.slice(i, i + t));
  return r;
}, P = async (e, t) => {
  let r = t;
  const i = [];
  let a;
  do {
    const o = await e(r);
    a = o.ledger_state, i.push(...o.items), r = o.next_cursor;
  } while (r);
  return {
    aggregatedEntities: i,
    ledger_state: a
  };
};
class Uc {
  constructor(t, r) {
    this.innerClient = t, this.configuration = r;
  }
  async getEntityDetailsVaultAggregated(t, r, i) {
    var l, O, h, R, k, E, se;
    const a = Array.isArray(t);
    if (a && t.length === 0)
      return Promise.resolve([]);
    if (a && t.length > this.configuration.maxAddressesCount) {
      const D = B(t, this.configuration.maxAddressesCount);
      return Promise.all(
        D.map(
          (J) => this.getEntityDetailsVaultAggregated(J, r, i)
        )
      ).then((J) => J.flat());
    }
    const { items: o, ledger_state: u } = await this.innerClient.stateEntityDetails({
      stateEntityDetailsRequest: {
        addresses: a ? t : [t],
        aggregation_level: ga.Vault,
        opt_ins: {
          ancestor_identities: (l = r == null ? void 0 : r.ancestorIdentities) != null ? l : !1,
          component_royalty_vault_balance: (O = r == null ? void 0 : r.componentRoyaltyVaultBalance) != null ? O : !1,
          package_royalty_vault_balance: (h = r == null ? void 0 : r.packageRoyaltyVaultBalance) != null ? h : !1,
          non_fungible_include_nfids: (R = r == null ? void 0 : r.nonFungibleIncludeNfids) != null ? R : !0,
          explicit_metadata: (k = r == null ? void 0 : r.explicitMetadata) != null ? k : []
        },
        at_ledger_state: i
      }
    }).then((D) => this.ensureResourcesProperties(D));
    return a ? Promise.all(
      o.map(
        (D) => {
          var J, ce;
          return this.queryAllResources(
            D,
            {
              explicitMetadata: (J = r == null ? void 0 : r.explicitMetadata) != null ? J : [],
              nonFungibleIncludeNfids: (ce = r == null ? void 0 : r.nonFungibleIncludeNfids) != null ? ce : !0
            },
            i || {
              state_version: u.state_version
            }
          );
        }
      )
    ) : this.queryAllResources(
      o[0],
      {
        explicitMetadata: (E = r == null ? void 0 : r.explicitMetadata) != null ? E : [],
        nonFungibleIncludeNfids: (se = r == null ? void 0 : r.nonFungibleIncludeNfids) != null ? se : !0
      },
      i || {
        state_version: u.state_version
      }
    );
  }
  async getEntityMetadata(t, r) {
    return this.innerClient.entityMetadataPage({
      stateEntityMetadataPageRequest: {
        address: t,
        cursor: r
      }
    });
  }
  async getNonFungibleLocation(t, r) {
    if (r.length > this.configuration.maxNftIdsCount) {
      const i = B(r, this.configuration.maxNftIdsCount);
      return Promise.all(
        i.map((a) => this.getNonFungibleLocation(t, a))
      ).then((a) => a.flat());
    }
    return this.innerClient.nonFungibleLocation({
      stateNonFungibleLocationRequest: {
        resource_address: t,
        non_fungible_ids: r
      }
    }).then((i) => i.non_fungible_ids);
  }
  async getAllEntityMetadata(t, r) {
    return P(
      this.getEntityMetadata.bind(this, t),
      r
    ).then((i) => i.aggregatedEntities);
  }
  async getValidators(t) {
    return this.innerClient.stateValidatorsList({
      stateValidatorsListRequest: {
        cursor: t || null
      }
    }).then(({ validators: r }) => r);
  }
  async getAllValidators(t) {
    return P((r) => this.getValidatorsWithLedgerState(r).then((a) => ({
      items: a.validators.items,
      ledger_state: a.ledger_state,
      next_cursor: a.validators.next_cursor
    })), t).then((r) => r.aggregatedEntities);
  }
  async getValidatorsWithLedgerState(t) {
    return this.innerClient.stateValidatorsList({
      stateValidatorsListRequest: {
        cursor: t || null
      }
    });
  }
  async getAllValidatorsWithLedgerState(t) {
    return P(
      (r) => this.getValidatorsWithLedgerState(r).then((i) => ({
        items: i.validators.items,
        ledger_state: i.ledger_state,
        next_cursor: i.validators.next_cursor
      })),
      t
    );
  }
  async getNonFungibleIds(t, r, i) {
    return this.innerClient.nonFungibleIds({
      stateNonFungibleIdsRequest: {
        resource_address: t,
        cursor: i,
        at_ledger_state: r
      }
    }).then(({ non_fungible_ids: a }) => a);
  }
  async getAllNonFungibleIds(t, r, i) {
    let a = i, o = r;
    const u = [];
    do {
      const l = await this.innerClient.nonFungibleIds({
        stateNonFungibleIdsRequest: {
          resource_address: t,
          cursor: o,
          at_ledger_state: a
        }
      });
      u.push(...l.non_fungible_ids.items), a = a || {
        state_version: l.ledger_state.state_version
      }, o = l.non_fungible_ids.next_cursor;
    } while (o);
    return u;
  }
  async getNonFungibleData(t, r, i) {
    const a = Array.isArray(r);
    if (a && r.length === 0)
      return Promise.resolve([]);
    if (a && r.length > this.configuration.maxNftIdsCount) {
      const u = B(r, this.configuration.maxNftIdsCount);
      return Promise.all(
        u.map(
          (l) => this.getNonFungibleData(t, l, i)
        )
      ).then((l) => l.flat());
    }
    const { non_fungible_ids: o } = await this.innerClient.nonFungibleData({
      stateNonFungibleDataRequest: {
        resource_address: t,
        non_fungible_ids: a ? r : [r],
        at_ledger_state: i
      }
    });
    return a ? o : o[0];
  }
  async getEntityFungiblesPageVaultAggregated(t, r) {
    return this.innerClient.entityFungiblesPage({
      stateEntityFungiblesPageRequest: {
        address: t,
        cursor: r == null ? void 0 : r.nextCursor,
        aggregation_level: "Vault",
        at_ledger_state: r == null ? void 0 : r.ledgerState,
        opt_ins: {
          explicit_metadata: r == null ? void 0 : r.explicitMetadata
        }
      }
    });
  }
  async getEntityNonFungiblesPageVaultAggregated(t, r) {
    return this.innerClient.entityNonFungiblesPage({
      stateEntityNonFungiblesPageRequest: {
        address: t,
        cursor: r == null ? void 0 : r.cursor,
        aggregation_level: "Vault",
        at_ledger_state: r == null ? void 0 : r.ledgerState,
        opt_ins: {
          explicit_metadata: r == null ? void 0 : r.explicitMetadata,
          non_fungible_include_nfids: r == null ? void 0 : r.nonFungibleIncludeNfids
        }
      }
    });
  }
  ensureResourcesProperties(t) {
    return {
      ...t,
      items: t.items.map((r) => ({
        ...r,
        fungible_resources: r.fungible_resources || {
          total_count: 0,
          items: []
        },
        non_fungible_resources: r.non_fungible_resources || {
          total_count: 0,
          items: []
        }
      }))
    };
  }
  async queryAllFungibles(t, r, i) {
    var u, l;
    const a = (u = t == null ? void 0 : t.fungible_resources) == null ? void 0 : u.next_cursor;
    if (!a)
      return Promise.resolve(t);
    const o = await P(
      (O) => this.getEntityFungiblesPageVaultAggregated(t.address, {
        nextCursor: O,
        ledgerState: i,
        explicitMetadata: r == null ? void 0 : r.explicitMetadata
      }),
      a
    );
    return Promise.resolve({
      ...t,
      fungible_resources: {
        items: [
          ...((l = t == null ? void 0 : t.fungible_resources) == null ? void 0 : l.items) || [],
          ...o.aggregatedEntities
        ]
      }
    });
  }
  async queryAllNonFungibles(t, r, i) {
    const a = t.non_fungible_resources.next_cursor;
    if (!a)
      return Promise.resolve(t);
    const o = await P(
      (u) => this.getEntityNonFungiblesPageVaultAggregated(
        t.address,
        {
          cursor: u,
          ledgerState: i,
          explicitMetadata: r == null ? void 0 : r.explicitMetadata,
          nonFungibleIncludeNfids: r == null ? void 0 : r.nonFungibleIncludeNfids
        }
      ),
      a
    );
    return Promise.resolve({
      ...t,
      non_fungible_resources: {
        items: [
          ...t.non_fungible_resources.items,
          ...o.aggregatedEntities
        ]
      }
    });
  }
  async queryAllResources(t, r, i) {
    const a = this.queryAllFungibles(
      t,
      r,
      i
    ), o = this.queryAllNonFungibles(
      t,
      r,
      i
    );
    return Promise.all([a, o]).then(
      (u) => ({
        ...t,
        fungible_resources: {
          ...t.fungible_resources,
          items: [...u[0].fungible_resources.items]
        },
        non_fungible_resources: {
          ...t.non_fungible_resources,
          items: [...u[1].non_fungible_resources.items]
        }
      })
    );
  }
}
const Kc = 20, Lc = 29, ee = 200, Bc = "1.3.0", S = {
  Mainnet: 1,
  Stokenet: 2,
  Alphanet: 10,
  Betanet: 11,
  Kisharnet: 12,
  RCnetV1: 12,
  Zabanet: 14,
  RCnetV3: 14,
  Gilganet: 32,
  Enkinet: 33,
  Hammunet: 34,
  Nergalnet: 35,
  Mardunet: 36,
  Dumunet: 37,
  LocalNet: 240,
  InternalTestNet: 241,
  Simulator: 242
}, Gc = {
  Mainnet: {
    networkName: "Mainnet",
    networkId: S.Mainnet,
    gatewayUrl: "https://mainnet.radixdlt.com",
    dashboardUrl: "https://dashboard.radixdlt.com"
  },
  Stokenet: {
    networkName: "Stokenet",
    networkId: S.Stokenet,
    gatewayUrl: "https://babylon-stokenet-gateway.radixdlt.com",
    dashboardUrl: "https://stokenet-dashboard.radixdlt.com"
  },
  Kisharnet: {
    networkName: "Kisharnet",
    networkId: S.Kisharnet,
    gatewayUrl: "https://kisharnet-gateway.radixdlt.com",
    dashboardUrl: "https://kisharnet-dashboard.radixdlt.com"
  },
  RCnetV1: {
    networkName: "RCnetV1",
    networkId: S.RCnetV1,
    gatewayUrl: "https://rcnet.radixdlt.com",
    dashboardUrl: "https://rcnet-dashboard.radixdlt.com"
  },
  Mardunet: {
    networkName: "Mardunet",
    networkId: S.Mardunet,
    gatewayUrl: "https://mardunet-gateway.radixdlt.com",
    dashboardUrl: "https://mardunet-dashboard.rdx-works-main.extratools.works"
  },
  Zabanet: {
    networkName: "Zabanet",
    networkId: S.Zabanet,
    gatewayUrl: "https://zabanet-gateway.radixdlt.com",
    dashboardUrl: "https://rcnet-v3-dashboard.radixdlt.com"
  },
  RCnetV3: {
    networkName: "RCNetV3",
    networkId: S.RCnetV3,
    gatewayUrl: "https://zabanet-gateway.radixdlt.com",
    dashboardUrl: "https://rcnet-v3-dashboard.radixdlt.com"
  },
  Gilganet: {
    networkName: "Gilganet",
    networkId: S.Gilganet,
    gatewayUrl: "https://gilganet-gateway.radixdlt.com",
    dashboardUrl: "https://gilganet-dashboard.rdx-works-main.extratools.works"
  },
  Enkinet: {
    networkName: "Enkinet",
    networkId: S.Enkinet,
    gatewayUrl: "https://enkinet-gateway.radixdlt.com",
    dashboardUrl: "https://enkinet-dashboard.rdx-works-main.extratools.works"
  },
  Hammunet: {
    networkName: "Hammunet",
    networkId: S.Hammunet,
    gatewayUrl: "https://hammunet-gateway.radixdlt.com",
    dashboardUrl: "https://hammunet-dashboard.rdx-works-main.extratools.works"
  },
  Dumunet: {
    networkName: "Dumunet",
    networkId: S.Dumunet,
    gatewayUrl: "https://dumunet-gateway.radixdlt.com",
    dashboardUrl: "https://dumunet-dashboard.rdx-works-main.extratools.works"
  }
}, nT = Object.values(Gc).reduce(
  (e, t) => (e[t.networkId] = t, e),
  {}
);
class Hc {
  constructor(t, r) {
    this.innerClient = t, this.configuration = r;
  }
  getValidatorsUptimeFromTo(t, r, i) {
    var a, o;
    if (t.length > (((a = this.configuration) == null ? void 0 : a.maxValidatorsUptimeCount) || ee)) {
      const u = B(
        t,
        ((o = this.configuration) == null ? void 0 : o.maxValidatorsUptimeCount) || ee
      );
      return Promise.all(
        u.map((l) => this.getValidatorsUptimeFromTo(l, r, i))
      ).then((l) => l.flat());
    }
    return this.innerClient.validatorsUptime({
      validatorsUptimeRequest: {
        validator_addresses: t,
        from_ledger_state: r !== void 0 ? r instanceof Date ? { timestamp: r } : { state_version: r } : void 0,
        at_ledger_state: i !== void 0 ? i instanceof Date ? { timestamp: i } : { state_version: i } : void 0
      }
    }).then((u) => u.validators.items);
  }
  getValidatorsUptime(t) {
    return this.innerClient.validatorsUptime({
      validatorsUptimeRequest: {
        validator_addresses: t
      }
    });
  }
}
class $c {
  constructor(t) {
    this.innerClient = t;
  }
  getCurrent() {
    return this.innerClient.gatewayStatus();
  }
  getNetworkConfiguration() {
    return this.innerClient.networkConfiguration();
  }
}
class Wc {
  constructor(t) {
    this.innerClient = t;
  }
  getTransactionsList(t, r) {
    return this.innerClient.streamTransactions({
      streamTransactionsRequest: {
        cursor: r,
        affected_global_entities_filter: t
      }
    });
  }
}
class zc {
  constructor(t) {
    this.innerClient = t;
  }
  getStatus(t) {
    return this.innerClient.transactionStatus({
      transactionStatusRequest: {
        intent_hash: t
      }
    });
  }
  getCommittedDetails(t, r) {
    var i, a, o, u, l, O, h, R, k, E;
    return this.innerClient.transactionCommittedDetails({
      transactionCommittedDetailsRequest: {
        intent_hash: t,
        opt_ins: {
          raw_hex: (i = r == null ? void 0 : r.rawHex) != null ? i : !0,
          receipt_events: (a = r == null ? void 0 : r.receiptEvents) != null ? a : !0,
          receipt_fee_source: (o = r == null ? void 0 : r.receiptFeeSource) != null ? o : !0,
          receipt_fee_destination: (u = r == null ? void 0 : r.receiptFeeDestination) != null ? u : !0,
          receipt_costing_parameters: (l = r == null ? void 0 : r.receiptCostingParameters) != null ? l : !0,
          receipt_fee_summary: (O = r == null ? void 0 : r.receiptFeeSummary) != null ? O : !0,
          receipt_state_changes: (h = r == null ? void 0 : r.receiptStateChanges) != null ? h : !0,
          affected_global_entities: (R = r == null ? void 0 : r.affectedGlobalEntities) != null ? R : !0,
          balance_changes: (k = r == null ? void 0 : r.balanceChanges) != null ? k : !0,
          receipt_output: (E = r == null ? void 0 : r.receiptOutput) != null ? E : !0
        }
      }
    });
  }
}
class Xc extends _e {
  constructor(r) {
    super(r);
    y(this, "extendedConfiguration");
    this.extendedConfiguration = r;
  }
  get maxAddressesCount() {
    return this.extendedConfiguration.maxAddressesCount || Kc;
  }
  get maxNftIdsCount() {
    return this.extendedConfiguration.maxNftIdsCount || Lc;
  }
  get maxValidatorsUptimeCount() {
    return this.extendedConfiguration.maxValidatorsUptimeCount || ee;
  }
}
const Zc = (e) => e ? e.endsWith("/") ? e == null ? void 0 : e.slice(0, -1) : e : "";
class te {
  constructor(t) {
    y(this, "state");
    y(this, "stream");
    y(this, "status");
    y(this, "transaction");
    y(this, "statistics");
    y(this, "lowLevel");
    this.lowLevel = {
      state: new wc(t),
      stream: new Cc(t),
      status: new xc(t),
      transaction: new qc(t),
      statistics: new Mc(t)
    }, this.state = new Uc(this.lowLevel.state, t), this.stream = new Wc(this.lowLevel.stream), this.status = new $c(this.lowLevel.status), this.transaction = new zc(this.lowLevel.transaction), this.statistics = new Hc(this.lowLevel.statistics, t);
  }
  static initialize(t) {
    const r = te.constructConfiguration(t);
    return new te(r);
  }
  static constructConfiguration(t) {
    var a, o, u, l;
    const r = Zc(t == null ? void 0 : t.basePath), i = (a = t == null ? void 0 : t.applicationName) != null ? a : "Unknown";
    return new Xc({
      ...t,
      basePath: r,
      applicationName: i,
      headers: {
        ...(o = t == null ? void 0 : t.headers) != null ? o : {},
        "RDX-Client-Name": "@radixdlt/babylon-gateway-api-sdk",
        "RDX-Client-Version": Bc,
        "RDX-App-Name": i,
        "RDX-App-Version": (u = t.applicationVersion) != null ? u : "Unknown",
        "RDX-App-Dapp-Definition": (l = t.applicationDappDefinitionAddress) != null ? l : "Unknown"
      }
    });
  }
}
export {
  od as AtLedgerStateMixinFromJSON,
  zn as AtLedgerStateMixinFromJSONTyped,
  ud as AtLedgerStateMixinToJSON,
  Bn as BASE_PATH,
  w as BaseAPI,
  nd as BlobApiResponse,
  Yc as COLLECTION_FORMATS,
  H as CommittedTransactionInfoFromJSON,
  Kr as CommittedTransactionInfoFromJSONTyped,
  $ as CommittedTransactionInfoToJSON,
  Gr as ComponentEntityRoleAssignmentEntryAssignmentFromJSON,
  Hr as ComponentEntityRoleAssignmentEntryAssignmentFromJSONTyped,
  $r as ComponentEntityRoleAssignmentEntryAssignmentToJSON,
  Zr as ComponentEntityRoleAssignmentEntryFromJSON,
  Qr as ComponentEntityRoleAssignmentEntryFromJSONTyped,
  Yr as ComponentEntityRoleAssignmentEntryToJSON,
  v as ComponentEntityRoleAssignmentsFromJSON,
  jr as ComponentEntityRoleAssignmentsFromJSONTyped,
  V as ComponentEntityRoleAssignmentsToJSON,
  _e as Configuration,
  Gf as CursorLimitMixinFromJSON,
  ei as CursorLimitMixinFromJSONTyped,
  Hf as CursorLimitMixinToJSON,
  Gn as DefaultConfig,
  Qm as EntityMetadataCollectionAllOfFromJSON,
  $i as EntityMetadataCollectionAllOfFromJSONTyped,
  Ym as EntityMetadataCollectionAllOfToJSON,
  N as EntityMetadataCollectionFromJSON,
  Hi as EntityMetadataCollectionFromJSONTyped,
  F as EntityMetadataCollectionToJSON,
  ne as EntityMetadataItemFromJSON,
  Gi as EntityMetadataItemFromJSONTyped,
  re as EntityMetadataItemToJSON,
  ey as EntityMetadataItemValueAllOfFromJSON,
  Wi as EntityMetadataItemValueAllOfFromJSONTyped,
  ty as EntityMetadataItemValueAllOfToJSON,
  Ki as EntityMetadataItemValueFromJSON,
  Li as EntityMetadataItemValueFromJSONTyped,
  Bi as EntityMetadataItemValueToJSON,
  uy as EntityNotFoundErrorAllOfFromJSON,
  Xi as EntityNotFoundErrorAllOfFromJSONTyped,
  ly as EntityNotFoundErrorAllOfToJSON,
  ay as EntityNotFoundErrorAllOfTypeEnum,
  iy as EntityNotFoundErrorFromJSON,
  Tt as EntityNotFoundErrorFromJSONTyped,
  zi as EntityNotFoundErrorToJSON,
  ny as EntityNotFoundErrorTypeEnum,
  Vy as ErrorResponseFromJSON,
  oa as ErrorResponseFromJSONTyped,
  Ry as ErrorResponseToJSON,
  Pr as EventsItemFromJSON,
  wr as EventsItemFromJSONTyped,
  Mr as EventsItemToJSON,
  Ey as FromLedgerStateMixinFromJSON,
  ua as FromLedgerStateMixinFromJSONTyped,
  Dy as FromLedgerStateMixinToJSON,
  Gy as FungibleResourcesCollectionAllOfFromJSON,
  pa as FungibleResourcesCollectionAllOfFromJSONTyped,
  Hy as FungibleResourcesCollectionAllOfToJSON,
  _a as FungibleResourcesCollectionFromJSON,
  ma as FungibleResourcesCollectionFromJSONTyped,
  zy as FungibleResourcesCollectionItemBaseFromJSON,
  Oa as FungibleResourcesCollectionItemBaseFromJSONTyped,
  Xy as FungibleResourcesCollectionItemBaseToJSON,
  ie as FungibleResourcesCollectionItemFromJSON,
  fa as FungibleResourcesCollectionItemFromJSONTyped,
  Py as FungibleResourcesCollectionItemGloballyAggregatedAggregationLevelEnum,
  Zy as FungibleResourcesCollectionItemGloballyAggregatedAllOfAggregationLevelEnum,
  Yy as FungibleResourcesCollectionItemGloballyAggregatedAllOfFromJSON,
  ba as FungibleResourcesCollectionItemGloballyAggregatedAllOfFromJSONTyped,
  jy as FungibleResourcesCollectionItemGloballyAggregatedAllOfToJSON,
  My as FungibleResourcesCollectionItemGloballyAggregatedFromJSON,
  wt as FungibleResourcesCollectionItemGloballyAggregatedFromJSONTyped,
  la as FungibleResourcesCollectionItemGloballyAggregatedToJSON,
  ae as FungibleResourcesCollectionItemToJSON,
  qy as FungibleResourcesCollectionItemVaultAggregatedAggregationLevelEnum,
  ep as FungibleResourcesCollectionItemVaultAggregatedAllOfAggregationLevelEnum,
  np as FungibleResourcesCollectionItemVaultAggregatedAllOfFromJSON,
  Na as FungibleResourcesCollectionItemVaultAggregatedAllOfFromJSONTyped,
  rp as FungibleResourcesCollectionItemVaultAggregatedAllOfToJSON,
  Ky as FungibleResourcesCollectionItemVaultAggregatedFromJSON,
  Ct as FungibleResourcesCollectionItemVaultAggregatedFromJSONTyped,
  da as FungibleResourcesCollectionItemVaultAggregatedToJSON,
  ap as FungibleResourcesCollectionItemVaultAggregatedVaultAllOfFromJSON,
  Fa as FungibleResourcesCollectionItemVaultAggregatedVaultAllOfFromJSONTyped,
  op as FungibleResourcesCollectionItemVaultAggregatedVaultAllOfToJSON,
  Mt as FungibleResourcesCollectionItemVaultAggregatedVaultFromJSON,
  ca as FungibleResourcesCollectionItemVaultAggregatedVaultFromJSONTyped,
  x as FungibleResourcesCollectionItemVaultAggregatedVaultItemFromJSON,
  sa as FungibleResourcesCollectionItemVaultAggregatedVaultItemFromJSONTyped,
  C as FungibleResourcesCollectionItemVaultAggregatedVaultItemToJSON,
  xt as FungibleResourcesCollectionItemVaultAggregatedVaultToJSON,
  ya as FungibleResourcesCollectionToJSON,
  te as GatewayApiClient,
  lp as GatewayErrorBaseFromJSON,
  ha as GatewayErrorBaseFromJSONTyped,
  sp as GatewayErrorBaseToJSON,
  ra as GatewayErrorFromJSON,
  ia as GatewayErrorFromJSONTyped,
  aa as GatewayErrorToJSON,
  dp as GatewayInfoResponseKnownTargetFromJSON,
  Aa as GatewayInfoResponseKnownTargetFromJSONTyped,
  fp as GatewayInfoResponseKnownTargetToJSON,
  qt as GatewayInfoResponseReleaseInfoFromJSON,
  Ia as GatewayInfoResponseReleaseInfoFromJSONTyped,
  Ut as GatewayInfoResponseReleaseInfoToJSON,
  Sp as GatewayStatusResponseAllOfFromJSON,
  Va as GatewayStatusResponseAllOfFromJSONTyped,
  Op as GatewayStatusResponseAllOfToJSON,
  Ja as GatewayStatusResponseFromJSON,
  va as GatewayStatusResponseFromJSONTyped,
  pp as GatewayStatusResponseToJSON,
  Fp as InternalServerErrorAllOfFromJSON,
  Ra as InternalServerErrorAllOfFromJSONTyped,
  hp as InternalServerErrorAllOfToJSON,
  bp as InternalServerErrorAllOfTypeEnum,
  dy as InternalServerErrorFromJSON,
  Jt as InternalServerErrorFromJSONTyped,
  Zi as InternalServerErrorToJSON,
  sy as InternalServerErrorTypeEnum,
  Tp as InvalidEntityErrorAllOfFromJSON,
  ka as InvalidEntityErrorAllOfFromJSONTyped,
  Jp as InvalidEntityErrorAllOfToJSON,
  Ap as InvalidEntityErrorAllOfTypeEnum,
  my as InvalidEntityErrorFromJSON,
  vt as InvalidEntityErrorFromJSONTyped,
  Qi as InvalidEntityErrorToJSON,
  fy as InvalidEntityErrorTypeEnum,
  Rp as InvalidRequestErrorAllOfFromJSON,
  Ea as InvalidRequestErrorAllOfFromJSONTyped,
  kp as InvalidRequestErrorAllOfToJSON,
  vp as InvalidRequestErrorAllOfTypeEnum,
  Sy as InvalidRequestErrorFromJSON,
  kt as InvalidRequestErrorFromJSONTyped,
  ji as InvalidRequestErrorToJSON,
  py as InvalidRequestErrorTypeEnum,
  Pp as InvalidTransactionErrorAllOfFromJSON,
  Da as InvalidTransactionErrorAllOfFromJSONTyped,
  wp as InvalidTransactionErrorAllOfToJSON,
  Ep as InvalidTransactionErrorAllOfTypeEnum,
  Ny as InvalidTransactionErrorFromJSON,
  Et as InvalidTransactionErrorFromJSONTyped,
  ea as InvalidTransactionErrorToJSON,
  Oy as InvalidTransactionErrorTypeEnum,
  s as JSONApiResponse,
  f as LedgerStateFromJSON,
  Ta as LedgerStateFromJSONTyped,
  xp as LedgerStateMixinFromJSON,
  Pa as LedgerStateMixinFromJSONTyped,
  Cp as LedgerStateMixinToJSON,
  c as LedgerStateSelectorFromJSON,
  Wn as LedgerStateSelectorFromJSONTyped,
  d as LedgerStateSelectorToJSON,
  _ as LedgerStateToJSON,
  Kp as MetadataBoolArrayValueAllOfFromJSON,
  wa as MetadataBoolArrayValueAllOfFromJSONTyped,
  Lp as MetadataBoolArrayValueAllOfToJSON,
  qp as MetadataBoolArrayValueAllOfTypeEnum,
  zf as MetadataBoolArrayValueFromJSON,
  Ue as MetadataBoolArrayValueFromJSONTyped,
  ti as MetadataBoolArrayValueToJSON,
  $f as MetadataBoolArrayValueTypeEnum,
  Hp as MetadataBoolValueAllOfFromJSON,
  Ma as MetadataBoolValueAllOfFromJSONTyped,
  $p as MetadataBoolValueAllOfToJSON,
  Bp as MetadataBoolValueAllOfTypeEnum,
  Qf as MetadataBoolValueFromJSON,
  Ke as MetadataBoolValueFromJSONTyped,
  ni as MetadataBoolValueToJSON,
  Xf as MetadataBoolValueTypeEnum,
  Xp as MetadataDecimalArrayValueAllOfFromJSON,
  xa as MetadataDecimalArrayValueAllOfFromJSONTyped,
  Zp as MetadataDecimalArrayValueAllOfToJSON,
  Wp as MetadataDecimalArrayValueAllOfTypeEnum,
  e_ as MetadataDecimalArrayValueFromJSON,
  Le as MetadataDecimalArrayValueFromJSONTyped,
  ri as MetadataDecimalArrayValueToJSON,
  Yf as MetadataDecimalArrayValueTypeEnum,
  jp as MetadataDecimalValueAllOfFromJSON,
  Ca as MetadataDecimalValueAllOfFromJSONTyped,
  eg as MetadataDecimalValueAllOfToJSON,
  Qp as MetadataDecimalValueAllOfTypeEnum,
  r_ as MetadataDecimalValueFromJSON,
  Be as MetadataDecimalValueFromJSONTyped,
  ii as MetadataDecimalValueToJSON,
  t_ as MetadataDecimalValueTypeEnum,
  rg as MetadataGlobalAddressArrayValueAllOfFromJSON,
  qa as MetadataGlobalAddressArrayValueAllOfFromJSONTyped,
  ig as MetadataGlobalAddressArrayValueAllOfToJSON,
  tg as MetadataGlobalAddressArrayValueAllOfTypeEnum,
  o_ as MetadataGlobalAddressArrayValueFromJSON,
  Ge as MetadataGlobalAddressArrayValueFromJSONTyped,
  ai as MetadataGlobalAddressArrayValueToJSON,
  i_ as MetadataGlobalAddressArrayValueTypeEnum,
  ug as MetadataGlobalAddressValueAllOfFromJSON,
  Ua as MetadataGlobalAddressValueAllOfFromJSONTyped,
  lg as MetadataGlobalAddressValueAllOfToJSON,
  ag as MetadataGlobalAddressValueAllOfTypeEnum,
  s_ as MetadataGlobalAddressValueFromJSON,
  He as MetadataGlobalAddressValueFromJSONTyped,
  oi as MetadataGlobalAddressValueToJSON,
  u_ as MetadataGlobalAddressValueTypeEnum,
  dg as MetadataI32ArrayValueAllOfFromJSON,
  Ka as MetadataI32ArrayValueAllOfFromJSONTyped,
  fg as MetadataI32ArrayValueAllOfToJSON,
  sg as MetadataI32ArrayValueAllOfTypeEnum,
  f_ as MetadataI32ArrayValueFromJSON,
  $e as MetadataI32ArrayValueFromJSONTyped,
  ui as MetadataI32ArrayValueToJSON,
  c_ as MetadataI32ArrayValueTypeEnum,
  yg as MetadataI32ValueAllOfFromJSON,
  La as MetadataI32ValueAllOfFromJSONTyped,
  pg as MetadataI32ValueAllOfToJSON,
  _g as MetadataI32ValueAllOfTypeEnum,
  y_ as MetadataI32ValueFromJSON,
  We as MetadataI32ValueFromJSONTyped,
  li as MetadataI32ValueToJSON,
  __ as MetadataI32ValueTypeEnum,
  Og as MetadataI64ArrayValueAllOfFromJSON,
  Ba as MetadataI64ArrayValueAllOfFromJSONTyped,
  bg as MetadataI64ArrayValueAllOfToJSON,
  gg as MetadataI64ArrayValueAllOfTypeEnum,
  S_ as MetadataI64ArrayValueFromJSON,
  ze as MetadataI64ArrayValueFromJSONTyped,
  si as MetadataI64ArrayValueToJSON,
  p_ as MetadataI64ArrayValueTypeEnum,
  hg as MetadataI64ValueAllOfFromJSON,
  Ga as MetadataI64ValueAllOfFromJSONTyped,
  Ag as MetadataI64ValueAllOfToJSON,
  Ng as MetadataI64ValueAllOfTypeEnum,
  N_ as MetadataI64ValueFromJSON,
  Xe as MetadataI64ValueFromJSONTyped,
  ci as MetadataI64ValueToJSON,
  O_ as MetadataI64ValueTypeEnum,
  Jg as MetadataInstantArrayValueAllOfFromJSON,
  Ha as MetadataInstantArrayValueAllOfFromJSONTyped,
  vg as MetadataInstantArrayValueAllOfToJSON,
  Ig as MetadataInstantArrayValueAllOfTypeEnum,
  A_ as MetadataInstantArrayValueFromJSON,
  Ze as MetadataInstantArrayValueFromJSONTyped,
  di as MetadataInstantArrayValueToJSON,
  F_ as MetadataInstantArrayValueTypeEnum,
  kg as MetadataInstantValueAllOfFromJSON,
  $a as MetadataInstantValueAllOfFromJSONTyped,
  Eg as MetadataInstantValueAllOfToJSON,
  Vg as MetadataInstantValueAllOfTypeEnum,
  J_ as MetadataInstantValueFromJSON,
  Qe as MetadataInstantValueFromJSONTyped,
  fi as MetadataInstantValueToJSON,
  I_ as MetadataInstantValueTypeEnum,
  wg as MetadataNonFungibleGlobalIdArrayValueAllOfFromJSON,
  Wa as MetadataNonFungibleGlobalIdArrayValueAllOfFromJSONTyped,
  Mg as MetadataNonFungibleGlobalIdArrayValueAllOfToJSON,
  Dg as MetadataNonFungibleGlobalIdArrayValueAllOfTypeEnum,
  Ye as MetadataNonFungibleGlobalIdArrayValueAllOfValuesFromJSON,
  _i as MetadataNonFungibleGlobalIdArrayValueAllOfValuesFromJSONTyped,
  je as MetadataNonFungibleGlobalIdArrayValueAllOfValuesToJSON,
  k_ as MetadataNonFungibleGlobalIdArrayValueFromJSON,
  et as MetadataNonFungibleGlobalIdArrayValueFromJSONTyped,
  mi as MetadataNonFungibleGlobalIdArrayValueToJSON,
  V_ as MetadataNonFungibleGlobalIdArrayValueTypeEnum,
  qg as MetadataNonFungibleGlobalIdValueAllOfFromJSON,
  za as MetadataNonFungibleGlobalIdValueAllOfFromJSONTyped,
  Ug as MetadataNonFungibleGlobalIdValueAllOfToJSON,
  xg as MetadataNonFungibleGlobalIdValueAllOfTypeEnum,
  P_ as MetadataNonFungibleGlobalIdValueFromJSON,
  tt as MetadataNonFungibleGlobalIdValueFromJSONTyped,
  yi as MetadataNonFungibleGlobalIdValueToJSON,
  E_ as MetadataNonFungibleGlobalIdValueTypeEnum,
  Bg as MetadataNonFungibleLocalIdArrayValueAllOfFromJSON,
  Xa as MetadataNonFungibleLocalIdArrayValueAllOfFromJSONTyped,
  Gg as MetadataNonFungibleLocalIdArrayValueAllOfToJSON,
  Kg as MetadataNonFungibleLocalIdArrayValueAllOfTypeEnum,
  x_ as MetadataNonFungibleLocalIdArrayValueFromJSON,
  nt as MetadataNonFungibleLocalIdArrayValueFromJSONTyped,
  pi as MetadataNonFungibleLocalIdArrayValueToJSON,
  w_ as MetadataNonFungibleLocalIdArrayValueTypeEnum,
  Wg as MetadataNonFungibleLocalIdValueAllOfFromJSON,
  Za as MetadataNonFungibleLocalIdValueAllOfFromJSONTyped,
  zg as MetadataNonFungibleLocalIdValueAllOfToJSON,
  Hg as MetadataNonFungibleLocalIdValueAllOfTypeEnum,
  U_ as MetadataNonFungibleLocalIdValueFromJSON,
  rt as MetadataNonFungibleLocalIdValueFromJSONTyped,
  gi as MetadataNonFungibleLocalIdValueToJSON,
  C_ as MetadataNonFungibleLocalIdValueTypeEnum,
  Qg as MetadataOriginArrayValueAllOfFromJSON,
  Qa as MetadataOriginArrayValueAllOfFromJSONTyped,
  Yg as MetadataOriginArrayValueAllOfToJSON,
  Xg as MetadataOriginArrayValueAllOfTypeEnum,
  B_ as MetadataOriginArrayValueFromJSON,
  it as MetadataOriginArrayValueFromJSONTyped,
  Si as MetadataOriginArrayValueToJSON,
  K_ as MetadataOriginArrayValueTypeEnum,
  tS as MetadataOriginValueAllOfFromJSON,
  Ya as MetadataOriginValueAllOfFromJSONTyped,
  nS as MetadataOriginValueAllOfToJSON,
  jg as MetadataOriginValueAllOfTypeEnum,
  $_ as MetadataOriginValueFromJSON,
  at as MetadataOriginValueFromJSONTyped,
  Oi as MetadataOriginValueToJSON,
  G_ as MetadataOriginValueTypeEnum,
  aS as MetadataPublicKeyArrayValueAllOfFromJSON,
  ja as MetadataPublicKeyArrayValueAllOfFromJSONTyped,
  oS as MetadataPublicKeyArrayValueAllOfToJSON,
  rS as MetadataPublicKeyArrayValueAllOfTypeEnum,
  tm as MetadataPublicKeyArrayValueFromJSON,
  lt as MetadataPublicKeyArrayValueFromJSONTyped,
  hi as MetadataPublicKeyArrayValueToJSON,
  j_ as MetadataPublicKeyArrayValueTypeEnum,
  sS as MetadataPublicKeyHashArrayValueAllOfFromJSON,
  eo as MetadataPublicKeyHashArrayValueAllOfFromJSONTyped,
  cS as MetadataPublicKeyHashArrayValueAllOfToJSON,
  uS as MetadataPublicKeyHashArrayValueAllOfTypeEnum,
  cm as MetadataPublicKeyHashArrayValueFromJSON,
  dt as MetadataPublicKeyHashArrayValueFromJSONTyped,
  Ji as MetadataPublicKeyHashArrayValueToJSON,
  lm as MetadataPublicKeyHashArrayValueTypeEnum,
  _S as MetadataPublicKeyHashValueAllOfFromJSON,
  to as MetadataPublicKeyHashValueAllOfFromJSONTyped,
  mS as MetadataPublicKeyHashValueAllOfToJSON,
  dS as MetadataPublicKeyHashValueAllOfTypeEnum,
  _m as MetadataPublicKeyHashValueFromJSON,
  ft as MetadataPublicKeyHashValueFromJSONTyped,
  vi as MetadataPublicKeyHashValueToJSON,
  dm as MetadataPublicKeyHashValueTypeEnum,
  gS as MetadataPublicKeyValueAllOfFromJSON,
  no as MetadataPublicKeyValueAllOfFromJSONTyped,
  SS as MetadataPublicKeyValueAllOfToJSON,
  yS as MetadataPublicKeyValueAllOfTypeEnum,
  pm as MetadataPublicKeyValueFromJSON,
  _t as MetadataPublicKeyValueFromJSONTyped,
  Vi as MetadataPublicKeyValueToJSON,
  mm as MetadataPublicKeyValueTypeEnum,
  NS as MetadataStringArrayValueAllOfFromJSON,
  ro as MetadataStringArrayValueAllOfFromJSONTyped,
  FS as MetadataStringArrayValueAllOfToJSON,
  OS as MetadataStringArrayValueAllOfTypeEnum,
  Om as MetadataStringArrayValueFromJSON,
  mt as MetadataStringArrayValueFromJSONTyped,
  Ri as MetadataStringArrayValueToJSON,
  gm as MetadataStringArrayValueTypeEnum,
  IS as MetadataStringValueAllOfFromJSON,
  io as MetadataStringValueAllOfFromJSONTyped,
  TS as MetadataStringValueAllOfToJSON,
  hS as MetadataStringValueAllOfTypeEnum,
  Fm as MetadataStringValueFromJSON,
  yt as MetadataStringValueFromJSONTyped,
  ki as MetadataStringValueToJSON,
  bm as MetadataStringValueTypeEnum,
  RS as MetadataTypedValueBaseFromJSON,
  uo as MetadataTypedValueBaseFromJSONTyped,
  kS as MetadataTypedValueBaseToJSON,
  At as MetadataTypedValueFromJSON,
  Ui as MetadataTypedValueFromJSONTyped,
  It as MetadataTypedValueToJSON,
  PS as MetadataU32ArrayValueAllOfFromJSON,
  lo as MetadataU32ArrayValueAllOfFromJSONTyped,
  wS as MetadataU32ArrayValueAllOfToJSON,
  ES as MetadataU32ArrayValueAllOfTypeEnum,
  Im as MetadataU32ArrayValueFromJSON,
  pt as MetadataU32ArrayValueFromJSONTyped,
  Ei as MetadataU32ArrayValueToJSON,
  hm as MetadataU32ArrayValueTypeEnum,
  CS as MetadataU32ValueAllOfFromJSON,
  so as MetadataU32ValueAllOfFromJSONTyped,
  qS as MetadataU32ValueAllOfToJSON,
  MS as MetadataU32ValueAllOfTypeEnum,
  vm as MetadataU32ValueFromJSON,
  gt as MetadataU32ValueFromJSONTyped,
  Di as MetadataU32ValueToJSON,
  Tm as MetadataU32ValueTypeEnum,
  LS as MetadataU64ArrayValueAllOfFromJSON,
  co as MetadataU64ArrayValueAllOfFromJSONTyped,
  BS as MetadataU64ArrayValueAllOfToJSON,
  US as MetadataU64ArrayValueAllOfTypeEnum,
  km as MetadataU64ArrayValueFromJSON,
  St as MetadataU64ArrayValueFromJSONTyped,
  Pi as MetadataU64ArrayValueToJSON,
  Vm as MetadataU64ArrayValueTypeEnum,
  $S as MetadataU64ValueAllOfFromJSON,
  fo as MetadataU64ValueAllOfFromJSONTyped,
  WS as MetadataU64ValueAllOfToJSON,
  GS as MetadataU64ValueAllOfTypeEnum,
  Pm as MetadataU64ValueFromJSON,
  Ot as MetadataU64ValueFromJSONTyped,
  wi as MetadataU64ValueToJSON,
  Em as MetadataU64ValueTypeEnum,
  ZS as MetadataU8ArrayValueAllOfFromJSON,
  _o as MetadataU8ArrayValueAllOfFromJSONTyped,
  QS as MetadataU8ArrayValueAllOfToJSON,
  zS as MetadataU8ArrayValueAllOfTypeEnum,
  xm as MetadataU8ArrayValueFromJSON,
  bt as MetadataU8ArrayValueFromJSONTyped,
  Mi as MetadataU8ArrayValueToJSON,
  wm as MetadataU8ArrayValueTypeEnum,
  eO as MetadataU8ValueAllOfFromJSON,
  mo as MetadataU8ValueAllOfFromJSONTyped,
  tO as MetadataU8ValueAllOfToJSON,
  YS as MetadataU8ValueAllOfTypeEnum,
  Um as MetadataU8ValueFromJSON,
  Nt as MetadataU8ValueFromJSONTyped,
  xi as MetadataU8ValueToJSON,
  Cm as MetadataU8ValueTypeEnum,
  iO as MetadataUrlArrayValueAllOfFromJSON,
  yo as MetadataUrlArrayValueAllOfFromJSONTyped,
  aO as MetadataUrlArrayValueAllOfToJSON,
  nO as MetadataUrlArrayValueAllOfTypeEnum,
  Bm as MetadataUrlArrayValueFromJSON,
  Ft as MetadataUrlArrayValueFromJSONTyped,
  Ci as MetadataUrlArrayValueToJSON,
  Km as MetadataUrlArrayValueTypeEnum,
  lO as MetadataUrlValueAllOfFromJSON,
  po as MetadataUrlValueAllOfFromJSONTyped,
  sO as MetadataUrlValueAllOfToJSON,
  oO as MetadataUrlValueAllOfTypeEnum,
  $m as MetadataUrlValueFromJSON,
  ht as MetadataUrlValueFromJSONTyped,
  qi as MetadataUrlValueToJSON,
  Gm as MetadataUrlValueTypeEnum,
  JS as MetadataValueType,
  ao as MetadataValueTypeFromJSON,
  oo as MetadataValueTypeFromJSONTyped,
  vS as MetadataValueTypeToJSON,
  bo as NetworkConfigurationResponseFromJSON,
  No as NetworkConfigurationResponseFromJSONTyped,
  fO as NetworkConfigurationResponseToJSON,
  go as NetworkConfigurationResponseWellKnownAddressesFromJSON,
  So as NetworkConfigurationResponseWellKnownAddressesFromJSONTyped,
  Oo as NetworkConfigurationResponseWellKnownAddressesToJSON,
  _O as NonFungibleIdType,
  X as NonFungibleIdTypeFromJSON,
  Fo as NonFungibleIdTypeFromJSONTyped,
  mO as NonFungibleIdTypeToJSON,
  gO as NonFungibleIdsCollectionAllOfFromJSON,
  Ao as NonFungibleIdsCollectionAllOfFromJSONTyped,
  SO as NonFungibleIdsCollectionAllOfToJSON,
  Kt as NonFungibleIdsCollectionFromJSON,
  ho as NonFungibleIdsCollectionFromJSONTyped,
  Lt as NonFungibleIdsCollectionToJSON,
  VO as NonFungibleResourcesCollectionAllOfFromJSON,
  Do as NonFungibleResourcesCollectionAllOfFromJSONTyped,
  RO as NonFungibleResourcesCollectionAllOfToJSON,
  Ro as NonFungibleResourcesCollectionFromJSON,
  ko as NonFungibleResourcesCollectionFromJSONTyped,
  EO as NonFungibleResourcesCollectionItemBaseFromJSON,
  Po as NonFungibleResourcesCollectionItemBaseFromJSONTyped,
  DO as NonFungibleResourcesCollectionItemBaseToJSON,
  oe as NonFungibleResourcesCollectionItemFromJSON,
  Vo as NonFungibleResourcesCollectionItemFromJSONTyped,
  OO as NonFungibleResourcesCollectionItemGloballyAggregatedAggregationLevelEnum,
  PO as NonFungibleResourcesCollectionItemGloballyAggregatedAllOfAggregationLevelEnum,
  MO as NonFungibleResourcesCollectionItemGloballyAggregatedAllOfFromJSON,
  wo as NonFungibleResourcesCollectionItemGloballyAggregatedAllOfFromJSONTyped,
  xO as NonFungibleResourcesCollectionItemGloballyAggregatedAllOfToJSON,
  NO as NonFungibleResourcesCollectionItemGloballyAggregatedFromJSON,
  Bt as NonFungibleResourcesCollectionItemGloballyAggregatedFromJSONTyped,
  Io as NonFungibleResourcesCollectionItemGloballyAggregatedToJSON,
  ue as NonFungibleResourcesCollectionItemToJSON,
  AO as NonFungibleResourcesCollectionItemVaultAggregatedAggregationLevelEnum,
  CO as NonFungibleResourcesCollectionItemVaultAggregatedAllOfAggregationLevelEnum,
  UO as NonFungibleResourcesCollectionItemVaultAggregatedAllOfFromJSON,
  Mo as NonFungibleResourcesCollectionItemVaultAggregatedAllOfFromJSONTyped,
  KO as NonFungibleResourcesCollectionItemVaultAggregatedAllOfToJSON,
  TO as NonFungibleResourcesCollectionItemVaultAggregatedFromJSON,
  $t as NonFungibleResourcesCollectionItemVaultAggregatedFromJSONTyped,
  vo as NonFungibleResourcesCollectionItemVaultAggregatedToJSON,
  BO as NonFungibleResourcesCollectionItemVaultAggregatedVaultAllOfFromJSON,
  xo as NonFungibleResourcesCollectionItemVaultAggregatedVaultAllOfFromJSONTyped,
  GO as NonFungibleResourcesCollectionItemVaultAggregatedVaultAllOfToJSON,
  Gt as NonFungibleResourcesCollectionItemVaultAggregatedVaultFromJSON,
  Jo as NonFungibleResourcesCollectionItemVaultAggregatedVaultFromJSONTyped,
  $O as NonFungibleResourcesCollectionItemVaultAggregatedVaultItemAllOfFromJSON,
  Co as NonFungibleResourcesCollectionItemVaultAggregatedVaultItemAllOfFromJSONTyped,
  WO as NonFungibleResourcesCollectionItemVaultAggregatedVaultItemAllOfToJSON,
  q as NonFungibleResourcesCollectionItemVaultAggregatedVaultItemFromJSON,
  To as NonFungibleResourcesCollectionItemVaultAggregatedVaultItemFromJSONTyped,
  U as NonFungibleResourcesCollectionItemVaultAggregatedVaultItemToJSON,
  Ht as NonFungibleResourcesCollectionItemVaultAggregatedVaultToJSON,
  Eo as NonFungibleResourcesCollectionToJSON,
  ZO as NotSyncedUpErrorAllOfFromJSON,
  qo as NotSyncedUpErrorAllOfFromJSONTyped,
  QO as NotSyncedUpErrorAllOfToJSON,
  zO as NotSyncedUpErrorAllOfTypeEnum,
  Ay as NotSyncedUpErrorFromJSON,
  Dt as NotSyncedUpErrorFromJSONTyped,
  ta as NotSyncedUpErrorToJSON,
  Fy as NotSyncedUpErrorTypeEnum,
  Cf as ObjectModuleId,
  Wr as ObjectModuleIdFromJSON,
  zr as ObjectModuleIdFromJSONTyped,
  qf as ObjectModuleIdToJSON,
  nb as OptionalNonFungibleIdsCollectionAllOfFromJSON,
  Ko as OptionalNonFungibleIdsCollectionAllOfFromJSONTyped,
  rb as OptionalNonFungibleIdsCollectionAllOfToJSON,
  jO as OptionalNonFungibleIdsCollectionFromJSON,
  Uo as OptionalNonFungibleIdsCollectionFromJSONTyped,
  eb as OptionalNonFungibleIdsCollectionToJSON,
  Wt as PackageCodeCollectionItemFromJSON,
  Bo as PackageCodeCollectionItemFromJSONTyped,
  zt as PackageCodeCollectionItemToJSON,
  ib as PackageVmType,
  le as PackageVmTypeFromJSON,
  Lo as PackageVmTypeFromJSONTyped,
  ab as PackageVmTypeToJSON,
  sb as ProgrammaticScryptoSborValueArrayAllOfFromJSON,
  Go as ProgrammaticScryptoSborValueArrayAllOfFromJSONTyped,
  ub as ProgrammaticScryptoSborValueArrayAllOfKindEnum,
  cb as ProgrammaticScryptoSborValueArrayAllOfToJSON,
  Sd as ProgrammaticScryptoSborValueArrayFromJSON,
  pe as ProgrammaticScryptoSborValueArrayFromJSONTyped,
  pd as ProgrammaticScryptoSborValueArrayKindEnum,
  cr as ProgrammaticScryptoSborValueArrayToJSON,
  fb as ProgrammaticScryptoSborValueBaseFromJSON,
  Ho as ProgrammaticScryptoSborValueBaseFromJSONTyped,
  _b as ProgrammaticScryptoSborValueBaseToJSON,
  pb as ProgrammaticScryptoSborValueBoolAllOfFromJSON,
  $o as ProgrammaticScryptoSborValueBoolAllOfFromJSONTyped,
  mb as ProgrammaticScryptoSborValueBoolAllOfKindEnum,
  gb as ProgrammaticScryptoSborValueBoolAllOfToJSON,
  Nd as ProgrammaticScryptoSborValueBoolFromJSON,
  ge as ProgrammaticScryptoSborValueBoolFromJSONTyped,
  Od as ProgrammaticScryptoSborValueBoolKindEnum,
  dr as ProgrammaticScryptoSborValueBoolToJSON,
  bb as ProgrammaticScryptoSborValueBytesAllOfFromJSON,
  Wo as ProgrammaticScryptoSborValueBytesAllOfFromJSONTyped,
  Sb as ProgrammaticScryptoSborValueBytesAllOfKindEnum,
  Nb as ProgrammaticScryptoSborValueBytesAllOfToJSON,
  Ad as ProgrammaticScryptoSborValueBytesFromJSON,
  Se as ProgrammaticScryptoSborValueBytesFromJSONTyped,
  Fd as ProgrammaticScryptoSborValueBytesKindEnum,
  fr as ProgrammaticScryptoSborValueBytesToJSON,
  Ab as ProgrammaticScryptoSborValueDecimalAllOfFromJSON,
  zo as ProgrammaticScryptoSborValueDecimalAllOfFromJSONTyped,
  Fb as ProgrammaticScryptoSborValueDecimalAllOfKindEnum,
  Ib as ProgrammaticScryptoSborValueDecimalAllOfToJSON,
  Jd as ProgrammaticScryptoSborValueDecimalFromJSON,
  Oe as ProgrammaticScryptoSborValueDecimalFromJSONTyped,
  Id as ProgrammaticScryptoSborValueDecimalKindEnum,
  _r as ProgrammaticScryptoSborValueDecimalToJSON,
  vb as ProgrammaticScryptoSborValueEnumAllOfFromJSON,
  Xo as ProgrammaticScryptoSborValueEnumAllOfFromJSONTyped,
  Tb as ProgrammaticScryptoSborValueEnumAllOfKindEnum,
  Vb as ProgrammaticScryptoSborValueEnumAllOfToJSON,
  Rd as ProgrammaticScryptoSborValueEnumFromJSON,
  be as ProgrammaticScryptoSborValueEnumFromJSONTyped,
  vd as ProgrammaticScryptoSborValueEnumKindEnum,
  mr as ProgrammaticScryptoSborValueEnumToJSON,
  p as ProgrammaticScryptoSborValueFromJSON,
  Dr as ProgrammaticScryptoSborValueFromJSONTyped,
  Eb as ProgrammaticScryptoSborValueI128AllOfFromJSON,
  Zo as ProgrammaticScryptoSborValueI128AllOfFromJSONTyped,
  Rb as ProgrammaticScryptoSborValueI128AllOfKindEnum,
  Db as ProgrammaticScryptoSborValueI128AllOfToJSON,
  Dd as ProgrammaticScryptoSborValueI128FromJSON,
  Ne as ProgrammaticScryptoSborValueI128FromJSONTyped,
  kd as ProgrammaticScryptoSborValueI128KindEnum,
  yr as ProgrammaticScryptoSborValueI128ToJSON,
  Mb as ProgrammaticScryptoSborValueI16AllOfFromJSON,
  Qo as ProgrammaticScryptoSborValueI16AllOfFromJSONTyped,
  Pb as ProgrammaticScryptoSborValueI16AllOfKindEnum,
  xb as ProgrammaticScryptoSborValueI16AllOfToJSON,
  Md as ProgrammaticScryptoSborValueI16FromJSON,
  Fe as ProgrammaticScryptoSborValueI16FromJSONTyped,
  Pd as ProgrammaticScryptoSborValueI16KindEnum,
  pr as ProgrammaticScryptoSborValueI16ToJSON,
  Ub as ProgrammaticScryptoSborValueI32AllOfFromJSON,
  Yo as ProgrammaticScryptoSborValueI32AllOfFromJSONTyped,
  Cb as ProgrammaticScryptoSborValueI32AllOfKindEnum,
  Kb as ProgrammaticScryptoSborValueI32AllOfToJSON,
  qd as ProgrammaticScryptoSborValueI32FromJSON,
  he as ProgrammaticScryptoSborValueI32FromJSONTyped,
  xd as ProgrammaticScryptoSborValueI32KindEnum,
  gr as ProgrammaticScryptoSborValueI32ToJSON,
  Gb as ProgrammaticScryptoSborValueI64AllOfFromJSON,
  jo as ProgrammaticScryptoSborValueI64AllOfFromJSONTyped,
  Lb as ProgrammaticScryptoSborValueI64AllOfKindEnum,
  Hb as ProgrammaticScryptoSborValueI64AllOfToJSON,
  Ld as ProgrammaticScryptoSborValueI64FromJSON,
  Ae as ProgrammaticScryptoSborValueI64FromJSONTyped,
  Ud as ProgrammaticScryptoSborValueI64KindEnum,
  Sr as ProgrammaticScryptoSborValueI64ToJSON,
  zb as ProgrammaticScryptoSborValueI8AllOfFromJSON,
  eu as ProgrammaticScryptoSborValueI8AllOfFromJSONTyped,
  $b as ProgrammaticScryptoSborValueI8AllOfKindEnum,
  Xb as ProgrammaticScryptoSborValueI8AllOfToJSON,
  Hd as ProgrammaticScryptoSborValueI8FromJSON,
  Ie as ProgrammaticScryptoSborValueI8FromJSONTyped,
  Bd as ProgrammaticScryptoSborValueI8KindEnum,
  Or as ProgrammaticScryptoSborValueI8ToJSON,
  md as ProgrammaticScryptoSborValueKind,
  b as ProgrammaticScryptoSborValueKindFromJSON,
  sr as ProgrammaticScryptoSborValueKindFromJSONTyped,
  yd as ProgrammaticScryptoSborValueKindToJSON,
  Yb as ProgrammaticScryptoSborValueMapAllOfFromJSON,
  tu as ProgrammaticScryptoSborValueMapAllOfFromJSONTyped,
  Zb as ProgrammaticScryptoSborValueMapAllOfKindEnum,
  jb as ProgrammaticScryptoSborValueMapAllOfToJSON,
  Te as ProgrammaticScryptoSborValueMapEntryFromJSON,
  br as ProgrammaticScryptoSborValueMapEntryFromJSONTyped,
  Je as ProgrammaticScryptoSborValueMapEntryToJSON,
  Xd as ProgrammaticScryptoSborValueMapFromJSON,
  ve as ProgrammaticScryptoSborValueMapFromJSONTyped,
  Wd as ProgrammaticScryptoSborValueMapKindEnum,
  Nr as ProgrammaticScryptoSborValueMapToJSON,
  nN as ProgrammaticScryptoSborValueNonFungibleLocalIdAllOfFromJSON,
  nu as ProgrammaticScryptoSborValueNonFungibleLocalIdAllOfFromJSONTyped,
  eN as ProgrammaticScryptoSborValueNonFungibleLocalIdAllOfKindEnum,
  rN as ProgrammaticScryptoSborValueNonFungibleLocalIdAllOfToJSON,
  Yd as ProgrammaticScryptoSborValueNonFungibleLocalIdFromJSON,
  Ve as ProgrammaticScryptoSborValueNonFungibleLocalIdFromJSONTyped,
  Zd as ProgrammaticScryptoSborValueNonFungibleLocalIdKindEnum,
  Fr as ProgrammaticScryptoSborValueNonFungibleLocalIdToJSON,
  oN as ProgrammaticScryptoSborValueOwnAllOfFromJSON,
  ru as ProgrammaticScryptoSborValueOwnAllOfFromJSONTyped,
  iN as ProgrammaticScryptoSborValueOwnAllOfKindEnum,
  uN as ProgrammaticScryptoSborValueOwnAllOfToJSON,
  tf as ProgrammaticScryptoSborValueOwnFromJSON,
  Re as ProgrammaticScryptoSborValueOwnFromJSONTyped,
  jd as ProgrammaticScryptoSborValueOwnKindEnum,
  hr as ProgrammaticScryptoSborValueOwnToJSON,
  cN as ProgrammaticScryptoSborValuePreciseDecimalAllOfFromJSON,
  iu as ProgrammaticScryptoSborValuePreciseDecimalAllOfFromJSONTyped,
  lN as ProgrammaticScryptoSborValuePreciseDecimalAllOfKindEnum,
  dN as ProgrammaticScryptoSborValuePreciseDecimalAllOfToJSON,
  af as ProgrammaticScryptoSborValuePreciseDecimalFromJSON,
  ke as ProgrammaticScryptoSborValuePreciseDecimalFromJSONTyped,
  nf as ProgrammaticScryptoSborValuePreciseDecimalKindEnum,
  Ar as ProgrammaticScryptoSborValuePreciseDecimalToJSON,
  mN as ProgrammaticScryptoSborValueReferenceAllOfFromJSON,
  au as ProgrammaticScryptoSborValueReferenceAllOfFromJSONTyped,
  fN as ProgrammaticScryptoSborValueReferenceAllOfKindEnum,
  yN as ProgrammaticScryptoSborValueReferenceAllOfToJSON,
  lf as ProgrammaticScryptoSborValueReferenceFromJSON,
  Ee as ProgrammaticScryptoSborValueReferenceFromJSONTyped,
  of as ProgrammaticScryptoSborValueReferenceKindEnum,
  Ir as ProgrammaticScryptoSborValueReferenceToJSON,
  SN as ProgrammaticScryptoSborValueStringAllOfFromJSON,
  ou as ProgrammaticScryptoSborValueStringAllOfFromJSONTyped,
  pN as ProgrammaticScryptoSborValueStringAllOfKindEnum,
  ON as ProgrammaticScryptoSborValueStringAllOfToJSON,
  df as ProgrammaticScryptoSborValueStringFromJSON,
  De as ProgrammaticScryptoSborValueStringFromJSONTyped,
  sf as ProgrammaticScryptoSborValueStringKindEnum,
  Tr as ProgrammaticScryptoSborValueStringToJSON,
  g as ProgrammaticScryptoSborValueToJSON,
  FN as ProgrammaticScryptoSborValueTupleAllOfFromJSON,
  uu as ProgrammaticScryptoSborValueTupleAllOfFromJSONTyped,
  bN as ProgrammaticScryptoSborValueTupleAllOfKindEnum,
  hN as ProgrammaticScryptoSborValueTupleAllOfToJSON,
  mf as ProgrammaticScryptoSborValueTupleFromJSON,
  Pe as ProgrammaticScryptoSborValueTupleFromJSONTyped,
  ff as ProgrammaticScryptoSborValueTupleKindEnum,
  Jr as ProgrammaticScryptoSborValueTupleToJSON,
  TN as ProgrammaticScryptoSborValueU128AllOfFromJSON,
  lu as ProgrammaticScryptoSborValueU128AllOfFromJSONTyped,
  AN as ProgrammaticScryptoSborValueU128AllOfKindEnum,
  JN as ProgrammaticScryptoSborValueU128AllOfToJSON,
  gf as ProgrammaticScryptoSborValueU128FromJSON,
  we as ProgrammaticScryptoSborValueU128FromJSONTyped,
  yf as ProgrammaticScryptoSborValueU128KindEnum,
  vr as ProgrammaticScryptoSborValueU128ToJSON,
  RN as ProgrammaticScryptoSborValueU16AllOfFromJSON,
  su as ProgrammaticScryptoSborValueU16AllOfFromJSONTyped,
  vN as ProgrammaticScryptoSborValueU16AllOfKindEnum,
  kN as ProgrammaticScryptoSborValueU16AllOfToJSON,
  bf as ProgrammaticScryptoSborValueU16FromJSON,
  Me as ProgrammaticScryptoSborValueU16FromJSONTyped,
  Sf as ProgrammaticScryptoSborValueU16KindEnum,
  Vr as ProgrammaticScryptoSborValueU16ToJSON,
  PN as ProgrammaticScryptoSborValueU32AllOfFromJSON,
  cu as ProgrammaticScryptoSborValueU32AllOfFromJSONTyped,
  EN as ProgrammaticScryptoSborValueU32AllOfKindEnum,
  wN as ProgrammaticScryptoSborValueU32AllOfToJSON,
  hf as ProgrammaticScryptoSborValueU32FromJSON,
  xe as ProgrammaticScryptoSborValueU32FromJSONTyped,
  Nf as ProgrammaticScryptoSborValueU32KindEnum,
  Rr as ProgrammaticScryptoSborValueU32ToJSON,
  CN as ProgrammaticScryptoSborValueU64AllOfFromJSON,
  du as ProgrammaticScryptoSborValueU64AllOfFromJSONTyped,
  MN as ProgrammaticScryptoSborValueU64AllOfKindEnum,
  qN as ProgrammaticScryptoSborValueU64AllOfToJSON,
  Tf as ProgrammaticScryptoSborValueU64FromJSON,
  Ce as ProgrammaticScryptoSborValueU64FromJSONTyped,
  Af as ProgrammaticScryptoSborValueU64KindEnum,
  kr as ProgrammaticScryptoSborValueU64ToJSON,
  LN as ProgrammaticScryptoSborValueU8AllOfFromJSON,
  fu as ProgrammaticScryptoSborValueU8AllOfFromJSONTyped,
  UN as ProgrammaticScryptoSborValueU8AllOfKindEnum,
  BN as ProgrammaticScryptoSborValueU8AllOfToJSON,
  Vf as ProgrammaticScryptoSborValueU8FromJSON,
  qe as ProgrammaticScryptoSborValueU8FromJSONTyped,
  Jf as ProgrammaticScryptoSborValueU8KindEnum,
  Er as ProgrammaticScryptoSborValueU8ToJSON,
  WN as PublicKeyBaseFromJSON,
  yu as PublicKeyBaseFromJSONTyped,
  zN as PublicKeyBaseToJSON,
  QN as PublicKeyEcdsaSecp256k1AllOfFromJSON,
  pu as PublicKeyEcdsaSecp256k1AllOfFromJSONTyped,
  XN as PublicKeyEcdsaSecp256k1AllOfKeyTypeEnum,
  YN as PublicKeyEcdsaSecp256k1AllOfToJSON,
  X_ as PublicKeyEcdsaSecp256k1FromJSON,
  ot as PublicKeyEcdsaSecp256k1FromJSONTyped,
  W_ as PublicKeyEcdsaSecp256k1KeyTypeEnum,
  bi as PublicKeyEcdsaSecp256k1ToJSON,
  t0 as PublicKeyEddsaEd25519AllOfFromJSON,
  gu as PublicKeyEddsaEd25519AllOfFromJSONTyped,
  jN as PublicKeyEddsaEd25519AllOfKeyTypeEnum,
  n0 as PublicKeyEddsaEd25519AllOfToJSON,
  Y_ as PublicKeyEddsaEd25519FromJSON,
  ut as PublicKeyEddsaEd25519FromJSONTyped,
  Z_ as PublicKeyEddsaEd25519KeyTypeEnum,
  Ni as PublicKeyEddsaEd25519ToJSON,
  I as PublicKeyFromJSON,
  Fi as PublicKeyFromJSONTyped,
  o0 as PublicKeyHashBaseFromJSON,
  bu as PublicKeyHashBaseFromJSONTyped,
  u0 as PublicKeyHashBaseToJSON,
  c0 as PublicKeyHashEcdsaSecp256k1AllOfFromJSON,
  Nu as PublicKeyHashEcdsaSecp256k1AllOfFromJSONTyped,
  l0 as PublicKeyHashEcdsaSecp256k1AllOfKeyHashTypeEnum,
  d0 as PublicKeyHashEcdsaSecp256k1AllOfToJSON,
  im as PublicKeyHashEcdsaSecp256k1FromJSON,
  st as PublicKeyHashEcdsaSecp256k1FromJSONTyped,
  nm as PublicKeyHashEcdsaSecp256k1KeyHashTypeEnum,
  Ai as PublicKeyHashEcdsaSecp256k1ToJSON,
  m0 as PublicKeyHashEddsaEd25519AllOfFromJSON,
  Fu as PublicKeyHashEddsaEd25519AllOfFromJSONTyped,
  f0 as PublicKeyHashEddsaEd25519AllOfKeyHashTypeEnum,
  y0 as PublicKeyHashEddsaEd25519AllOfToJSON,
  um as PublicKeyHashEddsaEd25519FromJSON,
  ct as PublicKeyHashEddsaEd25519FromJSONTyped,
  am as PublicKeyHashEddsaEd25519KeyHashTypeEnum,
  Ii as PublicKeyHashEddsaEd25519ToJSON,
  W as PublicKeyHashFromJSON,
  Ti as PublicKeyHashFromJSONTyped,
  z as PublicKeyHashToJSON,
  r0 as PublicKeyHashType,
  Su as PublicKeyHashTypeFromJSON,
  Ou as PublicKeyHashTypeFromJSONTyped,
  i0 as PublicKeyHashTypeToJSON,
  T as PublicKeyToJSON,
  GN as PublicKeyType,
  _u as PublicKeyTypeFromJSON,
  mu as PublicKeyTypeFromJSONTyped,
  HN as PublicKeyTypeToJSON,
  S as RadixNetwork,
  Gc as RadixNetworkConfig,
  nT as RadixNetworkConfigById,
  m as RequiredError,
  ga as ResourceAggregationLevel,
  A as ResourceAggregationLevelFromJSON,
  Sa as ResourceAggregationLevelFromJSONTyped,
  $y as ResourceAggregationLevelToJSON,
  G as ResponseError,
  g0 as ResultSetCursorMixinFromJSON,
  hu as ResultSetCursorMixinFromJSONTyped,
  S0 as ResultSetCursorMixinToJSON,
  wf as RoleAssignmentResolution,
  Lr as RoleAssignmentResolutionFromJSON,
  Br as RoleAssignmentResolutionFromJSONTyped,
  Mf as RoleAssignmentResolutionToJSON,
  de as RoleKeyFromJSON,
  Xr as RoleKeyFromJSONTyped,
  fe as RoleKeyToJSON,
  Y as ScryptoSborValueFromJSON,
  Au as ScryptoSborValueFromJSONTyped,
  j as ScryptoSborValueToJSON,
  Uc as State,
  wc as StateApi,
  Xt as StateEntityDetailsOptInsFromJSON,
  Iu as StateEntityDetailsOptInsFromJSONTyped,
  Zt as StateEntityDetailsOptInsToJSON,
  A0 as StateEntityDetailsRequestAllOfFromJSON,
  vu as StateEntityDetailsRequestAllOfFromJSONTyped,
  I0 as StateEntityDetailsRequestAllOfToJSON,
  F0 as StateEntityDetailsRequestFromJSON,
  Tu as StateEntityDetailsRequestFromJSONTyped,
  Ju as StateEntityDetailsRequestToJSON,
  eF as StateEntityDetailsResponseAllOfFromJSON,
  Xu as StateEntityDetailsResponseAllOfFromJSONTyped,
  tF as StateEntityDetailsResponseAllOfToJSON,
  iF as StateEntityDetailsResponseComponentDetailsAllOfFromJSON,
  Zu as StateEntityDetailsResponseComponentDetailsAllOfFromJSONTyped,
  aF as StateEntityDetailsResponseComponentDetailsAllOfToJSON,
  nF as StateEntityDetailsResponseComponentDetailsAllOfTypeEnum,
  V0 as StateEntityDetailsResponseComponentDetailsFromJSON,
  Qt as StateEntityDetailsResponseComponentDetailsFromJSONTyped,
  Eu as StateEntityDetailsResponseComponentDetailsToJSON,
  J0 as StateEntityDetailsResponseComponentDetailsTypeEnum,
  Wu as StateEntityDetailsResponseFromJSON,
  zu as StateEntityDetailsResponseFromJSONTyped,
  lF as StateEntityDetailsResponseFungibleResourceDetailsAllOfFromJSON,
  Qu as StateEntityDetailsResponseFungibleResourceDetailsAllOfFromJSONTyped,
  sF as StateEntityDetailsResponseFungibleResourceDetailsAllOfToJSON,
  oF as StateEntityDetailsResponseFungibleResourceDetailsAllOfTypeEnum,
  E0 as StateEntityDetailsResponseFungibleResourceDetailsFromJSON,
  Yt as StateEntityDetailsResponseFungibleResourceDetailsFromJSONTyped,
  Du as StateEntityDetailsResponseFungibleResourceDetailsToJSON,
  R0 as StateEntityDetailsResponseFungibleResourceDetailsTypeEnum,
  fF as StateEntityDetailsResponseFungibleVaultDetailsAllOfFromJSON,
  Yu as StateEntityDetailsResponseFungibleVaultDetailsAllOfFromJSONTyped,
  _F as StateEntityDetailsResponseFungibleVaultDetailsAllOfToJSON,
  cF as StateEntityDetailsResponseFungibleVaultDetailsAllOfTypeEnum,
  w0 as StateEntityDetailsResponseFungibleVaultDetailsFromJSON,
  jt as StateEntityDetailsResponseFungibleVaultDetailsFromJSONTyped,
  Pu as StateEntityDetailsResponseFungibleVaultDetailsToJSON,
  D0 as StateEntityDetailsResponseFungibleVaultDetailsTypeEnum,
  Vu as StateEntityDetailsResponseItemAncestorIdentitiesFromJSON,
  Ru as StateEntityDetailsResponseItemAncestorIdentitiesFromJSONTyped,
  ku as StateEntityDetailsResponseItemAncestorIdentitiesToJSON,
  gF as StateEntityDetailsResponseItemDetailsBaseFromJSON,
  tl as StateEntityDetailsResponseItemDetailsBaseFromJSONTyped,
  SF as StateEntityDetailsResponseItemDetailsBaseToJSON,
  Bu as StateEntityDetailsResponseItemDetailsFromJSON,
  Gu as StateEntityDetailsResponseItemDetailsFromJSONTyped,
  Hu as StateEntityDetailsResponseItemDetailsToJSON,
  mF as StateEntityDetailsResponseItemDetailsType,
  ju as StateEntityDetailsResponseItemDetailsTypeFromJSON,
  el as StateEntityDetailsResponseItemDetailsTypeFromJSONTyped,
  yF as StateEntityDetailsResponseItemDetailsTypeToJSON,
  mn as StateEntityDetailsResponseItemFromJSON,
  $u as StateEntityDetailsResponseItemFromJSONTyped,
  yn as StateEntityDetailsResponseItemToJSON,
  NF as StateEntityDetailsResponseNonFungibleResourceDetailsAllOfFromJSON,
  nl as StateEntityDetailsResponseNonFungibleResourceDetailsAllOfFromJSONTyped,
  FF as StateEntityDetailsResponseNonFungibleResourceDetailsAllOfToJSON,
  OF as StateEntityDetailsResponseNonFungibleResourceDetailsAllOfTypeEnum,
  C0 as StateEntityDetailsResponseNonFungibleResourceDetailsFromJSON,
  en as StateEntityDetailsResponseNonFungibleResourceDetailsFromJSONTyped,
  wu as StateEntityDetailsResponseNonFungibleResourceDetailsToJSON,
  M0 as StateEntityDetailsResponseNonFungibleResourceDetailsTypeEnum,
  IF as StateEntityDetailsResponseNonFungibleVaultDetailsAllOfFromJSON,
  rl as StateEntityDetailsResponseNonFungibleVaultDetailsAllOfFromJSONTyped,
  TF as StateEntityDetailsResponseNonFungibleVaultDetailsAllOfToJSON,
  hF as StateEntityDetailsResponseNonFungibleVaultDetailsAllOfTypeEnum,
  K0 as StateEntityDetailsResponseNonFungibleVaultDetailsFromJSON,
  tn as StateEntityDetailsResponseNonFungibleVaultDetailsFromJSONTyped,
  Mu as StateEntityDetailsResponseNonFungibleVaultDetailsToJSON,
  q0 as StateEntityDetailsResponseNonFungibleVaultDetailsTypeEnum,
  VF as StateEntityDetailsResponsePackageDetailsAllOfFromJSON,
  il as StateEntityDetailsResponsePackageDetailsAllOfFromJSONTyped,
  RF as StateEntityDetailsResponsePackageDetailsAllOfToJSON,
  JF as StateEntityDetailsResponsePackageDetailsAllOfTypeEnum,
  EF as StateEntityDetailsResponsePackageDetailsBlueprintCollectionAllOfFromJSON,
  al as StateEntityDetailsResponsePackageDetailsBlueprintCollectionAllOfFromJSONTyped,
  DF as StateEntityDetailsResponsePackageDetailsBlueprintCollectionAllOfToJSON,
  an as StateEntityDetailsResponsePackageDetailsBlueprintCollectionFromJSON,
  Cu as StateEntityDetailsResponsePackageDetailsBlueprintCollectionFromJSONTyped,
  on as StateEntityDetailsResponsePackageDetailsBlueprintCollectionToJSON,
  nn as StateEntityDetailsResponsePackageDetailsBlueprintItemFromJSON,
  xu as StateEntityDetailsResponsePackageDetailsBlueprintItemFromJSONTyped,
  rn as StateEntityDetailsResponsePackageDetailsBlueprintItemToJSON,
  wF as StateEntityDetailsResponsePackageDetailsCodeCollectionAllOfFromJSON,
  ol as StateEntityDetailsResponsePackageDetailsCodeCollectionAllOfFromJSONTyped,
  MF as StateEntityDetailsResponsePackageDetailsCodeCollectionAllOfToJSON,
  un as StateEntityDetailsResponsePackageDetailsCodeCollectionFromJSON,
  qu as StateEntityDetailsResponsePackageDetailsCodeCollectionFromJSONTyped,
  ln as StateEntityDetailsResponsePackageDetailsCodeCollectionToJSON,
  X0 as StateEntityDetailsResponsePackageDetailsFromJSON,
  _n as StateEntityDetailsResponsePackageDetailsFromJSONTyped,
  CF as StateEntityDetailsResponsePackageDetailsSchemaCollectionAllOfFromJSON,
  ul as StateEntityDetailsResponsePackageDetailsSchemaCollectionAllOfFromJSONTyped,
  qF as StateEntityDetailsResponsePackageDetailsSchemaCollectionAllOfToJSON,
  dn as StateEntityDetailsResponsePackageDetailsSchemaCollectionFromJSON,
  Ku as StateEntityDetailsResponsePackageDetailsSchemaCollectionFromJSONTyped,
  fn as StateEntityDetailsResponsePackageDetailsSchemaCollectionToJSON,
  sn as StateEntityDetailsResponsePackageDetailsSchemaItemFromJSON,
  Uu as StateEntityDetailsResponsePackageDetailsSchemaItemFromJSONTyped,
  cn as StateEntityDetailsResponsePackageDetailsSchemaItemToJSON,
  Lu as StateEntityDetailsResponsePackageDetailsToJSON,
  W0 as StateEntityDetailsResponsePackageDetailsTypeEnum,
  Y0 as StateEntityDetailsResponseToJSON,
  BF as StateEntityFungibleResourceVaultsPageRequestAllOfFromJSON,
  cl as StateEntityFungibleResourceVaultsPageRequestAllOfFromJSONTyped,
  GF as StateEntityFungibleResourceVaultsPageRequestAllOfToJSON,
  KF as StateEntityFungibleResourceVaultsPageRequestFromJSON,
  ll as StateEntityFungibleResourceVaultsPageRequestFromJSONTyped,
  sl as StateEntityFungibleResourceVaultsPageRequestToJSON,
  dl as StateEntityFungibleResourceVaultsPageResponseFromJSON,
  fl as StateEntityFungibleResourceVaultsPageResponseFromJSONTyped,
  $F as StateEntityFungibleResourceVaultsPageResponseToJSON,
  QF as StateEntityFungiblesPageRequestAllOfFromJSON,
  pl as StateEntityFungiblesPageRequestAllOfFromJSONTyped,
  YF as StateEntityFungiblesPageRequestAllOfToJSON,
  XF as StateEntityFungiblesPageRequestFromJSON,
  ml as StateEntityFungiblesPageRequestFromJSONTyped,
  pn as StateEntityFungiblesPageRequestOptInsFromJSON,
  _l as StateEntityFungiblesPageRequestOptInsFromJSONTyped,
  gn as StateEntityFungiblesPageRequestOptInsToJSON,
  yl as StateEntityFungiblesPageRequestToJSON,
  gl as StateEntityFungiblesPageResponseFromJSON,
  Sl as StateEntityFungiblesPageResponseFromJSONTyped,
  eh as StateEntityFungiblesPageResponseToJSON,
  ih as StateEntityMetadataPageRequestAllOfFromJSON,
  Nl as StateEntityMetadataPageRequestAllOfFromJSONTyped,
  ah as StateEntityMetadataPageRequestAllOfToJSON,
  nh as StateEntityMetadataPageRequestFromJSON,
  Ol as StateEntityMetadataPageRequestFromJSONTyped,
  bl as StateEntityMetadataPageRequestToJSON,
  Fl as StateEntityMetadataPageResponseFromJSON,
  hl as StateEntityMetadataPageResponseFromJSONTyped,
  uh as StateEntityMetadataPageResponseToJSON,
  dh as StateEntityNonFungibleIdsPageRequestAllOfFromJSON,
  Tl as StateEntityNonFungibleIdsPageRequestAllOfFromJSONTyped,
  fh as StateEntityNonFungibleIdsPageRequestAllOfToJSON,
  sh as StateEntityNonFungibleIdsPageRequestFromJSON,
  Al as StateEntityNonFungibleIdsPageRequestFromJSONTyped,
  Il as StateEntityNonFungibleIdsPageRequestToJSON,
  Jl as StateEntityNonFungibleIdsPageResponseFromJSON,
  vl as StateEntityNonFungibleIdsPageResponseFromJSONTyped,
  mh as StateEntityNonFungibleIdsPageResponseToJSON,
  Sn as StateEntityNonFungibleResourceVaultsPageOptInsFromJSON,
  Vl as StateEntityNonFungibleResourceVaultsPageOptInsFromJSONTyped,
  On as StateEntityNonFungibleResourceVaultsPageOptInsToJSON,
  Oh as StateEntityNonFungibleResourceVaultsPageRequestAllOfFromJSON,
  El as StateEntityNonFungibleResourceVaultsPageRequestAllOfFromJSONTyped,
  bh as StateEntityNonFungibleResourceVaultsPageRequestAllOfToJSON,
  gh as StateEntityNonFungibleResourceVaultsPageRequestFromJSON,
  Rl as StateEntityNonFungibleResourceVaultsPageRequestFromJSONTyped,
  kl as StateEntityNonFungibleResourceVaultsPageRequestToJSON,
  Dl as StateEntityNonFungibleResourceVaultsPageResponseFromJSON,
  Pl as StateEntityNonFungibleResourceVaultsPageResponseFromJSONTyped,
  Fh as StateEntityNonFungibleResourceVaultsPageResponseToJSON,
  Jh as StateEntityNonFungiblesPageRequestAllOfFromJSON,
  Cl as StateEntityNonFungiblesPageRequestAllOfFromJSONTyped,
  vh as StateEntityNonFungiblesPageRequestAllOfToJSON,
  Ih as StateEntityNonFungiblesPageRequestFromJSON,
  Ml as StateEntityNonFungiblesPageRequestFromJSONTyped,
  bn as StateEntityNonFungiblesPageRequestOptInsFromJSON,
  wl as StateEntityNonFungiblesPageRequestOptInsFromJSONTyped,
  Nn as StateEntityNonFungiblesPageRequestOptInsToJSON,
  xl as StateEntityNonFungiblesPageRequestToJSON,
  ql as StateEntityNonFungiblesPageResponseFromJSON,
  Ul as StateEntityNonFungiblesPageResponseFromJSONTyped,
  Rh as StateEntityNonFungiblesPageResponseToJSON,
  wh as StateKeyValueStoreDataRequestAllOfFromJSON,
  Gl as StateKeyValueStoreDataRequestAllOfFromJSONTyped,
  Mh as StateKeyValueStoreDataRequestAllOfToJSON,
  Dh as StateKeyValueStoreDataRequestFromJSON,
  Ll as StateKeyValueStoreDataRequestFromJSONTyped,
  Fn as StateKeyValueStoreDataRequestKeyItemFromJSON,
  Kl as StateKeyValueStoreDataRequestKeyItemFromJSONTyped,
  hn as StateKeyValueStoreDataRequestKeyItemToJSON,
  Bl as StateKeyValueStoreDataRequestToJSON,
  Kh as StateKeyValueStoreDataResponseAllOfFromJSON,
  zl as StateKeyValueStoreDataResponseAllOfFromJSONTyped,
  Lh as StateKeyValueStoreDataResponseAllOfToJSON,
  $l as StateKeyValueStoreDataResponseFromJSON,
  Wl as StateKeyValueStoreDataResponseFromJSONTyped,
  An as StateKeyValueStoreDataResponseItemFromJSON,
  Hl as StateKeyValueStoreDataResponseItemFromJSONTyped,
  In as StateKeyValueStoreDataResponseItemToJSON,
  qh as StateKeyValueStoreDataResponseToJSON,
  Gh as StateNonFungibleDataRequestFromJSON,
  Xl as StateNonFungibleDataRequestFromJSONTyped,
  Zl as StateNonFungibleDataRequestToJSON,
  Xh as StateNonFungibleDataResponseAllOfFromJSON,
  es as StateNonFungibleDataResponseAllOfFromJSONTyped,
  Zh as StateNonFungibleDataResponseAllOfToJSON,
  Yl as StateNonFungibleDataResponseFromJSON,
  jl as StateNonFungibleDataResponseFromJSONTyped,
  Wh as StateNonFungibleDataResponseToJSON,
  Tn as StateNonFungibleDetailsResponseItemFromJSON,
  Ql as StateNonFungibleDetailsResponseItemFromJSONTyped,
  Jn as StateNonFungibleDetailsResponseItemToJSON,
  eA as StateNonFungibleIdsRequestAllOfFromJSON,
  rs as StateNonFungibleIdsRequestAllOfFromJSONTyped,
  tA as StateNonFungibleIdsRequestAllOfToJSON,
  Yh as StateNonFungibleIdsRequestFromJSON,
  ts as StateNonFungibleIdsRequestFromJSONTyped,
  ns as StateNonFungibleIdsRequestToJSON,
  aA as StateNonFungibleIdsResponseAllOfFromJSON,
  os as StateNonFungibleIdsResponseAllOfFromJSONTyped,
  oA as StateNonFungibleIdsResponseAllOfToJSON,
  is as StateNonFungibleIdsResponseFromJSON,
  as as StateNonFungibleIdsResponseFromJSONTyped,
  rA as StateNonFungibleIdsResponseToJSON,
  cA as StateNonFungibleLocationRequestAllOfFromJSON,
  ss as StateNonFungibleLocationRequestAllOfFromJSONTyped,
  dA as StateNonFungibleLocationRequestAllOfToJSON,
  lA as StateNonFungibleLocationRequestFromJSON,
  us as StateNonFungibleLocationRequestFromJSONTyped,
  ls as StateNonFungibleLocationRequestToJSON,
  pA as StateNonFungibleLocationResponseAllOfFromJSON,
  _s as StateNonFungibleLocationResponseAllOfFromJSONTyped,
  gA as StateNonFungibleLocationResponseAllOfToJSON,
  ds as StateNonFungibleLocationResponseFromJSON,
  fs as StateNonFungibleLocationResponseFromJSONTyped,
  vn as StateNonFungibleLocationResponseItemFromJSON,
  cs as StateNonFungibleLocationResponseItemFromJSONTyped,
  Vn as StateNonFungibleLocationResponseItemToJSON,
  mA as StateNonFungibleLocationResponseToJSON,
  NA as StateValidatorsListRequestAllOfFromJSON,
  ps as StateValidatorsListRequestAllOfFromJSONTyped,
  FA as StateValidatorsListRequestAllOfToJSON,
  OA as StateValidatorsListRequestFromJSON,
  ms as StateValidatorsListRequestFromJSONTyped,
  ys as StateValidatorsListRequestToJSON,
  DA as StateValidatorsListResponseAllOfFromJSON,
  Ps as StateValidatorsListResponseAllOfFromJSONTyped,
  PA as StateValidatorsListResponseAllOfToJSON,
  Es as StateValidatorsListResponseFromJSON,
  Ds as StateValidatorsListResponseFromJSONTyped,
  kA as StateValidatorsListResponseToJSON,
  Hc as Statistics,
  Mc as StatisticsApi,
  $c as Status,
  xc as StatusApi,
  Wc as Stream,
  Cc as StreamApi,
  HA as StreamTransactionsRequestAllOfFromJSON,
  qs as StreamTransactionsRequestAllOfFromJSONTyped,
  LA as StreamTransactionsRequestAllOfKindFilterEnum,
  BA as StreamTransactionsRequestAllOfOrderEnum,
  $A as StreamTransactionsRequestAllOfToJSON,
  wA as StreamTransactionsRequestEventFilterItemEventEnum,
  Pn as StreamTransactionsRequestEventFilterItemFromJSON,
  ws as StreamTransactionsRequestEventFilterItemFromJSONTyped,
  wn as StreamTransactionsRequestEventFilterItemToJSON,
  KA as StreamTransactionsRequestFromJSON,
  xs as StreamTransactionsRequestFromJSONTyped,
  CA as StreamTransactionsRequestKindFilterEnum,
  qA as StreamTransactionsRequestOrderEnum,
  Cs as StreamTransactionsRequestToJSON,
  ZA as StreamTransactionsResponseAllOfFromJSON,
  Ls as StreamTransactionsResponseAllOfFromJSONTyped,
  QA as StreamTransactionsResponseAllOfToJSON,
  Us as StreamTransactionsResponseFromJSON,
  Ks as StreamTransactionsResponseFromJSONTyped,
  zA as StreamTransactionsResponseToJSON,
  rd as TextApiResponse,
  zc as Transaction,
  qc as TransactionApi,
  or as TransactionBalanceChangesFromJSON,
  ur as TransactionBalanceChangesFromJSONTyped,
  lr as TransactionBalanceChangesToJSON,
  tI as TransactionCommittedDetailsRequestAllOfFromJSON,
  Hs as TransactionCommittedDetailsRequestAllOfFromJSONTyped,
  nI as TransactionCommittedDetailsRequestAllOfToJSON,
  jA as TransactionCommittedDetailsRequestFromJSON,
  Bs as TransactionCommittedDetailsRequestFromJSONTyped,
  Gs as TransactionCommittedDetailsRequestToJSON,
  oI as TransactionCommittedDetailsResponseAllOfFromJSON,
  zs as TransactionCommittedDetailsResponseAllOfFromJSONTyped,
  uI as TransactionCommittedDetailsResponseAllOfToJSON,
  $s as TransactionCommittedDetailsResponseFromJSON,
  Ws as TransactionCommittedDetailsResponseFromJSONTyped,
  iI as TransactionCommittedDetailsResponseToJSON,
  Xs as TransactionConstructionResponseFromJSON,
  Zs as TransactionConstructionResponseFromJSONTyped,
  sI as TransactionConstructionResponseToJSON,
  Z as TransactionDetailsOptInsFromJSON,
  Ms as TransactionDetailsOptInsFromJSONTyped,
  Q as TransactionDetailsOptInsToJSON,
  Xn as TransactionFungibleBalanceChangesFromJSON,
  Zn as TransactionFungibleBalanceChangesFromJSONTyped,
  Qn as TransactionFungibleBalanceChangesToJSON,
  sd as TransactionFungibleFeeBalanceChangeType,
  Yn as TransactionFungibleFeeBalanceChangeTypeFromJSON,
  jn as TransactionFungibleFeeBalanceChangeTypeFromJSONTyped,
  cd as TransactionFungibleFeeBalanceChangeTypeToJSON,
  er as TransactionFungibleFeeBalanceChangesFromJSON,
  tr as TransactionFungibleFeeBalanceChangesFromJSONTyped,
  nr as TransactionFungibleFeeBalanceChangesToJSON,
  cI as TransactionIntentStatus,
  Mn as TransactionIntentStatusFromJSON,
  Qs as TransactionIntentStatusFromJSONTyped,
  dI as TransactionIntentStatusToJSON,
  rr as TransactionNonFungibleBalanceChangesFromJSON,
  ir as TransactionNonFungibleBalanceChangesFromJSONTyped,
  ar as TransactionNonFungibleBalanceChangesToJSON,
  mI as TransactionNotFoundErrorAllOfFromJSON,
  Ys as TransactionNotFoundErrorAllOfFromJSONTyped,
  yI as TransactionNotFoundErrorAllOfToJSON,
  fI as TransactionNotFoundErrorAllOfTypeEnum,
  Jy as TransactionNotFoundErrorFromJSON,
  Pt as TransactionNotFoundErrorFromJSONTyped,
  na as TransactionNotFoundErrorToJSON,
  Iy as TransactionNotFoundErrorTypeEnum,
  pI as TransactionPayloadGatewayHandlingStatus,
  js as TransactionPayloadGatewayHandlingStatusFromJSON,
  ec as TransactionPayloadGatewayHandlingStatusFromJSONTyped,
  gI as TransactionPayloadGatewayHandlingStatusToJSON,
  SI as TransactionPayloadStatus,
  tc as TransactionPayloadStatusFromJSON,
  nc as TransactionPayloadStatusFromJSONTyped,
  OI as TransactionPayloadStatusToJSON,
  rc as TransactionPreviewRequestFlagsFromJSON,
  ic as TransactionPreviewRequestFlagsFromJSONTyped,
  ac as TransactionPreviewRequestFlagsToJSON,
  FI as TransactionPreviewRequestFromJSON,
  oc as TransactionPreviewRequestFromJSONTyped,
  uc as TransactionPreviewRequestToJSON,
  dc as TransactionPreviewResponseFromJSON,
  fc as TransactionPreviewResponseFromJSONTyped,
  lc as TransactionPreviewResponseLogsInnerFromJSON,
  sc as TransactionPreviewResponseLogsInnerFromJSONTyped,
  cc as TransactionPreviewResponseLogsInnerToJSON,
  II as TransactionPreviewResponseToJSON,
  Cr as TransactionReceiptFromJSON,
  qr as TransactionReceiptFromJSONTyped,
  Ur as TransactionReceiptToJSON,
  kf as TransactionStatus,
  M as TransactionStatusFromJSON,
  xr as TransactionStatusFromJSONTyped,
  VI as TransactionStatusRequestAllOfFromJSON,
  yc as TransactionStatusRequestAllOfFromJSONTyped,
  RI as TransactionStatusRequestAllOfToJSON,
  JI as TransactionStatusRequestFromJSON,
  _c as TransactionStatusRequestFromJSONTyped,
  mc as TransactionStatusRequestToJSON,
  wI as TransactionStatusResponseAllOfFromJSON,
  Oc as TransactionStatusResponseAllOfFromJSONTyped,
  MI as TransactionStatusResponseAllOfToJSON,
  gc as TransactionStatusResponseFromJSON,
  Sc as TransactionStatusResponseFromJSONTyped,
  xn as TransactionStatusResponseKnownPayloadItemFromJSON,
  pc as TransactionStatusResponseKnownPayloadItemFromJSONTyped,
  Cn as TransactionStatusResponseKnownPayloadItemToJSON,
  DI as TransactionStatusResponseToJSON,
  Ef as TransactionStatusToJSON,
  CI as TransactionSubmitRequestFromJSON,
  bc as TransactionSubmitRequestFromJSONTyped,
  Nc as TransactionSubmitRequestToJSON,
  Fc as TransactionSubmitResponseFromJSON,
  hc as TransactionSubmitResponseFromJSONTyped,
  UI as TransactionSubmitResponseToJSON,
  Vt as ValidationErrorsAtPathFromJSON,
  Yi as ValidationErrorsAtPathFromJSONTyped,
  Rt as ValidationErrorsAtPathToJSON,
  LI as ValidatorCollectionAllOfFromJSON,
  Ac as ValidatorCollectionAllOfFromJSONTyped,
  BI as ValidatorCollectionAllOfToJSON,
  En as ValidatorCollectionFromJSON,
  ks as ValidatorCollectionFromJSONTyped,
  gs as ValidatorCollectionItemActiveInEpochFromJSON,
  Ss as ValidatorCollectionItemActiveInEpochFromJSONTyped,
  Os as ValidatorCollectionItemActiveInEpochToJSON,
  bs as ValidatorCollectionItemEffectiveFeeFactorCurrentFromJSON,
  Ns as ValidatorCollectionItemEffectiveFeeFactorCurrentFromJSONTyped,
  Fs as ValidatorCollectionItemEffectiveFeeFactorCurrentToJSON,
  Ts as ValidatorCollectionItemEffectiveFeeFactorFromJSON,
  Js as ValidatorCollectionItemEffectiveFeeFactorFromJSONTyped,
  hs as ValidatorCollectionItemEffectiveFeeFactorPendingFromJSON,
  As as ValidatorCollectionItemEffectiveFeeFactorPendingFromJSONTyped,
  Is as ValidatorCollectionItemEffectiveFeeFactorPendingToJSON,
  vs as ValidatorCollectionItemEffectiveFeeFactorToJSON,
  Rn as ValidatorCollectionItemFromJSON,
  Rs as ValidatorCollectionItemFromJSONTyped,
  kn as ValidatorCollectionItemToJSON,
  Dn as ValidatorCollectionToJSON,
  qn as ValidatorUptimeCollectionFromJSON,
  vc as ValidatorUptimeCollectionFromJSONTyped,
  Ic as ValidatorUptimeCollectionItemFromJSON,
  Tc as ValidatorUptimeCollectionItemFromJSONTyped,
  Jc as ValidatorUptimeCollectionItemToJSON,
  Un as ValidatorUptimeCollectionToJSON,
  K as ValidatorVaultItemFromJSON,
  Vs as ValidatorVaultItemFromJSONTyped,
  L as ValidatorVaultItemToJSON,
  XI as ValidatorsUptimeRequestAllOfFromJSON,
  kc as ValidatorsUptimeRequestAllOfFromJSONTyped,
  ZI as ValidatorsUptimeRequestAllOfToJSON,
  WI as ValidatorsUptimeRequestFromJSON,
  Vc as ValidatorsUptimeRequestFromJSONTyped,
  Rc as ValidatorsUptimeRequestToJSON,
  eT as ValidatorsUptimeResponseAllOfFromJSON,
  Pc as ValidatorsUptimeResponseAllOfFromJSONTyped,
  tT as ValidatorsUptimeResponseAllOfToJSON,
  Ec as ValidatorsUptimeResponseFromJSON,
  Dc as ValidatorsUptimeResponseFromJSONTyped,
  YI as ValidatorsUptimeResponseToJSON,
  td as VoidApiResponse,
  ed as canConsumeForm,
  B as chunk,
  P as exhaustPaginationWithLedgerState,
  n as exists,
  ad as instanceOfAtLedgerStateMixin,
  Pf as instanceOfCommittedTransactionInfo,
  Kf as instanceOfComponentEntityRoleAssignmentEntry,
  xf as instanceOfComponentEntityRoleAssignmentEntryAssignment,
  Lf as instanceOfComponentEntityRoleAssignments,
  Bf as instanceOfCursorLimitMixin,
  Xm as instanceOfEntityMetadataCollection,
  Zm as instanceOfEntityMetadataCollectionAllOf,
  zm as instanceOfEntityMetadataItem,
  Wm as instanceOfEntityMetadataItemValue,
  jm as instanceOfEntityMetadataItemValueAllOf,
  ry as instanceOfEntityNotFoundError,
  oy as instanceOfEntityNotFoundErrorAllOf,
  vy as instanceOfErrorResponse,
  Rf as instanceOfEventsItem,
  ky as instanceOfFromLedgerStateMixin,
  Ly as instanceOfFungibleResourcesCollection,
  By as instanceOfFungibleResourcesCollectionAllOf,
  Wy as instanceOfFungibleResourcesCollectionItemBase,
  wy as instanceOfFungibleResourcesCollectionItemGloballyAggregated,
  Qy as instanceOfFungibleResourcesCollectionItemGloballyAggregatedAllOf,
  Uy as instanceOfFungibleResourcesCollectionItemVaultAggregated,
  tp as instanceOfFungibleResourcesCollectionItemVaultAggregatedAllOf,
  Cy as instanceOfFungibleResourcesCollectionItemVaultAggregatedVault,
  ip as instanceOfFungibleResourcesCollectionItemVaultAggregatedVaultAllOf,
  xy as instanceOfFungibleResourcesCollectionItemVaultAggregatedVaultItem,
  up as instanceOfGatewayErrorBase,
  cp as instanceOfGatewayInfoResponseKnownTarget,
  _p as instanceOfGatewayInfoResponseReleaseInfo,
  yp as instanceOfGatewayStatusResponse,
  gp as instanceOfGatewayStatusResponseAllOf,
  cy as instanceOfInternalServerError,
  Np as instanceOfInternalServerErrorAllOf,
  _y as instanceOfInvalidEntityError,
  Ip as instanceOfInvalidEntityErrorAllOf,
  gy as instanceOfInvalidRequestError,
  Vp as instanceOfInvalidRequestErrorAllOf,
  by as instanceOfInvalidTransactionError,
  Dp as instanceOfInvalidTransactionErrorAllOf,
  mp as instanceOfLedgerState,
  Mp as instanceOfLedgerStateMixin,
  id as instanceOfLedgerStateSelector,
  Wf as instanceOfMetadataBoolArrayValue,
  Up as instanceOfMetadataBoolArrayValueAllOf,
  Zf as instanceOfMetadataBoolValue,
  Gp as instanceOfMetadataBoolValueAllOf,
  jf as instanceOfMetadataDecimalArrayValue,
  zp as instanceOfMetadataDecimalArrayValueAllOf,
  n_ as instanceOfMetadataDecimalValue,
  Yp as instanceOfMetadataDecimalValueAllOf,
  a_ as instanceOfMetadataGlobalAddressArrayValue,
  ng as instanceOfMetadataGlobalAddressArrayValueAllOf,
  l_ as instanceOfMetadataGlobalAddressValue,
  og as instanceOfMetadataGlobalAddressValueAllOf,
  d_ as instanceOfMetadataI32ArrayValue,
  cg as instanceOfMetadataI32ArrayValueAllOf,
  m_ as instanceOfMetadataI32Value,
  mg as instanceOfMetadataI32ValueAllOf,
  g_ as instanceOfMetadataI64ArrayValue,
  Sg as instanceOfMetadataI64ArrayValueAllOf,
  b_ as instanceOfMetadataI64Value,
  Fg as instanceOfMetadataI64ValueAllOf,
  h_ as instanceOfMetadataInstantArrayValue,
  Tg as instanceOfMetadataInstantArrayValueAllOf,
  T_ as instanceOfMetadataInstantValue,
  Rg as instanceOfMetadataInstantValueAllOf,
  R_ as instanceOfMetadataNonFungibleGlobalIdArrayValue,
  Pg as instanceOfMetadataNonFungibleGlobalIdArrayValueAllOf,
  v_ as instanceOfMetadataNonFungibleGlobalIdArrayValueAllOfValues,
  D_ as instanceOfMetadataNonFungibleGlobalIdValue,
  Cg as instanceOfMetadataNonFungibleGlobalIdValueAllOf,
  M_ as instanceOfMetadataNonFungibleLocalIdArrayValue,
  Lg as instanceOfMetadataNonFungibleLocalIdArrayValueAllOf,
  q_ as instanceOfMetadataNonFungibleLocalIdValue,
  $g as instanceOfMetadataNonFungibleLocalIdValueAllOf,
  L_ as instanceOfMetadataOriginArrayValue,
  Zg as instanceOfMetadataOriginArrayValueAllOf,
  H_ as instanceOfMetadataOriginValue,
  eS as instanceOfMetadataOriginValueAllOf,
  em as instanceOfMetadataPublicKeyArrayValue,
  iS as instanceOfMetadataPublicKeyArrayValueAllOf,
  sm as instanceOfMetadataPublicKeyHashArrayValue,
  lS as instanceOfMetadataPublicKeyHashArrayValueAllOf,
  fm as instanceOfMetadataPublicKeyHashValue,
  fS as instanceOfMetadataPublicKeyHashValueAllOf,
  ym as instanceOfMetadataPublicKeyValue,
  pS as instanceOfMetadataPublicKeyValueAllOf,
  Sm as instanceOfMetadataStringArrayValue,
  bS as instanceOfMetadataStringArrayValueAllOf,
  Nm as instanceOfMetadataStringValue,
  AS as instanceOfMetadataStringValueAllOf,
  VS as instanceOfMetadataTypedValueBase,
  Am as instanceOfMetadataU32ArrayValue,
  DS as instanceOfMetadataU32ArrayValueAllOf,
  Jm as instanceOfMetadataU32Value,
  xS as instanceOfMetadataU32ValueAllOf,
  Rm as instanceOfMetadataU64ArrayValue,
  KS as instanceOfMetadataU64ArrayValueAllOf,
  Dm as instanceOfMetadataU64Value,
  HS as instanceOfMetadataU64ValueAllOf,
  Mm as instanceOfMetadataU8ArrayValue,
  XS as instanceOfMetadataU8ArrayValueAllOf,
  qm as instanceOfMetadataU8Value,
  jS as instanceOfMetadataU8ValueAllOf,
  Lm as instanceOfMetadataUrlArrayValue,
  rO as instanceOfMetadataUrlArrayValueAllOf,
  Hm as instanceOfMetadataUrlValue,
  uO as instanceOfMetadataUrlValueAllOf,
  dO as instanceOfNetworkConfigurationResponse,
  cO as instanceOfNetworkConfigurationResponseWellKnownAddresses,
  yO as instanceOfNonFungibleIdsCollection,
  pO as instanceOfNonFungibleIdsCollectionAllOf,
  JO as instanceOfNonFungibleResourcesCollection,
  vO as instanceOfNonFungibleResourcesCollectionAllOf,
  kO as instanceOfNonFungibleResourcesCollectionItemBase,
  bO as instanceOfNonFungibleResourcesCollectionItemGloballyAggregated,
  wO as instanceOfNonFungibleResourcesCollectionItemGloballyAggregatedAllOf,
  IO as instanceOfNonFungibleResourcesCollectionItemVaultAggregated,
  qO as instanceOfNonFungibleResourcesCollectionItemVaultAggregatedAllOf,
  hO as instanceOfNonFungibleResourcesCollectionItemVaultAggregatedVault,
  LO as instanceOfNonFungibleResourcesCollectionItemVaultAggregatedVaultAllOf,
  FO as instanceOfNonFungibleResourcesCollectionItemVaultAggregatedVaultItem,
  HO as instanceOfNonFungibleResourcesCollectionItemVaultAggregatedVaultItemAllOf,
  hy as instanceOfNotSyncedUpError,
  XO as instanceOfNotSyncedUpErrorAllOf,
  YO as instanceOfOptionalNonFungibleIdsCollection,
  tb as instanceOfOptionalNonFungibleIdsCollectionAllOf,
  ob as instanceOfPackageCodeCollectionItem,
  gd as instanceOfProgrammaticScryptoSborValueArray,
  lb as instanceOfProgrammaticScryptoSborValueArrayAllOf,
  db as instanceOfProgrammaticScryptoSborValueBase,
  bd as instanceOfProgrammaticScryptoSborValueBool,
  yb as instanceOfProgrammaticScryptoSborValueBoolAllOf,
  hd as instanceOfProgrammaticScryptoSborValueBytes,
  Ob as instanceOfProgrammaticScryptoSborValueBytesAllOf,
  Td as instanceOfProgrammaticScryptoSborValueDecimal,
  hb as instanceOfProgrammaticScryptoSborValueDecimalAllOf,
  Vd as instanceOfProgrammaticScryptoSborValueEnum,
  Jb as instanceOfProgrammaticScryptoSborValueEnumAllOf,
  Ed as instanceOfProgrammaticScryptoSborValueI128,
  kb as instanceOfProgrammaticScryptoSborValueI128AllOf,
  wd as instanceOfProgrammaticScryptoSborValueI16,
  wb as instanceOfProgrammaticScryptoSborValueI16AllOf,
  Cd as instanceOfProgrammaticScryptoSborValueI32,
  qb as instanceOfProgrammaticScryptoSborValueI32AllOf,
  Kd as instanceOfProgrammaticScryptoSborValueI64,
  Bb as instanceOfProgrammaticScryptoSborValueI64AllOf,
  Gd as instanceOfProgrammaticScryptoSborValueI8,
  Wb as instanceOfProgrammaticScryptoSborValueI8AllOf,
  zd as instanceOfProgrammaticScryptoSborValueMap,
  Qb as instanceOfProgrammaticScryptoSborValueMapAllOf,
  $d as instanceOfProgrammaticScryptoSborValueMapEntry,
  Qd as instanceOfProgrammaticScryptoSborValueNonFungibleLocalId,
  tN as instanceOfProgrammaticScryptoSborValueNonFungibleLocalIdAllOf,
  ef as instanceOfProgrammaticScryptoSborValueOwn,
  aN as instanceOfProgrammaticScryptoSborValueOwnAllOf,
  rf as instanceOfProgrammaticScryptoSborValuePreciseDecimal,
  sN as instanceOfProgrammaticScryptoSborValuePreciseDecimalAllOf,
  uf as instanceOfProgrammaticScryptoSborValueReference,
  _N as instanceOfProgrammaticScryptoSborValueReferenceAllOf,
  cf as instanceOfProgrammaticScryptoSborValueString,
  gN as instanceOfProgrammaticScryptoSborValueStringAllOf,
  _f as instanceOfProgrammaticScryptoSborValueTuple,
  NN as instanceOfProgrammaticScryptoSborValueTupleAllOf,
  pf as instanceOfProgrammaticScryptoSborValueU128,
  IN as instanceOfProgrammaticScryptoSborValueU128AllOf,
  Of as instanceOfProgrammaticScryptoSborValueU16,
  VN as instanceOfProgrammaticScryptoSborValueU16AllOf,
  Ff as instanceOfProgrammaticScryptoSborValueU32,
  DN as instanceOfProgrammaticScryptoSborValueU32AllOf,
  If as instanceOfProgrammaticScryptoSborValueU64,
  xN as instanceOfProgrammaticScryptoSborValueU64AllOf,
  vf as instanceOfProgrammaticScryptoSborValueU8,
  KN as instanceOfProgrammaticScryptoSborValueU8AllOf,
  $N as instanceOfPublicKeyBase,
  z_ as instanceOfPublicKeyEcdsaSecp256k1,
  ZN as instanceOfPublicKeyEcdsaSecp256k1AllOf,
  Q_ as instanceOfPublicKeyEddsaEd25519,
  e0 as instanceOfPublicKeyEddsaEd25519AllOf,
  a0 as instanceOfPublicKeyHashBase,
  rm as instanceOfPublicKeyHashEcdsaSecp256k1,
  s0 as instanceOfPublicKeyHashEcdsaSecp256k1AllOf,
  om as instanceOfPublicKeyHashEddsaEd25519,
  _0 as instanceOfPublicKeyHashEddsaEd25519AllOf,
  p0 as instanceOfResultSetCursorMixin,
  Uf as instanceOfRoleKey,
  O0 as instanceOfScryptoSborValue,
  b0 as instanceOfStateEntityDetailsOptIns,
  N0 as instanceOfStateEntityDetailsRequest,
  h0 as instanceOfStateEntityDetailsRequestAllOf,
  Q0 as instanceOfStateEntityDetailsResponse,
  j0 as instanceOfStateEntityDetailsResponseAllOf,
  v0 as instanceOfStateEntityDetailsResponseComponentDetails,
  rF as instanceOfStateEntityDetailsResponseComponentDetailsAllOf,
  k0 as instanceOfStateEntityDetailsResponseFungibleResourceDetails,
  uF as instanceOfStateEntityDetailsResponseFungibleResourceDetailsAllOf,
  P0 as instanceOfStateEntityDetailsResponseFungibleVaultDetails,
  dF as instanceOfStateEntityDetailsResponseFungibleVaultDetailsAllOf,
  Z0 as instanceOfStateEntityDetailsResponseItem,
  T0 as instanceOfStateEntityDetailsResponseItemAncestorIdentities,
  pF as instanceOfStateEntityDetailsResponseItemDetailsBase,
  x0 as instanceOfStateEntityDetailsResponseNonFungibleResourceDetails,
  bF as instanceOfStateEntityDetailsResponseNonFungibleResourceDetailsAllOf,
  U0 as instanceOfStateEntityDetailsResponseNonFungibleVaultDetails,
  AF as instanceOfStateEntityDetailsResponseNonFungibleVaultDetailsAllOf,
  z0 as instanceOfStateEntityDetailsResponsePackageDetails,
  vF as instanceOfStateEntityDetailsResponsePackageDetailsAllOf,
  B0 as instanceOfStateEntityDetailsResponsePackageDetailsBlueprintCollection,
  kF as instanceOfStateEntityDetailsResponsePackageDetailsBlueprintCollectionAllOf,
  L0 as instanceOfStateEntityDetailsResponsePackageDetailsBlueprintItem,
  G0 as instanceOfStateEntityDetailsResponsePackageDetailsCodeCollection,
  PF as instanceOfStateEntityDetailsResponsePackageDetailsCodeCollectionAllOf,
  $0 as instanceOfStateEntityDetailsResponsePackageDetailsSchemaCollection,
  xF as instanceOfStateEntityDetailsResponsePackageDetailsSchemaCollectionAllOf,
  H0 as instanceOfStateEntityDetailsResponsePackageDetailsSchemaItem,
  UF as instanceOfStateEntityFungibleResourceVaultsPageRequest,
  LF as instanceOfStateEntityFungibleResourceVaultsPageRequestAllOf,
  HF as instanceOfStateEntityFungibleResourceVaultsPageResponse,
  zF as instanceOfStateEntityFungiblesPageRequest,
  ZF as instanceOfStateEntityFungiblesPageRequestAllOf,
  WF as instanceOfStateEntityFungiblesPageRequestOptIns,
  jF as instanceOfStateEntityFungiblesPageResponse,
  th as instanceOfStateEntityMetadataPageRequest,
  rh as instanceOfStateEntityMetadataPageRequestAllOf,
  oh as instanceOfStateEntityMetadataPageResponse,
  lh as instanceOfStateEntityNonFungibleIdsPageRequest,
  ch as instanceOfStateEntityNonFungibleIdsPageRequestAllOf,
  _h as instanceOfStateEntityNonFungibleIdsPageResponse,
  yh as instanceOfStateEntityNonFungibleResourceVaultsPageOptIns,
  ph as instanceOfStateEntityNonFungibleResourceVaultsPageRequest,
  Sh as instanceOfStateEntityNonFungibleResourceVaultsPageRequestAllOf,
  Nh as instanceOfStateEntityNonFungibleResourceVaultsPageResponse,
  Ah as instanceOfStateEntityNonFungiblesPageRequest,
  Th as instanceOfStateEntityNonFungiblesPageRequestAllOf,
  hh as instanceOfStateEntityNonFungiblesPageRequestOptIns,
  Vh as instanceOfStateEntityNonFungiblesPageResponse,
  Eh as instanceOfStateKeyValueStoreDataRequest,
  Ph as instanceOfStateKeyValueStoreDataRequestAllOf,
  kh as instanceOfStateKeyValueStoreDataRequestKeyItem,
  Ch as instanceOfStateKeyValueStoreDataResponse,
  Uh as instanceOfStateKeyValueStoreDataResponseAllOf,
  xh as instanceOfStateKeyValueStoreDataResponseItem,
  Bh as instanceOfStateNonFungibleDataRequest,
  $h as instanceOfStateNonFungibleDataResponse,
  zh as instanceOfStateNonFungibleDataResponseAllOf,
  Hh as instanceOfStateNonFungibleDetailsResponseItem,
  Qh as instanceOfStateNonFungibleIdsRequest,
  jh as instanceOfStateNonFungibleIdsRequestAllOf,
  nA as instanceOfStateNonFungibleIdsResponse,
  iA as instanceOfStateNonFungibleIdsResponseAllOf,
  uA as instanceOfStateNonFungibleLocationRequest,
  sA as instanceOfStateNonFungibleLocationRequestAllOf,
  _A as instanceOfStateNonFungibleLocationResponse,
  yA as instanceOfStateNonFungibleLocationResponseAllOf,
  fA as instanceOfStateNonFungibleLocationResponseItem,
  SA as instanceOfStateValidatorsListRequest,
  bA as instanceOfStateValidatorsListRequestAllOf,
  RA as instanceOfStateValidatorsListResponse,
  EA as instanceOfStateValidatorsListResponseAllOf,
  UA as instanceOfStreamTransactionsRequest,
  GA as instanceOfStreamTransactionsRequestAllOf,
  MA as instanceOfStreamTransactionsRequestEventFilterItem,
  WA as instanceOfStreamTransactionsResponse,
  XA as instanceOfStreamTransactionsResponseAllOf,
  _d as instanceOfTransactionBalanceChanges,
  YA as instanceOfTransactionCommittedDetailsRequest,
  eI as instanceOfTransactionCommittedDetailsRequestAllOf,
  rI as instanceOfTransactionCommittedDetailsResponse,
  aI as instanceOfTransactionCommittedDetailsResponseAllOf,
  lI as instanceOfTransactionConstructionResponse,
  xA as instanceOfTransactionDetailsOptIns,
  ld as instanceOfTransactionFungibleBalanceChanges,
  dd as instanceOfTransactionFungibleFeeBalanceChanges,
  fd as instanceOfTransactionNonFungibleBalanceChanges,
  Ty as instanceOfTransactionNotFoundError,
  _I as instanceOfTransactionNotFoundErrorAllOf,
  NI as instanceOfTransactionPreviewRequest,
  bI as instanceOfTransactionPreviewRequestFlags,
  AI as instanceOfTransactionPreviewResponse,
  hI as instanceOfTransactionPreviewResponseLogsInner,
  Df as instanceOfTransactionReceipt,
  TI as instanceOfTransactionStatusRequest,
  vI as instanceOfTransactionStatusRequestAllOf,
  EI as instanceOfTransactionStatusResponse,
  PI as instanceOfTransactionStatusResponseAllOf,
  kI as instanceOfTransactionStatusResponseKnownPayloadItem,
  xI as instanceOfTransactionSubmitRequest,
  qI as instanceOfTransactionSubmitResponse,
  yy as instanceOfValidationErrorsAtPath,
  VA as instanceOfValidatorCollection,
  KI as instanceOfValidatorCollectionAllOf,
  vA as instanceOfValidatorCollectionItem,
  hA as instanceOfValidatorCollectionItemActiveInEpoch,
  TA as instanceOfValidatorCollectionItemEffectiveFeeFactor,
  AA as instanceOfValidatorCollectionItemEffectiveFeeFactorCurrent,
  IA as instanceOfValidatorCollectionItemEffectiveFeeFactorPending,
  HI as instanceOfValidatorUptimeCollection,
  GI as instanceOfValidatorUptimeCollectionItem,
  JA as instanceOfValidatorVaultItem,
  $I as instanceOfValidatorsUptimeRequest,
  zI as instanceOfValidatorsUptimeRequestAllOf,
  QI as instanceOfValidatorsUptimeResponse,
  jI as instanceOfValidatorsUptimeResponseAllOf,
  jc as mapValues,
  me as querystring
};
